function attributeToString(t) {
  return (
    "string" != typeof t && ((t += ""), "undefined" === t && (t = "")),
    jQuery.trim(t)
  );
}
(function () {
  function t(t) {
    function e(e, i, n, o, s, r) {
      for (; s >= 0 && r > s; s += t) {
        var a = o ? o[s] : s;
        n = i(n, e[a], a, e);
      }
      return n;
    }
    return function (i, n, o, s) {
      n = k(n, s, 4);
      var r = !C(i) && y.keys(i),
        a = (r || i).length,
        l = t > 0 ? 0 : a - 1;
      return (
        arguments.length < 3 && ((o = i[r ? r[l] : l]), (l += t)),
        e(i, n, o, r, l, a)
      );
    };
  }
  function e(t) {
    return function (e, i, n) {
      i = w(i, n);
      for (var o = E(e), s = t > 0 ? 0 : o - 1; s >= 0 && o > s; s += t)
        if (i(e[s], s, e)) return s;
      return -1;
    };
  }
  function i(t, e, i) {
    return function (n, o, s) {
      var r = 0,
        a = E(n);
      if ("number" == typeof s)
        t > 0
          ? (r = s >= 0 ? s : Math.max(s + a, r))
          : (a = s >= 0 ? Math.min(s + 1, a) : s + a + 1);
      else if (i && s && a) return (s = i(n, o)), n[s] === o ? s : -1;
      if (o !== o)
        return (s = e(u.call(n, r, a), y.isNaN)), s >= 0 ? s + r : -1;
      for (s = t > 0 ? r : a - 1; s >= 0 && a > s; s += t)
        if (n[s] === o) return s;
      return -1;
    };
  }
  function n(t, e) {
    var i = A.length,
      n = t.constructor,
      o = (y.isFunction(n) && n.prototype) || a,
      s = "constructor";
    for (y.has(t, s) && !y.contains(e, s) && e.push(s); i--; )
      (s = A[i]), s in t && t[s] !== o[s] && !y.contains(e, s) && e.push(s);
  }
  var o = this,
    s = o._,
    r = Array.prototype,
    a = Object.prototype,
    l = Function.prototype,
    c = r.push,
    u = r.slice,
    h = a.toString,
    p = a.hasOwnProperty,
    d = Array.isArray,
    f = Object.keys,
    m = l.bind,
    g = Object.create,
    v = function () {},
    y = function (t) {
      return t instanceof y
        ? t
        : this instanceof y
        ? void (this._wrapped = t)
        : new y(t);
    };
  "undefined" != typeof exports
    ? ("undefined" != typeof module &&
        module.exports &&
        (exports = module.exports = y),
      (exports._ = y))
    : (o._ = y),
    (y.VERSION = "1.8.3");
  var k = function (t, e, i) {
      if (void 0 === e) return t;
      switch (null == i ? 3 : i) {
        case 1:
          return function (i) {
            return t.call(e, i);
          };
        case 2:
          return function (i, n) {
            return t.call(e, i, n);
          };
        case 3:
          return function (i, n, o) {
            return t.call(e, i, n, o);
          };
        case 4:
          return function (i, n, o, s) {
            return t.call(e, i, n, o, s);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    },
    w = function (t, e, i) {
      return null == t
        ? y.identity
        : y.isFunction(t)
        ? k(t, e, i)
        : y.isObject(t)
        ? y.matcher(t)
        : y.property(t);
    };
  y.iteratee = function (t, e) {
    return w(t, e, 1 / 0);
  };
  var b = function (t, e) {
      return function (i) {
        var n = arguments.length;
        if (2 > n || null == i) return i;
        for (var o = 1; n > o; o++)
          for (
            var s = arguments[o], r = t(s), a = r.length, l = 0;
            a > l;
            l++
          ) {
            var c = r[l];
            (e && void 0 !== i[c]) || (i[c] = s[c]);
          }
        return i;
      };
    },
    S = function (t) {
      if (!y.isObject(t)) return {};
      if (g) return g(t);
      v.prototype = t;
      var e = new v();
      return (v.prototype = null), e;
    },
    x = function (t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    },
    T = Math.pow(2, 53) - 1,
    E = x("length"),
    C = function (t) {
      var e = E(t);
      return "number" == typeof e && e >= 0 && T >= e;
    };
  (y.each = y.forEach =
    function (t, e, i) {
      e = k(e, i);
      var n, o;
      if (C(t)) for (n = 0, o = t.length; o > n; n++) e(t[n], n, t);
      else {
        var s = y.keys(t);
        for (n = 0, o = s.length; o > n; n++) e(t[s[n]], s[n], t);
      }
      return t;
    }),
    (y.map = y.collect =
      function (t, e, i) {
        e = w(e, i);
        for (
          var n = !C(t) && y.keys(t), o = (n || t).length, s = Array(o), r = 0;
          o > r;
          r++
        ) {
          var a = n ? n[r] : r;
          s[r] = e(t[a], a, t);
        }
        return s;
      }),
    (y.reduce = y.foldl = y.inject = t(1)),
    (y.reduceRight = y.foldr = t(-1)),
    (y.find = y.detect =
      function (t, e, i) {
        var n;
        return (
          (n = C(t) ? y.findIndex(t, e, i) : y.findKey(t, e, i)),
          void 0 !== n && -1 !== n ? t[n] : void 0
        );
      }),
    (y.filter = y.select =
      function (t, e, i) {
        var n = [];
        return (
          (e = w(e, i)),
          y.each(t, function (t, i, o) {
            e(t, i, o) && n.push(t);
          }),
          n
        );
      }),
    (y.reject = function (t, e, i) {
      return y.filter(t, y.negate(w(e)), i);
    }),
    (y.every = y.all =
      function (t, e, i) {
        e = w(e, i);
        for (
          var n = !C(t) && y.keys(t), o = (n || t).length, s = 0;
          o > s;
          s++
        ) {
          var r = n ? n[s] : s;
          if (!e(t[r], r, t)) return !1;
        }
        return !0;
      }),
    (y.some = y.any =
      function (t, e, i) {
        e = w(e, i);
        for (
          var n = !C(t) && y.keys(t), o = (n || t).length, s = 0;
          o > s;
          s++
        ) {
          var r = n ? n[s] : s;
          if (e(t[r], r, t)) return !0;
        }
        return !1;
      }),
    (y.contains =
      y.includes =
      y.include =
        function (t, e, i, n) {
          return (
            C(t) || (t = y.values(t)),
            ("number" != typeof i || n) && (i = 0),
            y.indexOf(t, e, i) >= 0
          );
        }),
    (y.invoke = function (t, e) {
      var i = u.call(arguments, 2),
        n = y.isFunction(e);
      return y.map(t, function (t) {
        var o = n ? e : t[e];
        return null == o ? o : o.apply(t, i);
      });
    }),
    (y.pluck = function (t, e) {
      return y.map(t, y.property(e));
    }),
    (y.where = function (t, e) {
      return y.filter(t, y.matcher(e));
    }),
    (y.findWhere = function (t, e) {
      return y.find(t, y.matcher(e));
    }),
    (y.max = function (t, e, i) {
      var n,
        o,
        s = -1 / 0,
        r = -1 / 0;
      if (null == e && null != t) {
        t = C(t) ? t : y.values(t);
        for (var a = 0, l = t.length; l > a; a++) (n = t[a]), n > s && (s = n);
      } else
        (e = w(e, i)),
          y.each(t, function (t, i, n) {
            (o = e(t, i, n)),
              (o > r || (o === -1 / 0 && s === -1 / 0)) && ((s = t), (r = o));
          });
      return s;
    }),
    (y.min = function (t, e, i) {
      var n,
        o,
        s = 1 / 0,
        r = 1 / 0;
      if (null == e && null != t) {
        t = C(t) ? t : y.values(t);
        for (var a = 0, l = t.length; l > a; a++) (n = t[a]), s > n && (s = n);
      } else
        (e = w(e, i)),
          y.each(t, function (t, i, n) {
            (o = e(t, i, n)),
              (r > o || (1 / 0 === o && 1 / 0 === s)) && ((s = t), (r = o));
          });
      return s;
    }),
    (y.shuffle = function (t) {
      for (
        var e, i = C(t) ? t : y.values(t), n = i.length, o = Array(n), s = 0;
        n > s;
        s++
      )
        (e = y.random(0, s)), e !== s && (o[s] = o[e]), (o[e] = i[s]);
      return o;
    }),
    (y.sample = function (t, e, i) {
      return null == e || i
        ? (C(t) || (t = y.values(t)), t[y.random(t.length - 1)])
        : y.shuffle(t).slice(0, Math.max(0, e));
    }),
    (y.sortBy = function (t, e, i) {
      return (
        (e = w(e, i)),
        y.pluck(
          y
            .map(t, function (t, i, n) {
              return { value: t, index: i, criteria: e(t, i, n) };
            })
            .sort(function (t, e) {
              var i = t.criteria,
                n = e.criteria;
              if (i !== n) {
                if (i > n || void 0 === i) return 1;
                if (n > i || void 0 === n) return -1;
              }
              return t.index - e.index;
            }),
          "value"
        )
      );
    });
  var $ = function (t) {
    return function (e, i, n) {
      var o = {};
      return (
        (i = w(i, n)),
        y.each(e, function (n, s) {
          var r = i(n, s, e);
          t(o, n, r);
        }),
        o
      );
    };
  };
  (y.groupBy = $(function (t, e, i) {
    y.has(t, i) ? t[i].push(e) : (t[i] = [e]);
  })),
    (y.indexBy = $(function (t, e, i) {
      t[i] = e;
    })),
    (y.countBy = $(function (t, e, i) {
      y.has(t, i) ? t[i]++ : (t[i] = 1);
    })),
    (y.toArray = function (t) {
      return t
        ? y.isArray(t)
          ? u.call(t)
          : C(t)
          ? y.map(t, y.identity)
          : y.values(t)
        : [];
    }),
    (y.size = function (t) {
      return null == t ? 0 : C(t) ? t.length : y.keys(t).length;
    }),
    (y.partition = function (t, e, i) {
      e = w(e, i);
      var n = [],
        o = [];
      return (
        y.each(t, function (t, i, s) {
          (e(t, i, s) ? n : o).push(t);
        }),
        [n, o]
      );
    }),
    (y.first =
      y.head =
      y.take =
        function (t, e, i) {
          return null == t
            ? void 0
            : null == e || i
            ? t[0]
            : y.initial(t, t.length - e);
        }),
    (y.initial = function (t, e, i) {
      return u.call(t, 0, Math.max(0, t.length - (null == e || i ? 1 : e)));
    }),
    (y.last = function (t, e, i) {
      return null == t
        ? void 0
        : null == e || i
        ? t[t.length - 1]
        : y.rest(t, Math.max(0, t.length - e));
    }),
    (y.rest =
      y.tail =
      y.drop =
        function (t, e, i) {
          return u.call(t, null == e || i ? 1 : e);
        }),
    (y.compact = function (t) {
      return y.filter(t, y.identity);
    });
  var _ = function (t, e, i, n) {
    for (var o = [], s = 0, r = n || 0, a = E(t); a > r; r++) {
      var l = t[r];
      if (C(l) && (y.isArray(l) || y.isArguments(l))) {
        e || (l = _(l, e, i));
        var c = 0,
          u = l.length;
        for (o.length += u; u > c; ) o[s++] = l[c++];
      } else i || (o[s++] = l);
    }
    return o;
  };
  (y.flatten = function (t, e) {
    return _(t, e, !1);
  }),
    (y.without = function (t) {
      return y.difference(t, u.call(arguments, 1));
    }),
    (y.uniq = y.unique =
      function (t, e, i, n) {
        y.isBoolean(e) || ((n = i), (i = e), (e = !1)),
          null != i && (i = w(i, n));
        for (var o = [], s = [], r = 0, a = E(t); a > r; r++) {
          var l = t[r],
            c = i ? i(l, r, t) : l;
          e
            ? ((r && s === c) || o.push(l), (s = c))
            : i
            ? y.contains(s, c) || (s.push(c), o.push(l))
            : y.contains(o, l) || o.push(l);
        }
        return o;
      }),
    (y.union = function () {
      return y.uniq(_(arguments, !0, !0));
    }),
    (y.intersection = function (t) {
      for (var e = [], i = arguments.length, n = 0, o = E(t); o > n; n++) {
        var s = t[n];
        if (!y.contains(e, s)) {
          for (var r = 1; i > r && y.contains(arguments[r], s); r++);
          r === i && e.push(s);
        }
      }
      return e;
    }),
    (y.difference = function (t) {
      var e = _(arguments, !0, !0, 1);
      return y.filter(t, function (t) {
        return !y.contains(e, t);
      });
    }),
    (y.zip = function () {
      return y.unzip(arguments);
    }),
    (y.unzip = function (t) {
      for (
        var e = (t && y.max(t, E).length) || 0, i = Array(e), n = 0;
        e > n;
        n++
      )
        i[n] = y.pluck(t, n);
      return i;
    }),
    (y.object = function (t, e) {
      for (var i = {}, n = 0, o = E(t); o > n; n++)
        e ? (i[t[n]] = e[n]) : (i[t[n][0]] = t[n][1]);
      return i;
    }),
    (y.findIndex = e(1)),
    (y.findLastIndex = e(-1)),
    (y.sortedIndex = function (t, e, i, n) {
      i = w(i, n, 1);
      for (var o = i(e), s = 0, r = E(t); r > s; ) {
        var a = Math.floor((s + r) / 2);
        i(t[a]) < o ? (s = a + 1) : (r = a);
      }
      return s;
    }),
    (y.indexOf = i(1, y.findIndex, y.sortedIndex)),
    (y.lastIndexOf = i(-1, y.findLastIndex)),
    (y.range = function (t, e, i) {
      null == e && ((e = t || 0), (t = 0)), (i = i || 1);
      for (
        var n = Math.max(Math.ceil((e - t) / i), 0), o = Array(n), s = 0;
        n > s;
        s++, t += i
      )
        o[s] = t;
      return o;
    });
  var I = function (t, e, i, n, o) {
    if (!(n instanceof e)) return t.apply(i, o);
    var s = S(t.prototype),
      r = t.apply(s, o);
    return y.isObject(r) ? r : s;
  };
  (y.bind = function (t, e) {
    if (m && t.bind === m) return m.apply(t, u.call(arguments, 1));
    if (!y.isFunction(t))
      throw new TypeError("Bind must be called on a function");
    var i = u.call(arguments, 2),
      n = function () {
        return I(t, n, e, this, i.concat(u.call(arguments)));
      };
    return n;
  }),
    (y.partial = function (t) {
      var e = u.call(arguments, 1),
        i = function () {
          for (var n = 0, o = e.length, s = Array(o), r = 0; o > r; r++)
            s[r] = e[r] === y ? arguments[n++] : e[r];
          for (; n < arguments.length; ) s.push(arguments[n++]);
          return I(t, i, this, this, s);
        };
      return i;
    }),
    (y.bindAll = function (t) {
      var e,
        i,
        n = arguments.length;
      if (1 >= n) throw new Error("bindAll must be passed function names");
      for (e = 1; n > e; e++) (i = arguments[e]), (t[i] = y.bind(t[i], t));
      return t;
    }),
    (y.memoize = function (t, e) {
      var i = function (n) {
        var o = i.cache,
          s = "" + (e ? e.apply(this, arguments) : n);
        return y.has(o, s) || (o[s] = t.apply(this, arguments)), o[s];
      };
      return (i.cache = {}), i;
    }),
    (y.delay = function (t, e) {
      var i = u.call(arguments, 2);
      return setTimeout(function () {
        return t.apply(null, i);
      }, e);
    }),
    (y.defer = y.partial(y.delay, y, 1)),
    (y.throttle = function (t, e, i) {
      var n,
        o,
        s,
        r = null,
        a = 0;
      i || (i = {});
      var l = function () {
        (a = i.leading === !1 ? 0 : y.now()),
          (r = null),
          (s = t.apply(n, o)),
          r || (n = o = null);
      };
      return function () {
        var c = y.now();
        a || i.leading !== !1 || (a = c);
        var u = e - (c - a);
        return (
          (n = this),
          (o = arguments),
          0 >= u || u > e
            ? (r && (clearTimeout(r), (r = null)),
              (a = c),
              (s = t.apply(n, o)),
              r || (n = o = null))
            : r || i.trailing === !1 || (r = setTimeout(l, u)),
          s
        );
      };
    }),
    (y.debounce = function (t, e, i) {
      var n,
        o,
        s,
        r,
        a,
        l = function () {
          var c = y.now() - r;
          e > c && c >= 0
            ? (n = setTimeout(l, e - c))
            : ((n = null), i || ((a = t.apply(s, o)), n || (s = o = null)));
        };
      return function () {
        (s = this), (o = arguments), (r = y.now());
        var c = i && !n;
        return (
          n || (n = setTimeout(l, e)),
          c && ((a = t.apply(s, o)), (s = o = null)),
          a
        );
      };
    }),
    (y.wrap = function (t, e) {
      return y.partial(e, t);
    }),
    (y.negate = function (t) {
      return function () {
        return !t.apply(this, arguments);
      };
    }),
    (y.compose = function () {
      var t = arguments,
        e = t.length - 1;
      return function () {
        for (var i = e, n = t[e].apply(this, arguments); i--; )
          n = t[i].call(this, n);
        return n;
      };
    }),
    (y.after = function (t, e) {
      return function () {
        return --t < 1 ? e.apply(this, arguments) : void 0;
      };
    }),
    (y.before = function (t, e) {
      var i;
      return function () {
        return (
          --t > 0 && (i = e.apply(this, arguments)), 1 >= t && (e = null), i
        );
      };
    }),
    (y.once = y.partial(y.before, 2));
  var P = !{ toString: null }.propertyIsEnumerable("toString"),
    A = [
      "valueOf",
      "isPrototypeOf",
      "toString",
      "propertyIsEnumerable",
      "hasOwnProperty",
      "toLocaleString",
    ];
  (y.keys = function (t) {
    if (!y.isObject(t)) return [];
    if (f) return f(t);
    var e = [];
    for (var i in t) y.has(t, i) && e.push(i);
    return P && n(t, e), e;
  }),
    (y.allKeys = function (t) {
      if (!y.isObject(t)) return [];
      var e = [];
      for (var i in t) e.push(i);
      return P && n(t, e), e;
    }),
    (y.values = function (t) {
      for (var e = y.keys(t), i = e.length, n = Array(i), o = 0; i > o; o++)
        n[o] = t[e[o]];
      return n;
    }),
    (y.mapObject = function (t, e, i) {
      e = w(e, i);
      for (var n, o = y.keys(t), s = o.length, r = {}, a = 0; s > a; a++)
        (n = o[a]), (r[n] = e(t[n], n, t));
      return r;
    }),
    (y.pairs = function (t) {
      for (var e = y.keys(t), i = e.length, n = Array(i), o = 0; i > o; o++)
        n[o] = [e[o], t[e[o]]];
      return n;
    }),
    (y.invert = function (t) {
      for (var e = {}, i = y.keys(t), n = 0, o = i.length; o > n; n++)
        e[t[i[n]]] = i[n];
      return e;
    }),
    (y.functions = y.methods =
      function (t) {
        var e = [];
        for (var i in t) y.isFunction(t[i]) && e.push(i);
        return e.sort();
      }),
    (y.extend = b(y.allKeys)),
    (y.extendOwn = y.assign = b(y.keys)),
    (y.findKey = function (t, e, i) {
      e = w(e, i);
      for (var n, o = y.keys(t), s = 0, r = o.length; r > s; s++)
        if (((n = o[s]), e(t[n], n, t))) return n;
    }),
    (y.pick = function (t, e, i) {
      var n,
        o,
        s = {},
        r = t;
      if (null == r) return s;
      y.isFunction(e)
        ? ((o = y.allKeys(r)), (n = k(e, i)))
        : ((o = _(arguments, !1, !1, 1)),
          (n = function (t, e, i) {
            return e in i;
          }),
          (r = Object(r)));
      for (var a = 0, l = o.length; l > a; a++) {
        var c = o[a],
          u = r[c];
        n(u, c, r) && (s[c] = u);
      }
      return s;
    }),
    (y.omit = function (t, e, i) {
      if (y.isFunction(e)) e = y.negate(e);
      else {
        var n = y.map(_(arguments, !1, !1, 1), String);
        e = function (t, e) {
          return !y.contains(n, e);
        };
      }
      return y.pick(t, e, i);
    }),
    (y.defaults = b(y.allKeys, !0)),
    (y.create = function (t, e) {
      var i = S(t);
      return e && y.extendOwn(i, e), i;
    }),
    (y.clone = function (t) {
      return y.isObject(t) ? (y.isArray(t) ? t.slice() : y.extend({}, t)) : t;
    }),
    (y.tap = function (t, e) {
      return e(t), t;
    }),
    (y.isMatch = function (t, e) {
      var i = y.keys(e),
        n = i.length;
      if (null == t) return !n;
      for (var o = Object(t), s = 0; n > s; s++) {
        var r = i[s];
        if (e[r] !== o[r] || !(r in o)) return !1;
      }
      return !0;
    });
  var O = function (t, e, i, n) {
    if (t === e) return 0 !== t || 1 / t === 1 / e;
    if (null == t || null == e) return t === e;
    t instanceof y && (t = t._wrapped), e instanceof y && (e = e._wrapped);
    var o = h.call(t);
    if (o !== h.call(e)) return !1;
    switch (o) {
      case "[object RegExp]":
      case "[object String]":
        return "" + t == "" + e;
      case "[object Number]":
        return +t !== +t ? +e !== +e : 0 === +t ? 1 / +t === 1 / e : +t === +e;
      case "[object Date]":
      case "[object Boolean]":
        return +t === +e;
    }
    var s = "[object Array]" === o;
    if (!s) {
      if ("object" != typeof t || "object" != typeof e) return !1;
      var r = t.constructor,
        a = e.constructor;
      if (
        r !== a &&
        !(
          y.isFunction(r) &&
          r instanceof r &&
          y.isFunction(a) &&
          a instanceof a
        ) &&
        "constructor" in t &&
        "constructor" in e
      )
        return !1;
    }
    (i = i || []), (n = n || []);
    for (var l = i.length; l--; ) if (i[l] === t) return n[l] === e;
    if ((i.push(t), n.push(e), s)) {
      if (((l = t.length), l !== e.length)) return !1;
      for (; l--; ) if (!O(t[l], e[l], i, n)) return !1;
    } else {
      var c,
        u = y.keys(t);
      if (((l = u.length), y.keys(e).length !== l)) return !1;
      for (; l--; )
        if (((c = u[l]), !y.has(e, c) || !O(t[c], e[c], i, n))) return !1;
    }
    return i.pop(), n.pop(), !0;
  };
  (y.isEqual = function (t, e) {
    return O(t, e);
  }),
    (y.isEmpty = function (t) {
      return null == t
        ? !0
        : C(t) && (y.isArray(t) || y.isString(t) || y.isArguments(t))
        ? 0 === t.length
        : 0 === y.keys(t).length;
    }),
    (y.isElement = function (t) {
      return !(!t || 1 !== t.nodeType);
    }),
    (y.isArray =
      d ||
      function (t) {
        return "[object Array]" === h.call(t);
      }),
    (y.isObject = function (t) {
      var e = typeof t;
      return "function" === e || ("object" === e && !!t);
    }),
    y.each(
      ["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error"],
      function (t) {
        y["is" + t] = function (e) {
          return h.call(e) === "[object " + t + "]";
        };
      }
    ),
    y.isArguments(arguments) ||
      (y.isArguments = function (t) {
        return y.has(t, "callee");
      }),
    "function" != typeof /./ &&
      "object" != typeof Int8Array &&
      (y.isFunction = function (t) {
        return "function" == typeof t || !1;
      }),
    (y.isFinite = function (t) {
      return isFinite(t) && !isNaN(parseFloat(t));
    }),
    (y.isNaN = function (t) {
      return y.isNumber(t) && t !== +t;
    }),
    (y.isBoolean = function (t) {
      return t === !0 || t === !1 || "[object Boolean]" === h.call(t);
    }),
    (y.isNull = function (t) {
      return null === t;
    }),
    (y.isUndefined = function (t) {
      return void 0 === t;
    }),
    (y.has = function (t, e) {
      return null != t && p.call(t, e);
    }),
    (y.noConflict = function () {
      return (o._ = s), this;
    }),
    (y.identity = function (t) {
      return t;
    }),
    (y.constant = function (t) {
      return function () {
        return t;
      };
    }),
    (y.noop = function () {}),
    (y.property = x),
    (y.propertyOf = function (t) {
      return null == t
        ? function () {}
        : function (e) {
            return t[e];
          };
    }),
    (y.matcher = y.matches =
      function (t) {
        return (
          (t = y.extendOwn({}, t)),
          function (e) {
            return y.isMatch(e, t);
          }
        );
      }),
    (y.times = function (t, e, i) {
      var n = Array(Math.max(0, t));
      e = k(e, i, 1);
      for (var o = 0; t > o; o++) n[o] = e(o);
      return n;
    }),
    (y.random = function (t, e) {
      return (
        null == e && ((e = t), (t = 0)),
        t + Math.floor(Math.random() * (e - t + 1))
      );
    }),
    (y.now =
      Date.now ||
      function () {
        return new Date().getTime();
      });
  var N = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#x27;",
      "`": "&#x60;",
    },
    j = y.invert(N),
    L = function (t) {
      var e = function (e) {
          return t[e];
        },
        i = "(?:" + y.keys(t).join("|") + ")",
        n = RegExp(i),
        o = RegExp(i, "g");
      return function (t) {
        return (t = null == t ? "" : "" + t), n.test(t) ? t.replace(o, e) : t;
      };
    };
  (y.escape = L(N)),
    (y.unescape = L(j)),
    (y.result = function (t, e, i) {
      var n = null == t ? void 0 : t[e];
      return void 0 === n && (n = i), y.isFunction(n) ? n.call(t) : n;
    });
  var M = 0;
  (y.uniqueId = function (t) {
    var e = ++M + "";
    return t ? t + e : e;
  }),
    (y.templateSettings = {
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: /<%=([\s\S]+?)%>/g,
      escape: /<%-([\s\S]+?)%>/g,
    });
  var H = /(.)^/,
    z = {
      "'": "'",
      "\\": "\\",
      "\r": "r",
      "\n": "n",
      "\u2028": "u2028",
      "\u2029": "u2029",
    },
    W = /\\|'|\r|\n|\u2028|\u2029/g,
    R = function (t) {
      return "\\" + z[t];
    };
  (y.template = function (t, e, i) {
    !e && i && (e = i), (e = y.defaults({}, e, y.templateSettings));
    var n = RegExp(
        [
          (e.escape || H).source,
          (e.interpolate || H).source,
          (e.evaluate || H).source,
        ].join("|") + "|$",
        "g"
      ),
      o = 0,
      s = "__p+='";
    t.replace(n, function (e, i, n, r, a) {
      return (
        (s += t.slice(o, a).replace(W, R)),
        (o = a + e.length),
        i
          ? (s += "'+\n((__t=(" + i + "))==null?'':_.escape(__t))+\n'")
          : n
          ? (s += "'+\n((__t=(" + n + "))==null?'':__t)+\n'")
          : r && (s += "';\n" + r + "\n__p+='"),
        e
      );
    }),
      (s += "';\n"),
      e.variable || (s = "with(obj||{}){\n" + s + "}\n"),
      (s =
        "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" +
        s +
        "return __p;\n");
    try {
      var r = new Function(e.variable || "obj", "_", s);
    } catch (a) {
      throw ((a.source = s), a);
    }
    var l = function (t) {
        return r.call(this, t, y);
      },
      c = e.variable || "obj";
    return (l.source = "function(" + c + "){\n" + s + "}"), l;
  }),
    (y.chain = function (t) {
      var e = y(t);
      return (e._chain = !0), e;
    });
  var D = function (t, e) {
    return t._chain ? y(e).chain() : e;
  };
  (y.mixin = function (t) {
    y.each(y.functions(t), function (e) {
      var i = (y[e] = t[e]);
      y.prototype[e] = function () {
        var t = [this._wrapped];
        return c.apply(t, arguments), D(this, i.apply(y, t));
      };
    });
  }),
    y.mixin(y),
    y.each(
      ["pop", "push", "reverse", "shift", "sort", "splice", "unshift"],
      function (t) {
        var e = r[t];
        y.prototype[t] = function () {
          var i = this._wrapped;
          return (
            e.apply(i, arguments),
            ("shift" !== t && "splice" !== t) || 0 !== i.length || delete i[0],
            D(this, i)
          );
        };
      }
    ),
    y.each(["concat", "join", "slice"], function (t) {
      var e = r[t];
      y.prototype[t] = function () {
        return D(this, e.apply(this._wrapped, arguments));
      };
    }),
    (y.prototype.value = function () {
      return this._wrapped;
    }),
    (y.prototype.valueOf = y.prototype.toJSON = y.prototype.value),
    (y.prototype.toString = function () {
      return "" + this._wrapped;
    }),
    "function" == typeof define &&
      define.amd &&
      define("underscore", [], function () {
        return y;
      });
}).call(this);
var Handlebars = (function () {
  var t = (function () {
      "use strict";
      function t(t) {
        this.string = t;
      }
      var e;
      return (
        (t.prototype.toString = function () {
          return "" + this.string;
        }),
        (e = t)
      );
    })(),
    e = (function (t) {
      "use strict";
      function e(t) {
        return a[t] || "&";
      }
      function i(t, e) {
        for (var i in e)
          Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
      function n(t) {
        return t instanceof r
          ? t.toString()
          : t || 0 === t
          ? ((t = "" + t), c.test(t) ? t.replace(l, e) : t)
          : "";
      }
      function o(t) {
        return t || 0 === t ? !(!p(t) || 0 !== t.length) : !0;
      }
      var s = {},
        r = t,
        a = {
          "&": "&",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;",
        },
        l = /[&<>"'`]/g,
        c = /[&<>"'`]/;
      s.extend = i;
      var u = Object.prototype.toString;
      s.toString = u;
      var h = function (t) {
        return "function" == typeof t;
      };
      h(/x/) &&
        (h = function (t) {
          return "function" == typeof t && "[object Function]" === u.call(t);
        });
      var h;
      s.isFunction = h;
      var p =
        Array.isArray ||
        function (t) {
          return t && "object" == typeof t
            ? "[object Array]" === u.call(t)
            : !1;
        };
      return (s.isArray = p), (s.escapeExpression = n), (s.isEmpty = o), s;
    })(t),
    i = (function () {
      "use strict";
      function t(t, e) {
        var n;
        e &&
          e.firstLine &&
          ((n = e.firstLine), (t += " - " + n + ":" + e.firstColumn));
        for (
          var o = Error.prototype.constructor.call(this, t), s = 0;
          s < i.length;
          s++
        )
          this[i[s]] = o[i[s]];
        n && ((this.lineNumber = n), (this.column = e.firstColumn));
      }
      var e,
        i = [
          "description",
          "fileName",
          "lineNumber",
          "message",
          "name",
          "number",
          "stack",
        ];
      return (t.prototype = new Error()), (e = t);
    })(),
    n = (function (t, e) {
      "use strict";
      function i(t, e) {
        (this.helpers = t || {}), (this.partials = e || {}), n(this);
      }
      function n(t) {
        t.registerHelper("helperMissing", function (t) {
          if (2 !== arguments.length)
            throw new a("Missing helper: '" + t + "'");
        }),
          t.registerHelper("blockHelperMissing", function (e, i) {
            var n = i.inverse || function () {},
              o = i.fn;
            return (
              p(e) && (e = e.call(this)),
              e === !0
                ? o(this)
                : e === !1 || null == e
                ? n(this)
                : h(e)
                ? e.length > 0
                  ? t.helpers.each(e, i)
                  : n(this)
                : o(e)
            );
          }),
          t.registerHelper("each", function (t, e) {
            var i,
              n = e.fn,
              o = e.inverse,
              s = 0,
              r = "";
            if (
              (p(t) && (t = t.call(this)),
              e.data && (i = g(e.data)),
              t && "object" == typeof t)
            )
              if (h(t))
                for (var a = t.length; a > s; s++)
                  i &&
                    ((i.index = s),
                    (i.first = 0 === s),
                    (i.last = s === t.length - 1)),
                    (r += n(t[s], { data: i }));
              else
                for (var l in t)
                  t.hasOwnProperty(l) &&
                    (i && ((i.key = l), (i.index = s), (i.first = 0 === s)),
                    (r += n(t[l], { data: i })),
                    s++);
            return 0 === s && (r = o(this)), r;
          }),
          t.registerHelper("if", function (t, e) {
            return (
              p(t) && (t = t.call(this)),
              (!e.hash.includeZero && !t) || r.isEmpty(t)
                ? e.inverse(this)
                : e.fn(this)
            );
          }),
          t.registerHelper("unless", function (e, i) {
            return t.helpers["if"].call(this, e, {
              fn: i.inverse,
              inverse: i.fn,
              hash: i.hash,
            });
          }),
          t.registerHelper("with", function (t, e) {
            return p(t) && (t = t.call(this)), r.isEmpty(t) ? void 0 : e.fn(t);
          }),
          t.registerHelper(
            "math",
            function (lvalue, operator, rvalue, options) {
              lvalue = parseFloat(lvalue);
              rvalue = parseFloat(rvalue);

              return {
                "+": lvalue + rvalue,
                "-": lvalue - rvalue,
                "*": lvalue * rvalue,
                "/": lvalue / rvalue,
                "%": lvalue % rvalue,
              }[operator];
            }
          ),
          t.registerHelper("log", function (e, i) {
            var n =
              i.data && null != i.data.level ? parseInt(i.data.level, 10) : 1;
            t.log(n, e);
          });
      }
      function o(t, e) {
        m.log(t, e);
      }
      var s = {},
        r = t,
        a = e,
        l = "1.3.0";
      s.VERSION = l;
      var c = 4;
      s.COMPILER_REVISION = c;
      var u = {
        1: "<= 1.0.rc.2",
        2: "== 1.0.0-rc.3",
        3: "== 1.0.0-rc.4",
        4: ">= 1.0.0",
      };
      s.REVISION_CHANGES = u;
      var h = r.isArray,
        p = r.isFunction,
        d = r.toString,
        f = "[object Object]";
      (s.HandlebarsEnvironment = i),
        (i.prototype = {
          constructor: i,
          logger: m,
          log: o,
          registerHelper: function (t, e, i) {
            if (d.call(t) === f) {
              if (i || e)
                throw new a("Arg not supported with multiple helpers");
              r.extend(this.helpers, t);
            } else i && (e.not = i), (this.helpers[t] = e);
          },
          registerPartial: function (t, e) {
            d.call(t) === f
              ? r.extend(this.partials, t)
              : (this.partials[t] = e);
          },
        });
      var m = {
        methodMap: { 0: "debug", 1: "info", 2: "warn", 3: "error" },
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        level: 3,
        log: function (t, e) {
          if (m.level <= t) {
            var i = m.methodMap[t];
            "undefined" != typeof console &&
              console[i] &&
              console[i].call(console, e);
          }
        },
      };
      (s.logger = m), (s.log = o);
      var g = function (t) {
        var e = {};
        return r.extend(e, t), e;
      };
      return (s.createFrame = g), s;
    })(e, i),
    o = (function (t, e, i) {
      "use strict";
      function n(t) {
        var e = (t && t[0]) || 1,
          i = p;
        if (e !== i) {
          if (i > e) {
            var n = d[i],
              o = d[e];
            throw new h(
              "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                n +
                ") or downgrade your runtime to an older version (" +
                o +
                ")."
            );
          }
          throw new h(
            "Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
              t[1] +
              ")."
          );
        }
      }
      function o(t, e) {
        if (!e) throw new h("No environment passed to template");
        var i = function (t, i, n, o, s, r) {
            var a = e.VM.invokePartial.apply(this, arguments);
            if (null != a) return a;
            if (e.compile) {
              var l = { helpers: o, partials: s, data: r };
              return (
                (s[i] = e.compile(t, { data: void 0 !== r }, e)), s[i](n, l)
              );
            }
            throw new h(
              "The partial " +
                i +
                " could not be compiled when running in runtime-only mode"
            );
          },
          n = {
            escapeExpression: u.escapeExpression,
            invokePartial: i,
            programs: [],
            program: function (t, e, i) {
              var n = this.programs[t];
              return (
                i ? (n = r(t, e, i)) : n || (n = this.programs[t] = r(t, e)), n
              );
            },
            merge: function (t, e) {
              var i = t || e;
              return (
                t && e && t !== e && ((i = {}), u.extend(i, e), u.extend(i, t)),
                i
              );
            },
            programWithDepth: e.VM.programWithDepth,
            noop: e.VM.noop,
            compilerInfo: null,
          };
        return function (i, o) {
          o = o || {};
          var s,
            r,
            a = o.partial ? o : e;
          o.partial || ((s = o.helpers), (r = o.partials));
          var l = t.call(n, a, i, s, r, o.data);
          return o.partial || e.VM.checkRevision(n.compilerInfo), l;
        };
      }
      function s(t, e, i) {
        var n = Array.prototype.slice.call(arguments, 3),
          o = function (t, o) {
            return (o = o || {}), e.apply(this, [t, o.data || i].concat(n));
          };
        return (o.program = t), (o.depth = n.length), o;
      }
      function r(t, e, i) {
        var n = function (t, n) {
          return (n = n || {}), e(t, n.data || i);
        };
        return (n.program = t), (n.depth = 0), n;
      }
      function a(t, e, i, n, o, s) {
        var r = { partial: !0, helpers: n, partials: o, data: s };
        if (void 0 === t)
          throw new h("The partial " + e + " could not be found");
        return t instanceof Function ? t(i, r) : void 0;
      }
      function l() {
        return "";
      }
      var c = {},
        u = t,
        h = e,
        p = i.COMPILER_REVISION,
        d = i.REVISION_CHANGES;
      return (
        (c.checkRevision = n),
        (c.template = o),
        (c.programWithDepth = s),
        (c.program = r),
        (c.invokePartial = a),
        (c.noop = l),
        c
      );
    })(e, i, n),
    s = (function (t, e, i, n, o) {
      "use strict";
      var s,
        r = t,
        a = e,
        l = i,
        c = n,
        u = o,
        h = function () {
          var t = new r.HandlebarsEnvironment();
          return (
            c.extend(t, r),
            (t.SafeString = a),
            (t.Exception = l),
            (t.Utils = c),
            (t.VM = u),
            (t.template = function (e) {
              return u.template(e, t);
            }),
            t
          );
        },
        p = h();
      return (p.create = h), (s = p);
    })(n, t, i, e, o),
    r = (function (t) {
      "use strict";
      function e(t) {
        (t = t || {}),
          (this.firstLine = t.first_line),
          (this.firstColumn = t.first_column),
          (this.lastColumn = t.last_column),
          (this.lastLine = t.last_line);
      }
      var i,
        n = t,
        o = {
          ProgramNode: function (t, i, n, s) {
            var r, a;
            3 === arguments.length
              ? ((s = n), (n = null))
              : 2 === arguments.length && ((s = i), (i = null)),
              e.call(this, s),
              (this.type = "program"),
              (this.statements = t),
              (this.strip = {}),
              n
                ? ((a = n[0]),
                  a
                    ? ((r = {
                        first_line: a.firstLine,
                        last_line: a.lastLine,
                        last_column: a.lastColumn,
                        first_column: a.firstColumn,
                      }),
                      (this.inverse = new o.ProgramNode(n, i, r)))
                    : (this.inverse = new o.ProgramNode(n, i)),
                  (this.strip.right = i.left))
                : i && (this.strip.left = i.right);
          },
          MustacheNode: function (t, i, n, s, r) {
            if (
              (e.call(this, r),
              (this.type = "mustache"),
              (this.strip = s),
              null != n && n.charAt)
            ) {
              var a = n.charAt(3) || n.charAt(2);
              this.escaped = "{" !== a && "&" !== a;
            } else this.escaped = !!n;
            t instanceof o.SexprNode
              ? (this.sexpr = t)
              : (this.sexpr = new o.SexprNode(t, i)),
              (this.sexpr.isRoot = !0),
              (this.id = this.sexpr.id),
              (this.params = this.sexpr.params),
              (this.hash = this.sexpr.hash),
              (this.eligibleHelper = this.sexpr.eligibleHelper),
              (this.isHelper = this.sexpr.isHelper);
          },
          SexprNode: function (t, i, n) {
            e.call(this, n), (this.type = "sexpr"), (this.hash = i);
            var o = (this.id = t[0]),
              s = (this.params = t.slice(1)),
              r = (this.eligibleHelper = o.isSimple);
            this.isHelper = r && (s.length || i);
          },
          PartialNode: function (t, i, n, o) {
            e.call(this, o),
              (this.type = "partial"),
              (this.partialName = t),
              (this.context = i),
              (this.strip = n);
          },
          BlockNode: function (t, i, o, s, r) {
            if ((e.call(this, r), t.sexpr.id.original !== s.path.original))
              throw new n(
                t.sexpr.id.original + " doesn't match " + s.path.original,
                this
              );
            (this.type = "block"),
              (this.mustache = t),
              (this.program = i),
              (this.inverse = o),
              (this.strip = { left: t.strip.left, right: s.strip.right }),
              ((i || o).strip.left = t.strip.right),
              ((o || i).strip.right = s.strip.left),
              o && !i && (this.isInverse = !0);
          },
          ContentNode: function (t, i) {
            e.call(this, i), (this.type = "content"), (this.string = t);
          },
          HashNode: function (t, i) {
            e.call(this, i), (this.type = "hash"), (this.pairs = t);
          },
          IdNode: function (t, i) {
            e.call(this, i), (this.type = "ID");
            for (var o = "", s = [], r = 0, a = 0, l = t.length; l > a; a++) {
              var c = t[a].part;
              if (
                ((o += (t[a].separator || "") + c),
                ".." === c || "." === c || "this" === c)
              ) {
                if (s.length > 0) throw new n("Invalid path: " + o, this);
                ".." === c ? r++ : (this.isScoped = !0);
              } else s.push(c);
            }
            (this.original = o),
              (this.parts = s),
              (this.string = s.join(".")),
              (this.depth = r),
              (this.isSimple = 1 === t.length && !this.isScoped && 0 === r),
              (this.stringModeValue = this.string);
          },
          PartialNameNode: function (t, i) {
            e.call(this, i),
              (this.type = "PARTIAL_NAME"),
              (this.name = t.original);
          },
          DataNode: function (t, i) {
            e.call(this, i), (this.type = "DATA"), (this.id = t);
          },
          StringNode: function (t, i) {
            e.call(this, i),
              (this.type = "STRING"),
              (this.original = this.string = this.stringModeValue = t);
          },
          IntegerNode: function (t, i) {
            e.call(this, i),
              (this.type = "INTEGER"),
              (this.original = this.integer = t),
              (this.stringModeValue = Number(t));
          },
          BooleanNode: function (t, i) {
            e.call(this, i),
              (this.type = "BOOLEAN"),
              (this.bool = t),
              (this.stringModeValue = "true" === t);
          },
          CommentNode: function (t, i) {
            e.call(this, i), (this.type = "comment"), (this.comment = t);
          },
        };
      return (i = o);
    })(i),
    a = (function () {
      "use strict";
      var t,
        e = (function () {
          function t(t, e) {
            return {
              left: "~" === t.charAt(2),
              right: "~" === e.charAt(0) || "~" === e.charAt(1),
            };
          }
          function e() {
            this.yy = {};
          }
          var i = {
              trace: function () {},
              yy: {},
              symbols_: {
                error: 2,
                root: 3,
                statements: 4,
                EOF: 5,
                program: 6,
                simpleInverse: 7,
                statement: 8,
                openInverse: 9,
                closeBlock: 10,
                openBlock: 11,
                mustache: 12,
                partial: 13,
                CONTENT: 14,
                COMMENT: 15,
                OPEN_BLOCK: 16,
                sexpr: 17,
                CLOSE: 18,
                OPEN_INVERSE: 19,
                OPEN_ENDBLOCK: 20,
                path: 21,
                OPEN: 22,
                OPEN_UNESCAPED: 23,
                CLOSE_UNESCAPED: 24,
                OPEN_PARTIAL: 25,
                partialName: 26,
                partial_option0: 27,
                sexpr_repetition0: 28,
                sexpr_option0: 29,
                dataName: 30,
                param: 31,
                STRING: 32,
                INTEGER: 33,
                BOOLEAN: 34,
                OPEN_SEXPR: 35,
                CLOSE_SEXPR: 36,
                hash: 37,
                hash_repetition_plus0: 38,
                hashSegment: 39,
                ID: 40,
                EQUALS: 41,
                DATA: 42,
                pathSegments: 43,
                SEP: 44,
                $accept: 0,
                $end: 1,
              },
              terminals_: {
                2: "error",
                5: "EOF",
                14: "CONTENT",
                15: "COMMENT",
                16: "OPEN_BLOCK",
                18: "CLOSE",
                19: "OPEN_INVERSE",
                20: "OPEN_ENDBLOCK",
                22: "OPEN",
                23: "OPEN_UNESCAPED",
                24: "CLOSE_UNESCAPED",
                25: "OPEN_PARTIAL",
                32: "STRING",
                33: "INTEGER",
                34: "BOOLEAN",
                35: "OPEN_SEXPR",
                36: "CLOSE_SEXPR",
                40: "ID",
                41: "EQUALS",
                42: "DATA",
                44: "SEP",
              },
              productions_: [
                0,
                [3, 2],
                [3, 1],
                [6, 2],
                [6, 3],
                [6, 2],
                [6, 1],
                [6, 1],
                [6, 0],
                [4, 1],
                [4, 2],
                [8, 3],
                [8, 3],
                [8, 1],
                [8, 1],
                [8, 1],
                [8, 1],
                [11, 3],
                [9, 3],
                [10, 3],
                [12, 3],
                [12, 3],
                [13, 4],
                [7, 2],
                [17, 3],
                [17, 1],
                [31, 1],
                [31, 1],
                [31, 1],
                [31, 1],
                [31, 1],
                [31, 3],
                [37, 1],
                [39, 3],
                [26, 1],
                [26, 1],
                [26, 1],
                [30, 2],
                [21, 1],
                [43, 3],
                [43, 1],
                [27, 0],
                [27, 1],
                [28, 0],
                [28, 2],
                [29, 0],
                [29, 1],
                [38, 1],
                [38, 2],
              ],
              performAction: function (e, i, n, o, s, r, a) {
                var l = r.length - 1;
                switch (s) {
                  case 1:
                    return new o.ProgramNode(r[l - 1], this._$);
                  case 2:
                    return new o.ProgramNode([], this._$);
                  case 3:
                    this.$ = new o.ProgramNode([], r[l - 1], r[l], this._$);
                    break;
                  case 4:
                    this.$ = new o.ProgramNode(
                      r[l - 2],
                      r[l - 1],
                      r[l],
                      this._$
                    );
                    break;
                  case 5:
                    this.$ = new o.ProgramNode(r[l - 1], r[l], [], this._$);
                    break;
                  case 6:
                    this.$ = new o.ProgramNode(r[l], this._$);
                    break;
                  case 7:
                    this.$ = new o.ProgramNode([], this._$);
                    break;
                  case 8:
                    this.$ = new o.ProgramNode([], this._$);
                    break;
                  case 9:
                    this.$ = [r[l]];
                    break;
                  case 10:
                    r[l - 1].push(r[l]), (this.$ = r[l - 1]);
                    break;
                  case 11:
                    this.$ = new o.BlockNode(
                      r[l - 2],
                      r[l - 1].inverse,
                      r[l - 1],
                      r[l],
                      this._$
                    );
                    break;
                  case 12:
                    this.$ = new o.BlockNode(
                      r[l - 2],
                      r[l - 1],
                      r[l - 1].inverse,
                      r[l],
                      this._$
                    );
                    break;
                  case 13:
                    this.$ = r[l];
                    break;
                  case 14:
                    this.$ = r[l];
                    break;
                  case 15:
                    this.$ = new o.ContentNode(r[l], this._$);
                    break;
                  case 16:
                    this.$ = new o.CommentNode(r[l], this._$);
                    break;
                  case 17:
                    this.$ = new o.MustacheNode(
                      r[l - 1],
                      null,
                      r[l - 2],
                      t(r[l - 2], r[l]),
                      this._$
                    );
                    break;
                  case 18:
                    this.$ = new o.MustacheNode(
                      r[l - 1],
                      null,
                      r[l - 2],
                      t(r[l - 2], r[l]),
                      this._$
                    );
                    break;
                  case 19:
                    this.$ = { path: r[l - 1], strip: t(r[l - 2], r[l]) };
                    break;
                  case 20:
                    this.$ = new o.MustacheNode(
                      r[l - 1],
                      null,
                      r[l - 2],
                      t(r[l - 2], r[l]),
                      this._$
                    );
                    break;
                  case 21:
                    this.$ = new o.MustacheNode(
                      r[l - 1],
                      null,
                      r[l - 2],
                      t(r[l - 2], r[l]),
                      this._$
                    );
                    break;
                  case 22:
                    this.$ = new o.PartialNode(
                      r[l - 2],
                      r[l - 1],
                      t(r[l - 3], r[l]),
                      this._$
                    );
                    break;
                  case 23:
                    this.$ = t(r[l - 1], r[l]);
                    break;
                  case 24:
                    this.$ = new o.SexprNode(
                      [r[l - 2]].concat(r[l - 1]),
                      r[l],
                      this._$
                    );
                    break;
                  case 25:
                    this.$ = new o.SexprNode([r[l]], null, this._$);
                    break;
                  case 26:
                    this.$ = r[l];
                    break;
                  case 27:
                    this.$ = new o.StringNode(r[l], this._$);
                    break;
                  case 28:
                    this.$ = new o.IntegerNode(r[l], this._$);
                    break;
                  case 29:
                    this.$ = new o.BooleanNode(r[l], this._$);
                    break;
                  case 30:
                    this.$ = r[l];
                    break;
                  case 31:
                    (r[l - 1].isHelper = !0), (this.$ = r[l - 1]);
                    break;
                  case 32:
                    this.$ = new o.HashNode(r[l], this._$);
                    break;
                  case 33:
                    this.$ = [r[l - 2], r[l]];
                    break;
                  case 34:
                    this.$ = new o.PartialNameNode(r[l], this._$);
                    break;
                  case 35:
                    this.$ = new o.PartialNameNode(
                      new o.StringNode(r[l], this._$),
                      this._$
                    );
                    break;
                  case 36:
                    this.$ = new o.PartialNameNode(
                      new o.IntegerNode(r[l], this._$)
                    );
                    break;
                  case 37:
                    this.$ = new o.DataNode(r[l], this._$);
                    break;
                  case 38:
                    this.$ = new o.IdNode(r[l], this._$);
                    break;
                  case 39:
                    r[l - 2].push({ part: r[l], separator: r[l - 1] }),
                      (this.$ = r[l - 2]);
                    break;
                  case 40:
                    this.$ = [{ part: r[l] }];
                    break;
                  case 43:
                    this.$ = [];
                    break;
                  case 44:
                    r[l - 1].push(r[l]);
                    break;
                  case 47:
                    this.$ = [r[l]];
                    break;
                  case 48:
                    r[l - 1].push(r[l]);
                }
              },
              table: [
                {
                  3: 1,
                  4: 2,
                  5: [1, 3],
                  8: 4,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 11],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                { 1: [3] },
                {
                  5: [1, 16],
                  8: 17,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 11],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                { 1: [2, 2] },
                {
                  5: [2, 9],
                  14: [2, 9],
                  15: [2, 9],
                  16: [2, 9],
                  19: [2, 9],
                  20: [2, 9],
                  22: [2, 9],
                  23: [2, 9],
                  25: [2, 9],
                },
                {
                  4: 20,
                  6: 18,
                  7: 19,
                  8: 4,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 21],
                  20: [2, 8],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                {
                  4: 20,
                  6: 22,
                  7: 19,
                  8: 4,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 21],
                  20: [2, 8],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                {
                  5: [2, 13],
                  14: [2, 13],
                  15: [2, 13],
                  16: [2, 13],
                  19: [2, 13],
                  20: [2, 13],
                  22: [2, 13],
                  23: [2, 13],
                  25: [2, 13],
                },
                {
                  5: [2, 14],
                  14: [2, 14],
                  15: [2, 14],
                  16: [2, 14],
                  19: [2, 14],
                  20: [2, 14],
                  22: [2, 14],
                  23: [2, 14],
                  25: [2, 14],
                },
                {
                  5: [2, 15],
                  14: [2, 15],
                  15: [2, 15],
                  16: [2, 15],
                  19: [2, 15],
                  20: [2, 15],
                  22: [2, 15],
                  23: [2, 15],
                  25: [2, 15],
                },
                {
                  5: [2, 16],
                  14: [2, 16],
                  15: [2, 16],
                  16: [2, 16],
                  19: [2, 16],
                  20: [2, 16],
                  22: [2, 16],
                  23: [2, 16],
                  25: [2, 16],
                },
                { 17: 23, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
                { 17: 29, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
                { 17: 30, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
                { 17: 31, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
                {
                  21: 33,
                  26: 32,
                  32: [1, 34],
                  33: [1, 35],
                  40: [1, 28],
                  43: 26,
                },
                { 1: [2, 1] },
                {
                  5: [2, 10],
                  14: [2, 10],
                  15: [2, 10],
                  16: [2, 10],
                  19: [2, 10],
                  20: [2, 10],
                  22: [2, 10],
                  23: [2, 10],
                  25: [2, 10],
                },
                { 10: 36, 20: [1, 37] },
                {
                  4: 38,
                  8: 4,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 11],
                  20: [2, 7],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                {
                  7: 39,
                  8: 17,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 21],
                  20: [2, 6],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                {
                  17: 23,
                  18: [1, 40],
                  21: 24,
                  30: 25,
                  40: [1, 28],
                  42: [1, 27],
                  43: 26,
                },
                { 10: 41, 20: [1, 37] },
                { 18: [1, 42] },
                {
                  18: [2, 43],
                  24: [2, 43],
                  28: 43,
                  32: [2, 43],
                  33: [2, 43],
                  34: [2, 43],
                  35: [2, 43],
                  36: [2, 43],
                  40: [2, 43],
                  42: [2, 43],
                },
                { 18: [2, 25], 24: [2, 25], 36: [2, 25] },
                {
                  18: [2, 38],
                  24: [2, 38],
                  32: [2, 38],
                  33: [2, 38],
                  34: [2, 38],
                  35: [2, 38],
                  36: [2, 38],
                  40: [2, 38],
                  42: [2, 38],
                  44: [1, 44],
                },
                { 21: 45, 40: [1, 28], 43: 26 },
                {
                  18: [2, 40],
                  24: [2, 40],
                  32: [2, 40],
                  33: [2, 40],
                  34: [2, 40],
                  35: [2, 40],
                  36: [2, 40],
                  40: [2, 40],
                  42: [2, 40],
                  44: [2, 40],
                },
                { 18: [1, 46] },
                { 18: [1, 47] },
                { 24: [1, 48] },
                { 18: [2, 41], 21: 50, 27: 49, 40: [1, 28], 43: 26 },
                { 18: [2, 34], 40: [2, 34] },
                { 18: [2, 35], 40: [2, 35] },
                { 18: [2, 36], 40: [2, 36] },
                {
                  5: [2, 11],
                  14: [2, 11],
                  15: [2, 11],
                  16: [2, 11],
                  19: [2, 11],
                  20: [2, 11],
                  22: [2, 11],
                  23: [2, 11],
                  25: [2, 11],
                },
                { 21: 51, 40: [1, 28], 43: 26 },
                {
                  8: 17,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 11],
                  20: [2, 3],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                {
                  4: 52,
                  8: 4,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 11],
                  20: [2, 5],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                {
                  14: [2, 23],
                  15: [2, 23],
                  16: [2, 23],
                  19: [2, 23],
                  20: [2, 23],
                  22: [2, 23],
                  23: [2, 23],
                  25: [2, 23],
                },
                {
                  5: [2, 12],
                  14: [2, 12],
                  15: [2, 12],
                  16: [2, 12],
                  19: [2, 12],
                  20: [2, 12],
                  22: [2, 12],
                  23: [2, 12],
                  25: [2, 12],
                },
                {
                  14: [2, 18],
                  15: [2, 18],
                  16: [2, 18],
                  19: [2, 18],
                  20: [2, 18],
                  22: [2, 18],
                  23: [2, 18],
                  25: [2, 18],
                },
                {
                  18: [2, 45],
                  21: 56,
                  24: [2, 45],
                  29: 53,
                  30: 60,
                  31: 54,
                  32: [1, 57],
                  33: [1, 58],
                  34: [1, 59],
                  35: [1, 61],
                  36: [2, 45],
                  37: 55,
                  38: 62,
                  39: 63,
                  40: [1, 64],
                  42: [1, 27],
                  43: 26,
                },
                { 40: [1, 65] },
                {
                  18: [2, 37],
                  24: [2, 37],
                  32: [2, 37],
                  33: [2, 37],
                  34: [2, 37],
                  35: [2, 37],
                  36: [2, 37],
                  40: [2, 37],
                  42: [2, 37],
                },
                {
                  14: [2, 17],
                  15: [2, 17],
                  16: [2, 17],
                  19: [2, 17],
                  20: [2, 17],
                  22: [2, 17],
                  23: [2, 17],
                  25: [2, 17],
                },
                {
                  5: [2, 20],
                  14: [2, 20],
                  15: [2, 20],
                  16: [2, 20],
                  19: [2, 20],
                  20: [2, 20],
                  22: [2, 20],
                  23: [2, 20],
                  25: [2, 20],
                },
                {
                  5: [2, 21],
                  14: [2, 21],
                  15: [2, 21],
                  16: [2, 21],
                  19: [2, 21],
                  20: [2, 21],
                  22: [2, 21],
                  23: [2, 21],
                  25: [2, 21],
                },
                { 18: [1, 66] },
                { 18: [2, 42] },
                { 18: [1, 67] },
                {
                  8: 17,
                  9: 5,
                  11: 6,
                  12: 7,
                  13: 8,
                  14: [1, 9],
                  15: [1, 10],
                  16: [1, 12],
                  19: [1, 11],
                  20: [2, 4],
                  22: [1, 13],
                  23: [1, 14],
                  25: [1, 15],
                },
                { 18: [2, 24], 24: [2, 24], 36: [2, 24] },
                {
                  18: [2, 44],
                  24: [2, 44],
                  32: [2, 44],
                  33: [2, 44],
                  34: [2, 44],
                  35: [2, 44],
                  36: [2, 44],
                  40: [2, 44],
                  42: [2, 44],
                },
                { 18: [2, 46], 24: [2, 46], 36: [2, 46] },
                {
                  18: [2, 26],
                  24: [2, 26],
                  32: [2, 26],
                  33: [2, 26],
                  34: [2, 26],
                  35: [2, 26],
                  36: [2, 26],
                  40: [2, 26],
                  42: [2, 26],
                },
                {
                  18: [2, 27],
                  24: [2, 27],
                  32: [2, 27],
                  33: [2, 27],
                  34: [2, 27],
                  35: [2, 27],
                  36: [2, 27],
                  40: [2, 27],
                  42: [2, 27],
                },
                {
                  18: [2, 28],
                  24: [2, 28],
                  32: [2, 28],
                  33: [2, 28],
                  34: [2, 28],
                  35: [2, 28],
                  36: [2, 28],
                  40: [2, 28],
                  42: [2, 28],
                },
                {
                  18: [2, 29],
                  24: [2, 29],
                  32: [2, 29],
                  33: [2, 29],
                  34: [2, 29],
                  35: [2, 29],
                  36: [2, 29],
                  40: [2, 29],
                  42: [2, 29],
                },
                {
                  18: [2, 30],
                  24: [2, 30],
                  32: [2, 30],
                  33: [2, 30],
                  34: [2, 30],
                  35: [2, 30],
                  36: [2, 30],
                  40: [2, 30],
                  42: [2, 30],
                },
                { 17: 68, 21: 24, 30: 25, 40: [1, 28], 42: [1, 27], 43: 26 },
                { 18: [2, 32], 24: [2, 32], 36: [2, 32], 39: 69, 40: [1, 70] },
                { 18: [2, 47], 24: [2, 47], 36: [2, 47], 40: [2, 47] },
                {
                  18: [2, 40],
                  24: [2, 40],
                  32: [2, 40],
                  33: [2, 40],
                  34: [2, 40],
                  35: [2, 40],
                  36: [2, 40],
                  40: [2, 40],
                  41: [1, 71],
                  42: [2, 40],
                  44: [2, 40],
                },
                {
                  18: [2, 39],
                  24: [2, 39],
                  32: [2, 39],
                  33: [2, 39],
                  34: [2, 39],
                  35: [2, 39],
                  36: [2, 39],
                  40: [2, 39],
                  42: [2, 39],
                  44: [2, 39],
                },
                {
                  5: [2, 22],
                  14: [2, 22],
                  15: [2, 22],
                  16: [2, 22],
                  19: [2, 22],
                  20: [2, 22],
                  22: [2, 22],
                  23: [2, 22],
                  25: [2, 22],
                },
                {
                  5: [2, 19],
                  14: [2, 19],
                  15: [2, 19],
                  16: [2, 19],
                  19: [2, 19],
                  20: [2, 19],
                  22: [2, 19],
                  23: [2, 19],
                  25: [2, 19],
                },
                { 36: [1, 72] },
                { 18: [2, 48], 24: [2, 48], 36: [2, 48], 40: [2, 48] },
                { 41: [1, 71] },
                {
                  21: 56,
                  30: 60,
                  31: 73,
                  32: [1, 57],
                  33: [1, 58],
                  34: [1, 59],
                  35: [1, 61],
                  40: [1, 28],
                  42: [1, 27],
                  43: 26,
                },
                {
                  18: [2, 31],
                  24: [2, 31],
                  32: [2, 31],
                  33: [2, 31],
                  34: [2, 31],
                  35: [2, 31],
                  36: [2, 31],
                  40: [2, 31],
                  42: [2, 31],
                },
                { 18: [2, 33], 24: [2, 33], 36: [2, 33], 40: [2, 33] },
              ],
              defaultActions: { 3: [2, 2], 16: [2, 1], 50: [2, 42] },
              parseError: function (t, e) {
                throw new Error(t);
              },
              parse: function (t) {
                function e() {
                  var t;
                  return (
                    (t = i.lexer.lex() || 1),
                    "number" != typeof t && (t = i.symbols_[t] || t),
                    t
                  );
                }
                var i = this,
                  n = [0],
                  o = [null],
                  s = [],
                  r = this.table,
                  a = "",
                  l = 0,
                  c = 0,
                  u = 0;
                this.lexer.setInput(t),
                  (this.lexer.yy = this.yy),
                  (this.yy.lexer = this.lexer),
                  (this.yy.parser = this),
                  "undefined" == typeof this.lexer.yylloc &&
                    (this.lexer.yylloc = {});
                var h = this.lexer.yylloc;
                s.push(h);
                var p = this.lexer.options && this.lexer.options.ranges;
                "function" == typeof this.yy.parseError &&
                  (this.parseError = this.yy.parseError);
                for (var d, f, m, g, v, y, k, w, b, S = {}; ; ) {
                  if (
                    ((m = n[n.length - 1]),
                    this.defaultActions[m]
                      ? (g = this.defaultActions[m])
                      : ((null !== d && "undefined" != typeof d) || (d = e()),
                        (g = r[m] && r[m][d])),
                    "undefined" == typeof g || !g.length || !g[0])
                  ) {
                    var x = "";
                    if (!u) {
                      b = [];
                      for (y in r[m])
                        this.terminals_[y] &&
                          y > 2 &&
                          b.push("'" + this.terminals_[y] + "'");
                      (x = this.lexer.showPosition
                        ? "Parse error on line " +
                          (l + 1) +
                          ":\n" +
                          this.lexer.showPosition() +
                          "\nExpecting " +
                          b.join(", ") +
                          ", got '" +
                          (this.terminals_[d] || d) +
                          "'"
                        : "Parse error on line " +
                          (l + 1) +
                          ": Unexpected " +
                          (1 == d
                            ? "end of input"
                            : "'" + (this.terminals_[d] || d) + "'")),
                        this.parseError(x, {
                          text: this.lexer.match,
                          token: this.terminals_[d] || d,
                          line: this.lexer.yylineno,
                          loc: h,
                          expected: b,
                        });
                    }
                  }
                  if (g[0] instanceof Array && g.length > 1)
                    throw new Error(
                      "Parse Error: multiple actions possible at state: " +
                        m +
                        ", token: " +
                        d
                    );
                  switch (g[0]) {
                    case 1:
                      n.push(d),
                        o.push(this.lexer.yytext),
                        s.push(this.lexer.yylloc),
                        n.push(g[1]),
                        (d = null),
                        f
                          ? ((d = f), (f = null))
                          : ((c = this.lexer.yyleng),
                            (a = this.lexer.yytext),
                            (l = this.lexer.yylineno),
                            (h = this.lexer.yylloc),
                            u > 0 && u--);
                      break;
                    case 2:
                      if (
                        ((k = this.productions_[g[1]][1]),
                        (S.$ = o[o.length - k]),
                        (S._$ = {
                          first_line: s[s.length - (k || 1)].first_line,
                          last_line: s[s.length - 1].last_line,
                          first_column: s[s.length - (k || 1)].first_column,
                          last_column: s[s.length - 1].last_column,
                        }),
                        p &&
                          (S._$.range = [
                            s[s.length - (k || 1)].range[0],
                            s[s.length - 1].range[1],
                          ]),
                        (v = this.performAction.call(
                          S,
                          a,
                          c,
                          l,
                          this.yy,
                          g[1],
                          o,
                          s
                        )),
                        "undefined" != typeof v)
                      )
                        return v;
                      k &&
                        ((n = n.slice(0, -1 * k * 2)),
                        (o = o.slice(0, -1 * k)),
                        (s = s.slice(0, -1 * k))),
                        n.push(this.productions_[g[1]][0]),
                        o.push(S.$),
                        s.push(S._$),
                        (w = r[n[n.length - 2]][n[n.length - 1]]),
                        n.push(w);
                      break;
                    case 3:
                      return !0;
                  }
                }
                return !0;
              },
            },
            n = (function () {
              var t = {
                EOF: 1,
                parseError: function (t, e) {
                  if (!this.yy.parser) throw new Error(t);
                  this.yy.parser.parseError(t, e);
                },
                setInput: function (t) {
                  return (
                    (this._input = t),
                    (this._more = this._less = this.done = !1),
                    (this.yylineno = this.yyleng = 0),
                    (this.yytext = this.matched = this.match = ""),
                    (this.conditionStack = ["INITIAL"]),
                    (this.yylloc = {
                      first_line: 1,
                      first_column: 0,
                      last_line: 1,
                      last_column: 0,
                    }),
                    this.options.ranges && (this.yylloc.range = [0, 0]),
                    (this.offset = 0),
                    this
                  );
                },
                input: function () {
                  var t = this._input[0];
                  (this.yytext += t),
                    this.yyleng++,
                    this.offset++,
                    (this.match += t),
                    (this.matched += t);
                  var e = t.match(/(?:\r\n?|\n).*/g);
                  return (
                    e
                      ? (this.yylineno++, this.yylloc.last_line++)
                      : this.yylloc.last_column++,
                    this.options.ranges && this.yylloc.range[1]++,
                    (this._input = this._input.slice(1)),
                    t
                  );
                },
                unput: function (t) {
                  var e = t.length,
                    i = t.split(/(?:\r\n?|\n)/g);
                  (this._input = t + this._input),
                    (this.yytext = this.yytext.substr(
                      0,
                      this.yytext.length - e - 1
                    )),
                    (this.offset -= e);
                  var n = this.match.split(/(?:\r\n?|\n)/g);
                  (this.match = this.match.substr(0, this.match.length - 1)),
                    (this.matched = this.matched.substr(
                      0,
                      this.matched.length - 1
                    )),
                    i.length - 1 && (this.yylineno -= i.length - 1);
                  var o = this.yylloc.range;
                  return (
                    (this.yylloc = {
                      first_line: this.yylloc.first_line,
                      last_line: this.yylineno + 1,
                      first_column: this.yylloc.first_column,
                      last_column: i
                        ? (i.length === n.length
                            ? this.yylloc.first_column
                            : 0) +
                          n[n.length - i.length].length -
                          i[0].length
                        : this.yylloc.first_column - e,
                    }),
                    this.options.ranges &&
                      (this.yylloc.range = [o[0], o[0] + this.yyleng - e]),
                    this
                  );
                },
                more: function () {
                  return (this._more = !0), this;
                },
                less: function (t) {
                  this.unput(this.match.slice(t));
                },
                pastInput: function () {
                  var t = this.matched.substr(
                    0,
                    this.matched.length - this.match.length
                  );
                  return (
                    (t.length > 20 ? "..." : "") +
                    t.substr(-20).replace(/\n/g, "")
                  );
                },
                upcomingInput: function () {
                  var t = this.match;
                  return (
                    t.length < 20 &&
                      (t += this._input.substr(0, 20 - t.length)),
                    (t.substr(0, 20) + (t.length > 20 ? "..." : "")).replace(
                      /\n/g,
                      ""
                    )
                  );
                },
                showPosition: function () {
                  var t = this.pastInput(),
                    e = new Array(t.length + 1).join("-");
                  return t + this.upcomingInput() + "\n" + e + "^";
                },
                next: function () {
                  if (this.done) return this.EOF;
                  this._input || (this.done = !0);
                  var t, e, i, n, o;
                  this._more || ((this.yytext = ""), (this.match = ""));
                  for (
                    var s = this._currentRules(), r = 0;
                    r < s.length &&
                    ((i = this._input.match(this.rules[s[r]])),
                    !i ||
                      (e && !(i[0].length > e[0].length)) ||
                      ((e = i), (n = r), this.options.flex));
                    r++
                  );
                  return e
                    ? ((o = e[0].match(/(?:\r\n?|\n).*/g)),
                      o && (this.yylineno += o.length),
                      (this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: o
                          ? o[o.length - 1].length -
                            o[o.length - 1].match(/\r?\n?/)[0].length
                          : this.yylloc.last_column + e[0].length,
                      }),
                      (this.yytext += e[0]),
                      (this.match += e[0]),
                      (this.matches = e),
                      (this.yyleng = this.yytext.length),
                      this.options.ranges &&
                        (this.yylloc.range = [
                          this.offset,
                          (this.offset += this.yyleng),
                        ]),
                      (this._more = !1),
                      (this._input = this._input.slice(e[0].length)),
                      (this.matched += e[0]),
                      (t = this.performAction.call(
                        this,
                        this.yy,
                        this,
                        s[n],
                        this.conditionStack[this.conditionStack.length - 1]
                      )),
                      this.done && this._input && (this.done = !1),
                      t ? t : void 0)
                    : "" === this._input
                    ? this.EOF
                    : this.parseError(
                        "Lexical error on line " +
                          (this.yylineno + 1) +
                          ". Unrecognized text.\n" +
                          this.showPosition(),
                        { text: "", token: null, line: this.yylineno }
                      );
                },
                lex: function () {
                  var t = this.next();
                  return "undefined" != typeof t ? t : this.lex();
                },
                begin: function (t) {
                  this.conditionStack.push(t);
                },
                popState: function () {
                  return this.conditionStack.pop();
                },
                _currentRules: function () {
                  return this.conditions[
                    this.conditionStack[this.conditionStack.length - 1]
                  ].rules;
                },
                topState: function () {
                  return this.conditionStack[this.conditionStack.length - 2];
                },
                pushState: function (t) {
                  this.begin(t);
                },
              };
              return (
                (t.options = {}),
                (t.performAction = function (t, e, i, n) {
                  function o(t, i) {
                    return (e.yytext = e.yytext.substr(t, e.yyleng - i));
                  }
                  switch (i) {
                    case 0:
                      if (
                        ("\\\\" === e.yytext.slice(-2)
                          ? (o(0, 1), this.begin("mu"))
                          : "\\" === e.yytext.slice(-1)
                          ? (o(0, 1), this.begin("emu"))
                          : this.begin("mu"),
                        e.yytext)
                      )
                        return 14;
                      break;
                    case 1:
                      return 14;
                    case 2:
                      return this.popState(), 14;
                    case 3:
                      return o(0, 4), this.popState(), 15;
                    case 4:
                      return 35;
                    case 5:
                      return 36;
                    case 6:
                      return 25;
                    case 7:
                      return 16;
                    case 8:
                      return 20;
                    case 9:
                      return 19;
                    case 10:
                      return 19;
                    case 11:
                      return 23;
                    case 12:
                      return 22;
                    case 13:
                      this.popState(), this.begin("com");
                      break;
                    case 14:
                      return o(3, 5), this.popState(), 15;
                    case 15:
                      return 22;
                    case 16:
                      return 41;
                    case 17:
                      return 40;
                    case 18:
                      return 40;
                    case 19:
                      return 44;
                    case 20:
                      break;
                    case 21:
                      return this.popState(), 24;
                    case 22:
                      return this.popState(), 18;
                    case 23:
                      return (e.yytext = o(1, 2).replace(/\\"/g, '"')), 32;
                    case 24:
                      return (e.yytext = o(1, 2).replace(/\\'/g, "'")), 32;
                    case 25:
                      return 42;
                    case 26:
                      return 34;
                    case 27:
                      return 34;
                    case 28:
                      return 33;
                    case 29:
                      return 40;
                    case 30:
                      return (e.yytext = o(1, 2)), 40;
                    case 31:
                      return "INVALID";
                    case 32:
                      return 5;
                  }
                }),
                (t.rules = [
                  /^(?:[^\x00]*?(?=(\{\{)))/,
                  /^(?:[^\x00]+)/,
                  /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                  /^(?:[\s\S]*?--\}\})/,
                  /^(?:\()/,
                  /^(?:\))/,
                  /^(?:\{\{(~)?>)/,
                  /^(?:\{\{(~)?#)/,
                  /^(?:\{\{(~)?\/)/,
                  /^(?:\{\{(~)?\^)/,
                  /^(?:\{\{(~)?\s*else\b)/,
                  /^(?:\{\{(~)?\{)/,
                  /^(?:\{\{(~)?&)/,
                  /^(?:\{\{!--)/,
                  /^(?:\{\{![\s\S]*?\}\})/,
                  /^(?:\{\{(~)?)/,
                  /^(?:=)/,
                  /^(?:\.\.)/,
                  /^(?:\.(?=([=~}\s\/.)])))/,
                  /^(?:[\/.])/,
                  /^(?:\s+)/,
                  /^(?:\}(~)?\}\})/,
                  /^(?:(~)?\}\})/,
                  /^(?:"(\\["]|[^"])*")/,
                  /^(?:'(\\[']|[^'])*')/,
                  /^(?:@)/,
                  /^(?:true(?=([~}\s)])))/,
                  /^(?:false(?=([~}\s)])))/,
                  /^(?:-?[0-9]+(?=([~}\s)])))/,
                  /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,
                  /^(?:\[[^\]]*\])/,
                  /^(?:.)/,
                  /^(?:$)/,
                ]),
                (t.conditions = {
                  mu: {
                    rules: [
                      4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                      20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
                    ],
                    inclusive: !1,
                  },
                  emu: { rules: [2], inclusive: !1 },
                  com: { rules: [3], inclusive: !1 },
                  INITIAL: { rules: [0, 1, 32], inclusive: !0 },
                }),
                t
              );
            })();
          return (i.lexer = n), (e.prototype = i), (i.Parser = e), new e();
        })();
      return (t = e);
    })(),
    l = (function (t, e) {
      "use strict";
      function i(t) {
        return t.constructor === s.ProgramNode ? t : ((o.yy = s), o.parse(t));
      }
      var n = {},
        o = t,
        s = e;
      return (n.parser = o), (n.parse = i), n;
    })(a, r),
    c = (function (t) {
      "use strict";
      function e() {}
      function i(t, e, i) {
        if (
          null == t ||
          ("string" != typeof t && t.constructor !== i.AST.ProgramNode)
        )
          throw new s(
            "You must pass a string or Handlebars AST to Handlebars.precompile. You passed " +
              t
          );
        (e = e || {}), "data" in e || (e.data = !0);
        var n = i.parse(t),
          o = new i.Compiler().compile(n, e);
        return new i.JavaScriptCompiler().compile(o, e);
      }
      function n(t, e, i) {
        function n() {
          var n = i.parse(t),
            o = new i.Compiler().compile(n, e),
            s = new i.JavaScriptCompiler().compile(o, e, void 0, !0);
          return i.template(s);
        }
        if (
          null == t ||
          ("string" != typeof t && t.constructor !== i.AST.ProgramNode)
        )
          throw new s(
            "You must pass a string or Handlebars AST to Handlebars.compile. You passed " +
              t
          );
        (e = e || {}), "data" in e || (e.data = !0);
        var o;
        return function (t, e) {
          return o || (o = n()), o.call(this, t, e);
        };
      }
      var o = {},
        s = t;
      return (
        (o.Compiler = e),
        (e.prototype = {
          compiler: e,
          disassemble: function () {
            for (
              var t, e, i, n = this.opcodes, o = [], s = 0, r = n.length;
              r > s;
              s++
            )
              if (((t = n[s]), "DECLARE" === t.opcode))
                o.push("DECLARE " + t.name + "=" + t.value);
              else {
                e = [];
                for (var a = 0; a < t.args.length; a++)
                  (i = t.args[a]),
                    "string" == typeof i &&
                      (i = '"' + i.replace("\n", "\\n") + '"'),
                    e.push(i);
                o.push(t.opcode + " " + e.join(" "));
              }
            return o.join("\n");
          },
          equals: function (t) {
            var e = this.opcodes.length;
            if (t.opcodes.length !== e) return !1;
            for (var i = 0; e > i; i++) {
              var n = this.opcodes[i],
                o = t.opcodes[i];
              if (n.opcode !== o.opcode || n.args.length !== o.args.length)
                return !1;
              for (var s = 0; s < n.args.length; s++)
                if (n.args[s] !== o.args[s]) return !1;
            }
            if (((e = this.children.length), t.children.length !== e))
              return !1;
            for (i = 0; e > i; i++)
              if (!this.children[i].equals(t.children[i])) return !1;
            return !0;
          },
          guid: 0,
          compile: function (t, e) {
            (this.opcodes = []),
              (this.children = []),
              (this.depths = { list: [] }),
              (this.options = e);
            var i = this.options.knownHelpers;
            if (
              ((this.options.knownHelpers = {
                helperMissing: !0,
                blockHelperMissing: !0,
                each: !0,
                if: !0,
                unless: !0,
                with: !0,
                log: !0,
              }),
              i)
            )
              for (var n in i) this.options.knownHelpers[n] = i[n];
            return this.accept(t);
          },
          accept: function (t) {
            var e,
              i = t.strip || {};
            return (
              i.left && this.opcode("strip"),
              (e = this[t.type](t)),
              i.right && this.opcode("strip"),
              e
            );
          },
          program: function (t) {
            for (var e = t.statements, i = 0, n = e.length; n > i; i++)
              this.accept(e[i]);
            return (
              (this.isSimple = 1 === n),
              (this.depths.list = this.depths.list.sort(function (t, e) {
                return t - e;
              })),
              this
            );
          },
          compileProgram: function (t) {
            var e,
              i = new this.compiler().compile(t, this.options),
              n = this.guid++;
            (this.usePartial = this.usePartial || i.usePartial),
              (this.children[n] = i);
            for (var o = 0, s = i.depths.list.length; s > o; o++)
              (e = i.depths.list[o]), 2 > e || this.addDepth(e - 1);
            return n;
          },
          block: function (t) {
            var e = t.mustache,
              i = t.program,
              n = t.inverse;
            i && (i = this.compileProgram(i)),
              n && (n = this.compileProgram(n));
            var o = e.sexpr,
              s = this.classifySexpr(o);
            "helper" === s
              ? this.helperSexpr(o, i, n)
              : "simple" === s
              ? (this.simpleSexpr(o),
                this.opcode("pushProgram", i),
                this.opcode("pushProgram", n),
                this.opcode("emptyHash"),
                this.opcode("blockValue"))
              : (this.ambiguousSexpr(o, i, n),
                this.opcode("pushProgram", i),
                this.opcode("pushProgram", n),
                this.opcode("emptyHash"),
                this.opcode("ambiguousBlockValue")),
              this.opcode("append");
          },
          hash: function (t) {
            var e,
              i,
              n = t.pairs;
            this.opcode("pushHash");
            for (var o = 0, s = n.length; s > o; o++)
              (e = n[o]),
                (i = e[1]),
                this.options.stringParams
                  ? (i.depth && this.addDepth(i.depth),
                    this.opcode("getContext", i.depth || 0),
                    this.opcode("pushStringParam", i.stringModeValue, i.type),
                    "sexpr" === i.type && this.sexpr(i))
                  : this.accept(i),
                this.opcode("assignToHash", e[0]);
            this.opcode("popHash");
          },
          partial: function (t) {
            var e = t.partialName;
            (this.usePartial = !0),
              t.context ? this.ID(t.context) : this.opcode("push", "depth0"),
              this.opcode("invokePartial", e.name),
              this.opcode("append");
          },
          content: function (t) {
            this.opcode("appendContent", t.string);
          },
          mustache: function (t) {
            this.sexpr(t.sexpr),
              t.escaped && !this.options.noEscape
                ? this.opcode("appendEscaped")
                : this.opcode("append");
          },
          ambiguousSexpr: function (t, e, i) {
            var n = t.id,
              o = n.parts[0],
              s = null != e || null != i;
            this.opcode("getContext", n.depth),
              this.opcode("pushProgram", e),
              this.opcode("pushProgram", i),
              this.opcode("invokeAmbiguous", o, s);
          },
          simpleSexpr: function (t) {
            var e = t.id;
            "DATA" === e.type
              ? this.DATA(e)
              : e.parts.length
              ? this.ID(e)
              : (this.addDepth(e.depth),
                this.opcode("getContext", e.depth),
                this.opcode("pushContext")),
              this.opcode("resolvePossibleLambda");
          },
          helperSexpr: function (t, e, i) {
            var n = this.setupFullMustacheParams(t, e, i),
              o = t.id.parts[0];
            if (this.options.knownHelpers[o])
              this.opcode("invokeKnownHelper", n.length, o);
            else {
              if (this.options.knownHelpersOnly)
                throw new s(
                  "You specified knownHelpersOnly, but used the unknown helper " +
                    o,
                  t
                );
              this.opcode("invokeHelper", n.length, o, t.isRoot);
            }
          },
          sexpr: function (t) {
            var e = this.classifySexpr(t);
            "simple" === e
              ? this.simpleSexpr(t)
              : "helper" === e
              ? this.helperSexpr(t)
              : this.ambiguousSexpr(t);
          },
          ID: function (t) {
            this.addDepth(t.depth), this.opcode("getContext", t.depth);
            var e = t.parts[0];
            e
              ? this.opcode("lookupOnContext", t.parts[0])
              : this.opcode("pushContext");
            for (var i = 1, n = t.parts.length; n > i; i++)
              this.opcode("lookup", t.parts[i]);
          },
          DATA: function (t) {
            if (((this.options.data = !0), t.id.isScoped || t.id.depth))
              throw new s(
                "Scoped data references are not supported: " + t.original,
                t
              );
            this.opcode("lookupData");
            for (var e = t.id.parts, i = 0, n = e.length; n > i; i++)
              this.opcode("lookup", e[i]);
          },
          STRING: function (t) {
            this.opcode("pushString", t.string);
          },
          INTEGER: function (t) {
            this.opcode("pushLiteral", t.integer);
          },
          BOOLEAN: function (t) {
            this.opcode("pushLiteral", t.bool);
          },
          comment: function () {},
          opcode: function (t) {
            this.opcodes.push({ opcode: t, args: [].slice.call(arguments, 1) });
          },
          declare: function (t, e) {
            this.opcodes.push({ opcode: "DECLARE", name: t, value: e });
          },
          addDepth: function (t) {
            0 !== t &&
              (this.depths[t] ||
                ((this.depths[t] = !0), this.depths.list.push(t)));
          },
          classifySexpr: function (t) {
            var e = t.isHelper,
              i = t.eligibleHelper,
              n = this.options;
            if (i && !e) {
              var o = t.id.parts[0];
              n.knownHelpers[o] ? (e = !0) : n.knownHelpersOnly && (i = !1);
            }
            return e ? "helper" : i ? "ambiguous" : "simple";
          },
          pushParams: function (t) {
            for (var e, i = t.length; i--; )
              (e = t[i]),
                this.options.stringParams
                  ? (e.depth && this.addDepth(e.depth),
                    this.opcode("getContext", e.depth || 0),
                    this.opcode("pushStringParam", e.stringModeValue, e.type),
                    "sexpr" === e.type && this.sexpr(e))
                  : this[e.type](e);
          },
          setupFullMustacheParams: function (t, e, i) {
            var n = t.params;
            return (
              this.pushParams(n),
              this.opcode("pushProgram", e),
              this.opcode("pushProgram", i),
              t.hash ? this.hash(t.hash) : this.opcode("emptyHash"),
              n
            );
          },
        }),
        (o.precompile = i),
        (o.compile = n),
        o
      );
    })(i),
    u = (function (t, e) {
      "use strict";
      function i(t) {
        this.value = t;
      }
      function n() {}
      var o,
        s = t.COMPILER_REVISION,
        r = t.REVISION_CHANGES,
        a = t.log,
        l = e;
      n.prototype = {
        nameLookup: function (t, e) {
          var i, o;
          return (
            0 === t.indexOf("depth") && (i = !0),
            (o = /^[0-9]+$/.test(e)
              ? t + "[" + e + "]"
              : n.isValidJavaScriptVariableName(e)
              ? t + "." + e
              : t + "['" + e + "']"),
            i ? "(" + t + " && " + o + ")" : o
          );
        },
        compilerInfo: function () {
          var t = s,
            e = r[t];
          return "this.compilerInfo = [" + t + ",'" + e + "'];\n";
        },
        appendToBuffer: function (t) {
          return this.environment.isSimple
            ? "return " + t + ";"
            : {
                appendToBuffer: !0,
                content: t,
                toString: function () {
                  return "buffer += " + t + ";";
                },
              };
        },
        initializeBuffer: function () {
          return this.quotedString("");
        },
        namespace: "Handlebars",
        compile: function (t, e, i, n) {
          (this.environment = t),
            (this.options = e || {}),
            a("debug", this.environment.disassemble() + "\n\n"),
            (this.name = this.environment.name),
            (this.isChild = !!i),
            (this.context = i || {
              programs: [],
              environments: [],
              aliases: {},
            }),
            this.preamble(),
            (this.stackSlot = 0),
            (this.stackVars = []),
            (this.registers = { list: [] }),
            (this.hashes = []),
            (this.compileStack = []),
            (this.inlineStack = []),
            this.compileChildren(t, e);
          var o,
            s = t.opcodes;
          this.i = 0;
          for (var r = s.length; this.i < r; this.i++)
            (o = s[this.i]),
              "DECLARE" === o.opcode
                ? (this[o.name] = o.value)
                : this[o.opcode].apply(this, o.args),
              o.opcode !== this.stripNext && (this.stripNext = !1);
          if (
            (this.pushSource(""),
            this.stackSlot ||
              this.inlineStack.length ||
              this.compileStack.length)
          )
            throw new l("Compile completed with content left on stack");
          return this.createFunctionContext(n);
        },
        preamble: function () {
          var t = [];
          if (this.isChild) t.push("");
          else {
            var e = this.namespace,
              i = "helpers = this.merge(helpers, " + e + ".helpers);";
            this.environment.usePartial &&
              (i = i + " partials = this.merge(partials, " + e + ".partials);"),
              this.options.data && (i += " data = data || {};"),
              t.push(i);
          }
          this.environment.isSimple
            ? t.push("")
            : t.push(", buffer = " + this.initializeBuffer()),
            (this.lastContext = 0),
            (this.source = t);
        },
        createFunctionContext: function (t) {
          var e = this.stackVars.concat(this.registers.list);
          if (
            (e.length > 0 &&
              (this.source[1] = this.source[1] + ", " + e.join(", ")),
            !this.isChild)
          )
            for (var i in this.context.aliases)
              this.context.aliases.hasOwnProperty(i) &&
                (this.source[1] =
                  this.source[1] + ", " + i + "=" + this.context.aliases[i]);
          this.source[1] &&
            (this.source[1] = "var " + this.source[1].substring(2) + ";"),
            this.isChild ||
              (this.source[1] +=
                "\n" + this.context.programs.join("\n") + "\n"),
            this.environment.isSimple || this.pushSource("return buffer;");
          for (
            var n = this.isChild
                ? ["depth0", "data"]
                : ["Handlebars", "depth0", "helpers", "partials", "data"],
              o = 0,
              s = this.environment.depths.list.length;
            s > o;
            o++
          )
            n.push("depth" + this.environment.depths.list[o]);
          var r = this.mergeSource();
          if ((this.isChild || (r = this.compilerInfo() + r), t))
            return n.push(r), Function.apply(this, n);
          var l =
            "function " +
            (this.name || "") +
            "(" +
            n.join(",") +
            ") {\n  " +
            r +
            "}";
          return a("debug", l + "\n\n"), l;
        },
        mergeSource: function () {
          for (var t, e = "", i = 0, n = this.source.length; n > i; i++) {
            var o = this.source[i];
            o.appendToBuffer
              ? (t = t ? t + "\n    + " + o.content : o.content)
              : (t && ((e += "buffer += " + t + ";\n  "), (t = void 0)),
                (e += o + "\n  "));
          }
          return e;
        },
        blockValue: function () {
          this.context.aliases.blockHelperMissing =
            "helpers.blockHelperMissing";
          var t = ["depth0"];
          this.setupParams(0, t),
            this.replaceStack(function (e) {
              return (
                t.splice(1, 0, e),
                "blockHelperMissing.call(" + t.join(", ") + ")"
              );
            });
        },
        ambiguousBlockValue: function () {
          this.context.aliases.blockHelperMissing =
            "helpers.blockHelperMissing";
          var t = ["depth0"];
          this.setupParams(0, t);
          var e = this.topStack();
          t.splice(1, 0, e),
            this.pushSource(
              "if (!" +
                this.lastHelper +
                ") { " +
                e +
                " = blockHelperMissing.call(" +
                t.join(", ") +
                "); }"
            );
        },
        appendContent: function (t) {
          this.pendingContent && (t = this.pendingContent + t),
            this.stripNext && (t = t.replace(/^\s+/, "")),
            (this.pendingContent = t);
        },
        strip: function () {
          this.pendingContent &&
            (this.pendingContent = this.pendingContent.replace(/\s+$/, "")),
            (this.stripNext = "strip");
        },
        append: function () {
          this.flushInline();
          var t = this.popStack();
          this.pushSource(
            "if(" +
              t +
              " || " +
              t +
              " === 0) { " +
              this.appendToBuffer(t) +
              " }"
          ),
            this.environment.isSimple &&
              this.pushSource("else { " + this.appendToBuffer("''") + " }");
        },
        appendEscaped: function () {
          (this.context.aliases.escapeExpression = "this.escapeExpression"),
            this.pushSource(
              this.appendToBuffer("escapeExpression(" + this.popStack() + ")")
            );
        },
        getContext: function (t) {
          this.lastContext !== t && (this.lastContext = t);
        },
        lookupOnContext: function (t) {
          this.push(this.nameLookup("depth" + this.lastContext, t, "context"));
        },
        pushContext: function () {
          this.pushStackLiteral("depth" + this.lastContext);
        },
        resolvePossibleLambda: function () {
          (this.context.aliases.functionType = '"function"'),
            this.replaceStack(function (t) {
              return (
                "typeof " +
                t +
                " === functionType ? " +
                t +
                ".apply(depth0) : " +
                t
              );
            });
        },
        lookup: function (t) {
          this.replaceStack(function (e) {
            return (
              e +
              " == null || " +
              e +
              " === false ? " +
              e +
              " : " +
              this.nameLookup(e, t, "context")
            );
          });
        },
        lookupData: function () {
          this.pushStackLiteral("data");
        },
        pushStringParam: function (t, e) {
          this.pushStackLiteral("depth" + this.lastContext),
            this.pushString(e),
            "sexpr" !== e &&
              ("string" == typeof t
                ? this.pushString(t)
                : this.pushStackLiteral(t));
        },
        emptyHash: function () {
          this.pushStackLiteral("{}"),
            this.options.stringParams && (this.push("{}"), this.push("{}"));
        },
        pushHash: function () {
          this.hash && this.hashes.push(this.hash),
            (this.hash = { values: [], types: [], contexts: [] });
        },
        popHash: function () {
          var t = this.hash;
          (this.hash = this.hashes.pop()),
            this.options.stringParams &&
              (this.push("{" + t.contexts.join(",") + "}"),
              this.push("{" + t.types.join(",") + "}")),
            this.push("{\n    " + t.values.join(",\n    ") + "\n  }");
        },
        pushString: function (t) {
          this.pushStackLiteral(this.quotedString(t));
        },
        push: function (t) {
          return this.inlineStack.push(t), t;
        },
        pushLiteral: function (t) {
          this.pushStackLiteral(t);
        },
        pushProgram: function (t) {
          null != t
            ? this.pushStackLiteral(this.programExpression(t))
            : this.pushStackLiteral(null);
        },
        invokeHelper: function (t, e, i) {
          (this.context.aliases.helperMissing = "helpers.helperMissing"),
            this.useRegister("helper");
          var n = (this.lastHelper = this.setupHelper(t, e, !0)),
            o = this.nameLookup("depth" + this.lastContext, e, "context"),
            s = "helper = " + n.name + " || " + o;
          n.paramsInit && (s += "," + n.paramsInit),
            this.push(
              "(" +
                s +
                ",helper ? helper.call(" +
                n.callParams +
                ") : helperMissing.call(" +
                n.helperMissingParams +
                "))"
            ),
            i || this.flushInline();
        },
        invokeKnownHelper: function (t, e) {
          var i = this.setupHelper(t, e);
          this.push(i.name + ".call(" + i.callParams + ")");
        },
        invokeAmbiguous: function (t, e) {
          (this.context.aliases.functionType = '"function"'),
            this.useRegister("helper"),
            this.emptyHash();
          var i = this.setupHelper(0, t, e),
            n = (this.lastHelper = this.nameLookup("helpers", t, "helper")),
            o = this.nameLookup("depth" + this.lastContext, t, "context"),
            s = this.nextStack();
          i.paramsInit && this.pushSource(i.paramsInit),
            this.pushSource(
              "if (helper = " +
                n +
                ") { " +
                s +
                " = helper.call(" +
                i.callParams +
                "); }"
            ),
            this.pushSource(
              "else { helper = " +
                o +
                "; " +
                s +
                " = typeof helper === functionType ? helper.call(" +
                i.callParams +
                ") : helper; }"
            );
        },
        invokePartial: function (t) {
          var e = [
            this.nameLookup("partials", t, "partial"),
            "'" + t + "'",
            this.popStack(),
            "helpers",
            "partials",
          ];
          this.options.data && e.push("data"),
            (this.context.aliases.self = "this"),
            this.push("self.invokePartial(" + e.join(", ") + ")");
        },
        assignToHash: function (t) {
          var e,
            i,
            n = this.popStack();
          this.options.stringParams &&
            ((i = this.popStack()), (e = this.popStack()));
          var o = this.hash;
          e && o.contexts.push("'" + t + "': " + e),
            i && o.types.push("'" + t + "': " + i),
            o.values.push("'" + t + "': (" + n + ")");
        },
        compiler: n,
        compileChildren: function (t, e) {
          for (var i, n, o = t.children, s = 0, r = o.length; r > s; s++) {
            (i = o[s]), (n = new this.compiler());
            var a = this.matchExistingProgram(i);
            null == a
              ? (this.context.programs.push(""),
                (a = this.context.programs.length),
                (i.index = a),
                (i.name = "program" + a),
                (this.context.programs[a] = n.compile(i, e, this.context)),
                (this.context.environments[a] = i))
              : ((i.index = a), (i.name = "program" + a));
          }
        },
        matchExistingProgram: function (t) {
          for (var e = 0, i = this.context.environments.length; i > e; e++) {
            var n = this.context.environments[e];
            if (n && n.equals(t)) return e;
          }
        },
        programExpression: function (t) {
          if (((this.context.aliases.self = "this"), null == t))
            return "self.noop";
          for (
            var e,
              i = this.environment.children[t],
              n = i.depths.list,
              o = [i.index, i.name, "data"],
              s = 0,
              r = n.length;
            r > s;
            s++
          )
            (e = n[s]), 1 === e ? o.push("depth0") : o.push("depth" + (e - 1));
          return (
            (0 === n.length ? "self.program(" : "self.programWithDepth(") +
            o.join(", ") +
            ")"
          );
        },
        register: function (t, e) {
          this.useRegister(t), this.pushSource(t + " = " + e + ";");
        },
        useRegister: function (t) {
          this.registers[t] ||
            ((this.registers[t] = !0), this.registers.list.push(t));
        },
        pushStackLiteral: function (t) {
          return this.push(new i(t));
        },
        pushSource: function (t) {
          this.pendingContent &&
            (this.source.push(
              this.appendToBuffer(this.quotedString(this.pendingContent))
            ),
            (this.pendingContent = void 0)),
            t && this.source.push(t);
        },
        pushStack: function (t) {
          this.flushInline();
          var e = this.incrStack();
          return (
            t && this.pushSource(e + " = " + t + ";"),
            this.compileStack.push(e),
            e
          );
        },
        replaceStack: function (t) {
          var e,
            n,
            o,
            s = "",
            r = this.isInline();
          if (r) {
            var a = this.popStack(!0);
            if (a instanceof i) (e = a.value), (o = !0);
            else {
              n = !this.stackSlot;
              var l = n ? this.incrStack() : this.topStackName();
              (s = "(" + this.push(l) + " = " + a + "),"),
                (e = this.topStack());
            }
          } else e = this.topStack();
          var c = t.call(this, e);
          return (
            r
              ? (o || this.popStack(),
                n && this.stackSlot--,
                this.push("(" + s + c + ")"))
              : (/^stack/.test(e) || (e = this.nextStack()),
                this.pushSource(e + " = (" + s + c + ");")),
            e
          );
        },
        nextStack: function () {
          return this.pushStack();
        },
        incrStack: function () {
          return (
            this.stackSlot++,
            this.stackSlot > this.stackVars.length &&
              this.stackVars.push("stack" + this.stackSlot),
            this.topStackName()
          );
        },
        topStackName: function () {
          return "stack" + this.stackSlot;
        },
        flushInline: function () {
          var t = this.inlineStack;
          if (t.length) {
            this.inlineStack = [];
            for (var e = 0, n = t.length; n > e; e++) {
              var o = t[e];
              o instanceof i ? this.compileStack.push(o) : this.pushStack(o);
            }
          }
        },
        isInline: function () {
          return this.inlineStack.length;
        },
        popStack: function (t) {
          var e = this.isInline(),
            n = (e ? this.inlineStack : this.compileStack).pop();
          if (!t && n instanceof i) return n.value;
          if (!e) {
            if (!this.stackSlot) throw new l("Invalid stack pop");
            this.stackSlot--;
          }
          return n;
        },
        topStack: function (t) {
          var e = this.isInline() ? this.inlineStack : this.compileStack,
            n = e[e.length - 1];
          return !t && n instanceof i ? n.value : n;
        },
        quotedString: function (t) {
          return (
            '"' +
            t
              .replace(/\\/g, "\\\\")
              .replace(/"/g, '\\"')
              .replace(/\n/g, "\\n")
              .replace(/\r/g, "\\r")
              .replace(/\u2028/g, "\\u2028")
              .replace(/\u2029/g, "\\u2029") +
            '"'
          );
        },
        setupHelper: function (t, e, i) {
          var n = [],
            o = this.setupParams(t, n, i),
            s = this.nameLookup("helpers", e, "helper");
          return {
            params: n,
            paramsInit: o,
            name: s,
            callParams: ["depth0"].concat(n).join(", "),
            helperMissingParams:
              i && ["depth0", this.quotedString(e)].concat(n).join(", "),
          };
        },
        setupOptions: function (t, e) {
          var i,
            n,
            o,
            s = [],
            r = [],
            a = [];
          s.push("hash:" + this.popStack()),
            this.options.stringParams &&
              (s.push("hashTypes:" + this.popStack()),
              s.push("hashContexts:" + this.popStack())),
            (n = this.popStack()),
            (o = this.popStack()),
            (o || n) &&
              (o || ((this.context.aliases.self = "this"), (o = "self.noop")),
              n || ((this.context.aliases.self = "this"), (n = "self.noop")),
              s.push("inverse:" + n),
              s.push("fn:" + o));
          for (var l = 0; t > l; l++)
            (i = this.popStack()),
              e.push(i),
              this.options.stringParams &&
                (a.push(this.popStack()), r.push(this.popStack()));
          return (
            this.options.stringParams &&
              (s.push("contexts:[" + r.join(",") + "]"),
              s.push("types:[" + a.join(",") + "]")),
            this.options.data && s.push("data:data"),
            s
          );
        },
        setupParams: function (t, e, i) {
          var n = "{" + this.setupOptions(t, e).join(",") + "}";
          return i
            ? (this.useRegister("options"), e.push("options"), "options=" + n)
            : (e.push(n), "");
        },
      };
      for (
        var c =
            "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield".split(
              " "
            ),
          u = (n.RESERVED_WORDS = {}),
          h = 0,
          p = c.length;
        p > h;
        h++
      )
        u[c[h]] = !0;
      return (
        (n.isValidJavaScriptVariableName = function (t) {
          return !(
            n.RESERVED_WORDS[t] || !/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t)
          );
        }),
        (o = n)
      );
    })(n, i),
    h = (function (t, e, i, n, o) {
      "use strict";
      var s,
        r = t,
        a = e,
        l = i.parser,
        c = i.parse,
        u = n.Compiler,
        h = n.compile,
        p = n.precompile,
        d = o,
        f = r.create,
        m = function () {
          var t = f();
          return (
            (t.compile = function (e, i) {
              return h(e, i, t);
            }),
            (t.precompile = function (e, i) {
              return p(e, i, t);
            }),
            (t.AST = a),
            (t.Compiler = u),
            (t.JavaScriptCompiler = d),
            (t.Parser = l),
            (t.parse = c),
            t
          );
        };
      return (r = m()), (r.create = m), (s = r);
    })(s, r, l, c, u);
  return h;
})();
!(function (t) {
  "function" == typeof define && define.amd
    ? define(["jquery"], t)
    : "object" == typeof module && module.exports
    ? (module.exports = t(require("jquery")))
    : t(jQuery);
})(function (t) {
  var e = Array.prototype.slice,
    i = Array.prototype.splice,
    n = {
      topSpacing: 0,
      bottomSpacing: 0,
      className: "is-sticky",
      wrapperClassName: "sticky-wrapper",
      center: !1,
      getWidthFrom: "",
      widthFromWrapper: !0,
      responsiveWidth: !1,
      zIndex: "auto",
    },
    o = t(window),
    s = t(document),
    r = [],
    a = o.height(),
    l = function () {
      for (
        var e = o.scrollTop(),
          i = s.height(),
          n = i - a,
          l = e > n ? n - e : 0,
          c = 0,
          u = r.length;
        u > c;
        c++
      ) {
        var h = r[c],
          p = h.stickyWrapper.offset().top,
          d = p - h.topSpacing - l;
        if (
          (h.stickyWrapper.css("height", h.stickyElement.outerHeight()), d >= e)
        )
          null !== h.currentTop &&
            (h.stickyElement.css({
              width: "",
              position: "",
              top: "",
              "z-index": "",
            }),
            h.stickyElement.parent().removeClass(h.className),
            h.stickyElement.trigger("sticky-end", [h]),
            (h.currentTop = null));
        else {
          var f =
            i -
            h.stickyElement.outerHeight() -
            h.topSpacing -
            h.bottomSpacing -
            e -
            l;
          if (
            (0 > f ? (f += h.topSpacing) : (f = h.topSpacing),
            h.currentTop !== f)
          ) {
            var m;
            h.getWidthFrom
              ? (m = t(h.getWidthFrom).width() || null)
              : h.widthFromWrapper && (m = h.stickyWrapper.width()),
              null == m && (m = h.stickyElement.width()),
              h.stickyElement
                .css("width", m)
                .css("position", "fixed")
                .css("top", f)
                .css("z-index", h.zIndex),
              h.stickyElement.parent().addClass(h.className),
              null === h.currentTop
                ? h.stickyElement.trigger("sticky-start", [h])
                : h.stickyElement.trigger("sticky-update", [h]),
              (h.currentTop === h.topSpacing && h.currentTop > f) ||
              (null === h.currentTop && f < h.topSpacing)
                ? h.stickyElement.trigger("sticky-bottom-reached", [h])
                : null !== h.currentTop &&
                  f === h.topSpacing &&
                  h.currentTop < f &&
                  h.stickyElement.trigger("sticky-bottom-unreached", [h]),
              (h.currentTop = f);
          }
          var g = h.stickyWrapper.parent(),
            v =
              h.stickyElement.offset().top + h.stickyElement.outerHeight() >=
                g.offset().top + g.outerHeight() &&
              h.stickyElement.offset().top <= h.topSpacing;
          v
            ? h.stickyElement
                .css("position", "absolute")
                .css("top", "")
                .css("bottom", 0)
                .css("z-index", "")
            : h.stickyElement
                .css("position", "fixed")
                .css("top", f)
                .css("bottom", "")
                .css("z-index", h.zIndex);
        }
      }
    },
    c = function () {
      a = o.height();
      for (var e = 0, i = r.length; i > e; e++) {
        var n = r[e],
          s = null;
        n.getWidthFrom
          ? n.responsiveWidth && (s = t(n.getWidthFrom).width())
          : n.widthFromWrapper && (s = n.stickyWrapper.width()),
          null != s && n.stickyElement.css("width", s);
      }
    },
    u = {
      init: function (e) {
        return this.each(function () {
          var i = t.extend({}, n, e),
            o = t(this),
            s = o.attr("id"),
            a = s ? s + "-" + n.wrapperClassName : n.wrapperClassName,
            l = t("<div></div>").attr("id", a).addClass(i.wrapperClassName);
          o.wrapAll(function () {
            return 0 == t(this).parent("#" + a).length ? l : void 0;
          });
          var c = o.parent();
          i.center &&
            c.css({
              width: o.outerWidth(),
              marginLeft: "auto",
              marginRight: "auto",
            }),
            "right" === o.css("float") &&
              o.css({ float: "none" }).parent().css({ float: "right" }),
            (i.stickyElement = o),
            (i.stickyWrapper = c),
            (i.currentTop = null),
            r.push(i),
            u.setWrapperHeight(this),
            u.setupChangeListeners(this);
        });
      },
      setWrapperHeight: function (e) {
        var i = t(e),
          n = i.parent();
        n && n.css("height", i.outerHeight());
      },
      setupChangeListeners: function (t) {
        if (window.MutationObserver) {
          var e = new window.MutationObserver(function (e) {
            (e[0].addedNodes.length || e[0].removedNodes.length) &&
              u.setWrapperHeight(t);
          });
          e.observe(t, { subtree: !0, childList: !0 });
        } else
          window.addEventListener
            ? (t.addEventListener(
                "DOMNodeInserted",
                function () {
                  u.setWrapperHeight(t);
                },
                !1
              ),
              t.addEventListener(
                "DOMNodeRemoved",
                function () {
                  u.setWrapperHeight(t);
                },
                !1
              ))
            : window.attachEvent &&
              (t.attachEvent("onDOMNodeInserted", function () {
                u.setWrapperHeight(t);
              }),
              t.attachEvent("onDOMNodeRemoved", function () {
                u.setWrapperHeight(t);
              }));
      },
      update: l,
      unstick: function (e) {
        return this.each(function () {
          for (var e = this, n = t(e), o = -1, s = r.length; s-- > 0; )
            r[s].stickyElement.get(0) === e && (i.call(r, s, 1), (o = s));
          -1 !== o &&
            (n.unwrap(),
            n.css({
              width: "",
              position: "",
              top: "",
              float: "",
              "z-index": "",
            }));
        });
      },
    };
  window.addEventListener
    ? (window.addEventListener("scroll", l, !1),
      window.addEventListener("resize", c, !1))
    : window.attachEvent &&
      (window.attachEvent("onscroll", l), window.attachEvent("onresize", c)),
    (t.fn.sticky = function (i) {
      return u[i]
        ? u[i].apply(this, e.call(arguments, 1))
        : "object" != typeof i && i
        ? void t.error("Method " + i + " does not exist on jQuery.sticky")
        : u.init.apply(this, arguments);
    }),
    (t.fn.unstick = function (i) {
      return u[i]
        ? u[i].apply(this, e.call(arguments, 1))
        : "object" != typeof i && i
        ? void t.error("Method " + i + " does not exist on jQuery.sticky")
        : u.unstick.apply(this, arguments);
    }),
    t(function () {
      setTimeout(l, 0);
    });
}),
  !(function (t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], t)
      : "undefined" != typeof exports
      ? (module.exports = t(require("jquery")))
      : t(jQuery);
  })(function (t) {
    "use strict";
    var e = window.Slick || {};
    (e = (function () {
      function e(e, n) {
        var o,
          s = this;
        (s.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: t(e),
          appendDots: t(e),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
          nextArrow:
            '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (t, e) {
            return (
              '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' +
              (e + 1) +
              "</button>"
            );
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (s.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          t.extend(s, s.initials),
          (s.activeBreakpoint = null),
          (s.animType = null),
          (s.animProp = null),
          (s.breakpoints = []),
          (s.breakpointSettings = []),
          (s.cssTransitions = !1),
          (s.hidden = "hidden"),
          (s.paused = !1),
          (s.positionProp = null),
          (s.respondTo = null),
          (s.rowCount = 1),
          (s.shouldClick = !0),
          (s.$slider = t(e)),
          (s.$slidesCache = null),
          (s.transformType = null),
          (s.transitionType = null),
          (s.visibilityChange = "visibilitychange"),
          (s.windowWidth = 0),
          (s.windowTimer = null),
          (o = t(e).data("slick") || {}),
          (s.options = t.extend({}, s.defaults, o, n)),
          (s.currentSlide = s.options.initialSlide),
          (s.originalSettings = s.options),
          "undefined" != typeof document.mozHidden
            ? ((s.hidden = "mozHidden"),
              (s.visibilityChange = "mozvisibilitychange"))
            : "undefined" != typeof document.webkitHidden &&
              ((s.hidden = "webkitHidden"),
              (s.visibilityChange = "webkitvisibilitychange")),
          (s.autoPlay = t.proxy(s.autoPlay, s)),
          (s.autoPlayClear = t.proxy(s.autoPlayClear, s)),
          (s.changeSlide = t.proxy(s.changeSlide, s)),
          (s.clickHandler = t.proxy(s.clickHandler, s)),
          (s.selectHandler = t.proxy(s.selectHandler, s)),
          (s.setPosition = t.proxy(s.setPosition, s)),
          (s.swipeHandler = t.proxy(s.swipeHandler, s)),
          (s.dragHandler = t.proxy(s.dragHandler, s)),
          (s.keyHandler = t.proxy(s.keyHandler, s)),
          (s.autoPlayIterator = t.proxy(s.autoPlayIterator, s)),
          (s.instanceUid = i++),
          (s.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          s.registerBreakpoints(),
          s.init(!0),
          s.checkResponsive(!0);
      }
      var i = 0;
      return e;
    })()),
      (e.prototype.addSlide = e.prototype.slickAdd =
        function (e, i, n) {
          var o = this;
          if ("boolean" == typeof i) (n = i), (i = null);
          else if (0 > i || i >= o.slideCount) return !1;
          o.unload(),
            "number" == typeof i
              ? 0 === i && 0 === o.$slides.length
                ? t(e).appendTo(o.$slideTrack)
                : n
                ? t(e).insertBefore(o.$slides.eq(i))
                : t(e).insertAfter(o.$slides.eq(i))
              : n === !0
              ? t(e).prependTo(o.$slideTrack)
              : t(e).appendTo(o.$slideTrack),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            o.$slides.each(function (e, i) {
              t(i).attr("data-slick-index", e);
            }),
            (o.$slidesCache = o.$slides),
            o.reinit();
        }),
      (e.prototype.animateHeight = function () {
        var t = this;
        if (
          1 === t.options.slidesToShow &&
          t.options.adaptiveHeight === !0 &&
          t.options.vertical === !1
        ) {
          var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
          t.$list.animate({ height: e }, t.options.speed);
        }
      }),
      (e.prototype.animateSlide = function (e, i) {
        var n = {},
          o = this;
        o.animateHeight(),
          o.options.rtl === !0 && o.options.vertical === !1 && (e = -e),
          o.transformsEnabled === !1
            ? o.options.vertical === !1
              ? o.$slideTrack.animate(
                  { left: e },
                  o.options.speed,
                  o.options.easing,
                  i
                )
              : o.$slideTrack.animate(
                  { top: e },
                  o.options.speed,
                  o.options.easing,
                  i
                )
            : o.cssTransitions === !1
            ? (o.options.rtl === !0 && (o.currentLeft = -o.currentLeft),
              t({ animStart: o.currentLeft }).animate(
                { animStart: e },
                {
                  duration: o.options.speed,
                  easing: o.options.easing,
                  step: function (t) {
                    (t = Math.ceil(t)),
                      o.options.vertical === !1
                        ? ((n[o.animType] = "translate(" + t + "px, 0px)"),
                          o.$slideTrack.css(n))
                        : ((n[o.animType] = "translate(0px," + t + "px)"),
                          o.$slideTrack.css(n));
                  },
                  complete: function () {
                    i && i.call();
                  },
                }
              ))
            : (o.applyTransition(),
              (e = Math.ceil(e)),
              o.options.vertical === !1
                ? (n[o.animType] = "translate3d(" + e + "px, 0px, 0px)")
                : (n[o.animType] = "translate3d(0px," + e + "px, 0px)"),
              o.$slideTrack.css(n),
              i &&
                setTimeout(function () {
                  o.disableTransition(), i.call();
                }, o.options.speed));
      }),
      (e.prototype.asNavFor = function (e) {
        var i = this,
          n = i.options.asNavFor;
        n && null !== n && (n = t(n).not(i.$slider)),
          null !== n &&
            "object" == typeof n &&
            n.each(function () {
              var i = t(this).slick("getSlick");
              i.unslicked || i.slideHandler(e, !0);
            });
      }),
      (e.prototype.applyTransition = function (t) {
        var e = this,
          i = {};
        e.options.fade === !1
          ? (i[e.transitionType] =
              e.transformType +
              " " +
              e.options.speed +
              "ms " +
              e.options.cssEase)
          : (i[e.transitionType] =
              "opacity " + e.options.speed + "ms " + e.options.cssEase),
          e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
      }),
      (e.prototype.autoPlay = function () {
        var t = this;
        t.autoPlayTimer && clearInterval(t.autoPlayTimer),
          t.slideCount > t.options.slidesToShow &&
            t.paused !== !0 &&
            (t.autoPlayTimer = setInterval(
              t.autoPlayIterator,
              t.options.autoplaySpeed
            ));
      }),
      (e.prototype.autoPlayClear = function () {
        var t = this;
        t.autoPlayTimer && clearInterval(t.autoPlayTimer);
      }),
      (e.prototype.autoPlayIterator = function () {
        var t = this;
        t.options.infinite === !1
          ? 1 === t.direction
            ? (t.currentSlide + 1 === t.slideCount - 1 && (t.direction = 0),
              t.slideHandler(t.currentSlide + t.options.slidesToScroll))
            : (t.currentSlide - 1 === 0 && (t.direction = 1),
              t.slideHandler(t.currentSlide - t.options.slidesToScroll))
          : t.slideHandler(t.currentSlide + t.options.slidesToScroll);
      }),
      (e.prototype.buildArrows = function () {
        var e = this;
        e.options.arrows === !0 &&
          ((e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow")),
          (e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow")),
          e.slideCount > e.options.slidesToShow
            ? (e.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.prependTo(e.options.appendArrows),
              e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.appendTo(e.options.appendArrows),
              e.options.infinite !== !0 &&
                e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : e.$prevArrow
                .add(e.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (e.prototype.buildDots = function () {
        var e,
          i,
          n = this;
        if (n.options.dots === !0 && n.slideCount > n.options.slidesToShow) {
          for (
            i = '<ul class="' + n.options.dotsClass + '">', e = 0;
            e <= n.getDotCount();
            e += 1
          )
            i += "<li>" + n.options.customPaging.call(this, n, e) + "</li>";
          (i += "</ul>"),
            (n.$dots = t(i).appendTo(n.options.appendDots)),
            n.$dots
              .find("li")
              .first()
              .addClass("slick-active")
              .attr("aria-hidden", "false");
        }
      }),
      (e.prototype.buildOut = function () {
        var e = this;
        (e.$slides = e.$slider
          .children(e.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (e, i) {
            t(i)
              .attr("data-slick-index", e)
              .data("originalStyling", t(i).attr("style") || "");
          }),
          e.$slider.addClass("slick-slider"),
          (e.$slideTrack =
            0 === e.slideCount
              ? t('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack
            .wrap('<div aria-live="polite" class="slick-list"/>')
            .parent()),
          e.$slideTrack.css("opacity", 0),
          (e.options.centerMode === !0 || e.options.swipeToSlide === !0) &&
            (e.options.slidesToScroll = 1),
          t("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.options.draggable === !0 && e.$list.addClass("draggable");
      }),
      (e.prototype.buildRows = function () {
        var t,
          e,
          i,
          n,
          o,
          s,
          r,
          a = this;
        if (
          ((n = document.createDocumentFragment()),
          (s = a.$slider.children()),
          a.options.rows > 1)
        ) {
          for (
            r = a.options.slidesPerRow * a.options.rows,
              o = Math.ceil(s.length / r),
              t = 0;
            o > t;
            t++
          ) {
            var l = document.createElement("div");
            for (e = 0; e < a.options.rows; e++) {
              var c = document.createElement("div");
              for (i = 0; i < a.options.slidesPerRow; i++) {
                var u = t * r + (e * a.options.slidesPerRow + i);
                s.get(u) && c.appendChild(s.get(u));
              }
              l.appendChild(c);
            }
            n.appendChild(l);
          }
          a.$slider.html(n),
            a.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (e.prototype.checkResponsive = function (e, i) {
        var n,
          o,
          s,
          r = this,
          a = !1,
          l = r.$slider.width(),
          c = window.innerWidth || t(window).width();
        if (
          ("window" === r.respondTo
            ? (s = c)
            : "slider" === r.respondTo
            ? (s = l)
            : "min" === r.respondTo && (s = Math.min(c, l)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          o = null;
          for (n in r.breakpoints)
            r.breakpoints.hasOwnProperty(n) &&
              (r.originalSettings.mobileFirst === !1
                ? s < r.breakpoints[n] && (o = r.breakpoints[n])
                : s > r.breakpoints[n] && (o = r.breakpoints[n]));
          null !== o
            ? null !== r.activeBreakpoint
              ? (o !== r.activeBreakpoint || i) &&
                ((r.activeBreakpoint = o),
                "unslick" === r.breakpointSettings[o]
                  ? r.unslick(o)
                  : ((r.options = t.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[o]
                    )),
                    e === !0 && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (a = o))
              : ((r.activeBreakpoint = o),
                "unslick" === r.breakpointSettings[o]
                  ? r.unslick(o)
                  : ((r.options = t.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[o]
                    )),
                    e === !0 && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (a = o))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              e === !0 && (r.currentSlide = r.options.initialSlide),
              r.refresh(e),
              (a = o)),
            e || a === !1 || r.$slider.trigger("breakpoint", [r, a]);
        }
      }),
      (e.prototype.changeSlide = function (e, i) {
        var n,
          o,
          s,
          r = this,
          a = t(e.target);
        switch (
          (a.is("a") && e.preventDefault(),
          a.is("li") || (a = a.closest("li")),
          (s = r.slideCount % r.options.slidesToScroll !== 0),
          (n = s
            ? 0
            : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
          e.data.message)
        ) {
          case "previous":
            (o =
              0 === n ? r.options.slidesToScroll : r.options.slidesToShow - n),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide - o, !1, i);
            break;
          case "next":
            (o = 0 === n ? r.options.slidesToScroll : n),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide + o, !1, i);
            break;
          case "index":
            var l =
              0 === e.data.index
                ? 0
                : e.data.index || a.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(l), !1, i),
              a.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (e.prototype.checkNavigable = function (t) {
        var e,
          i,
          n = this;
        if (((e = n.getNavigableIndexes()), (i = 0), t > e[e.length - 1]))
          t = e[e.length - 1];
        else
          for (var o in e) {
            if (t < e[o]) {
              t = i;
              break;
            }
            i = e[o];
          }
        return t;
      }),
      (e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots &&
          null !== e.$dots &&
          (t("li", e.$dots).off("click.slick", e.changeSlide),
          e.options.pauseOnDotsHover === !0 &&
            e.options.autoplay === !0 &&
            t("li", e.$dots)
              .off("mouseenter.slick", t.proxy(e.setPaused, e, !0))
              .off("mouseleave.slick", t.proxy(e.setPaused, e, !1))),
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
          e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
          e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
          e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
          e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
          e.$list.off("click.slick", e.clickHandler),
          t(document).off(e.visibilityChange, e.visibility),
          e.$list.off("mouseenter.slick", t.proxy(e.setPaused, e, !0)),
          e.$list.off("mouseleave.slick", t.proxy(e.setPaused, e, !1)),
          e.options.accessibility === !0 &&
            e.$list.off("keydown.slick", e.keyHandler),
          e.options.focusOnSelect === !0 &&
            t(e.$slideTrack).children().off("click.slick", e.selectHandler),
          t(window).off(
            "orientationchange.slick.slick-" + e.instanceUid,
            e.orientationChange
          ),
          t(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
          t("[draggable!=true]", e.$slideTrack).off(
            "dragstart",
            e.preventDefault
          ),
          t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
          t(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
      }),
      (e.prototype.cleanUpRows = function () {
        var t,
          e = this;
        e.options.rows > 1 &&
          ((t = e.$slides.children().children()),
          t.removeAttr("style"),
          e.$slider.html(t));
      }),
      (e.prototype.clickHandler = function (t) {
        var e = this;
        e.shouldClick === !1 &&
          (t.stopImmediatePropagation(),
          t.stopPropagation(),
          t.preventDefault());
      }),
      (e.prototype.destroy = function (e) {
        var i = this;
        i.autoPlayClear(),
          (i.touchObject = {}),
          i.cleanUpEvents(),
          t(".slick-cloned", i.$slider).detach(),
          i.$dots && i.$dots.remove(),
          i.$prevArrow &&
            i.$prevArrow.length &&
            (i.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
          i.$nextArrow &&
            i.$nextArrow.length &&
            (i.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
          i.$slides &&
            (i.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                t(this).attr("style", t(this).data("originalStyling"));
              }),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.detach(),
            i.$list.detach(),
            i.$slider.append(i.$slides)),
          i.cleanUpRows(),
          i.$slider.removeClass("slick-slider"),
          i.$slider.removeClass("slick-initialized"),
          (i.unslicked = !0),
          e || i.$slider.trigger("destroy", [i]);
      }),
      (e.prototype.disableTransition = function (t) {
        var e = this,
          i = {};
        (i[e.transitionType] = ""),
          e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
      }),
      (e.prototype.fadeSlide = function (t, e) {
        var i = this;
        i.cssTransitions === !1
          ? (i.$slides.eq(t).css({ zIndex: i.options.zIndex }),
            i.$slides
              .eq(t)
              .animate({ opacity: 1 }, i.options.speed, i.options.easing, e))
          : (i.applyTransition(t),
            i.$slides.eq(t).css({ opacity: 1, zIndex: i.options.zIndex }),
            e &&
              setTimeout(function () {
                i.disableTransition(t), e.call();
              }, i.options.speed));
      }),
      (e.prototype.fadeSlideOut = function (t) {
        var e = this;
        e.cssTransitions === !1
          ? e.$slides
              .eq(t)
              .animate(
                { opacity: 0, zIndex: e.options.zIndex - 2 },
                e.options.speed,
                e.options.easing
              )
          : (e.applyTransition(t),
            e.$slides.eq(t).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
      }),
      (e.prototype.filterSlides = e.prototype.slickFilter =
        function (t) {
          console.log("run slickFilter:", t);
          var e = this;
          null !== t &&
            ((e.$slidesCache = e.$slides),
            e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.filter(t).appendTo(e.$slideTrack),
            e.reinit());
        }),
      (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
        function () {
          var t = this;
          return t.currentSlide;
        }),
      (e.prototype.getDotCount = function () {
        var t = this,
          e = 0,
          i = 0,
          n = 0;
        if (t.options.infinite === !0)
          for (; e < t.slideCount; )
            ++n,
              (e = i + t.options.slidesToScroll),
              (i +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
        else if (t.options.centerMode === !0) n = t.slideCount;
        else
          for (; e < t.slideCount; )
            ++n,
              (e = i + t.options.slidesToScroll),
              (i +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
        return n - 1;
      }),
      (e.prototype.getLeft = function (t) {
        var e,
          i,
          n,
          o = this,
          s = 0;
        return (
          (o.slideOffset = 0),
          (i = o.$slides.first().outerHeight(!0)),
          o.options.infinite === !0
            ? (o.slideCount > o.options.slidesToShow &&
                ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1),
                (s = i * o.options.slidesToShow * -1)),
              o.slideCount % o.options.slidesToScroll !== 0 &&
                t + o.options.slidesToScroll > o.slideCount &&
                o.slideCount > o.options.slidesToShow &&
                (t > o.slideCount
                  ? ((o.slideOffset =
                      (o.options.slidesToShow - (t - o.slideCount)) *
                      o.slideWidth *
                      -1),
                    (s =
                      (o.options.slidesToShow - (t - o.slideCount)) * i * -1))
                  : ((o.slideOffset =
                      (o.slideCount % o.options.slidesToScroll) *
                      o.slideWidth *
                      -1),
                    (s = (o.slideCount % o.options.slidesToScroll) * i * -1))))
            : t + o.options.slidesToShow > o.slideCount &&
              ((o.slideOffset =
                (t + o.options.slidesToShow - o.slideCount) * o.slideWidth),
              (s = (t + o.options.slidesToShow - o.slideCount) * i)),
          o.slideCount <= o.options.slidesToShow &&
            ((o.slideOffset = 0), (s = 0)),
          o.options.centerMode === !0 && o.options.infinite === !0
            ? (o.slideOffset +=
                o.slideWidth * Math.floor(o.options.slidesToShow / 2) -
                o.slideWidth)
            : o.options.centerMode === !0 &&
              ((o.slideOffset = 0),
              (o.slideOffset +=
                o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
          (e =
            o.options.vertical === !1
              ? t * o.slideWidth * -1 + o.slideOffset
              : t * i * -1 + s),
          o.options.variableWidth === !0 &&
            ((n =
              o.slideCount <= o.options.slidesToShow ||
              o.options.infinite === !1
                ? o.$slideTrack.children(".slick-slide").eq(t)
                : o.$slideTrack
                    .children(".slick-slide")
                    .eq(t + o.options.slidesToShow)),
            (e =
              o.options.rtl === !0
                ? n[0]
                  ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width())
                  : 0
                : n[0]
                ? -1 * n[0].offsetLeft
                : 0),
            o.options.centerMode === !0 &&
              ((n =
                o.slideCount <= o.options.slidesToShow ||
                o.options.infinite === !1
                  ? o.$slideTrack.children(".slick-slide").eq(t)
                  : o.$slideTrack
                      .children(".slick-slide")
                      .eq(t + o.options.slidesToShow + 1)),
              (e =
                o.options.rtl === !0
                  ? n[0]
                    ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width())
                    : 0
                  : n[0]
                  ? -1 * n[0].offsetLeft
                  : 0),
              (e += (o.$list.width() - n.outerWidth()) / 2))),
          e
        );
      }),
      (e.prototype.getOption = e.prototype.slickGetOption =
        function (t) {
          var e = this;
          return e.options[t];
        }),
      (e.prototype.getNavigableIndexes = function () {
        var t,
          e = this,
          i = 0,
          n = 0,
          o = [];
        for (
          e.options.infinite === !1
            ? (t = e.slideCount)
            : ((i = -1 * e.options.slidesToScroll),
              (n = -1 * e.options.slidesToScroll),
              (t = 2 * e.slideCount));
          t > i;

        )
          o.push(i),
            (i = n + e.options.slidesToScroll),
            (n +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        return o;
      }),
      (e.prototype.getSlick = function () {
        return this;
      }),
      (e.prototype.getSlideCount = function () {
        var e,
          i,
          n,
          o = this;
        return (
          (n =
            o.options.centerMode === !0
              ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
              : 0),
          o.options.swipeToSlide === !0
            ? (o.$slideTrack.find(".slick-slide").each(function (e, s) {
                return s.offsetLeft - n + t(s).outerWidth() / 2 >
                  -1 * o.swipeLeft
                  ? ((i = s), !1)
                  : void 0;
              }),
              (e =
                Math.abs(t(i).attr("data-slick-index") - o.currentSlide) || 1))
            : o.options.slidesToScroll
        );
      }),
      (e.prototype.goTo = e.prototype.slickGoTo =
        function (t, e) {
          var i = this;
          i.changeSlide({ data: { message: "index", index: parseInt(t) } }, e);
        }),
      (e.prototype.init = function (e) {
        var i = this;
        t(i.$slider).hasClass("slick-initialized") ||
          (t(i.$slider).addClass("slick-initialized"),
          i.buildRows(),
          i.buildOut(),
          i.setProps(),
          i.startLoad(),
          i.loadSlider(),
          i.initializeEvents(),
          i.updateArrows(),
          i.updateDots()),
          e && i.$slider.trigger("init", [i]),
          i.options.accessibility === !0 && i.initADA();
      }),
      (e.prototype.initArrowEvents = function () {
        var t = this;
        t.options.arrows === !0 &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.on(
            "click.slick",
            { message: "previous" },
            t.changeSlide
          ),
          t.$nextArrow.on("click.slick", { message: "next" }, t.changeSlide));
      }),
      (e.prototype.initDotEvents = function () {
        var e = this;
        e.options.dots === !0 &&
          e.slideCount > e.options.slidesToShow &&
          t("li", e.$dots).on(
            "click.slick",
            { message: "index" },
            e.changeSlide
          ),
          e.options.dots === !0 &&
            e.options.pauseOnDotsHover === !0 &&
            e.options.autoplay === !0 &&
            t("li", e.$dots)
              .on("mouseenter.slick", t.proxy(e.setPaused, e, !0))
              .on("mouseleave.slick", t.proxy(e.setPaused, e, !1));
      }),
      (e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(),
          e.initDotEvents(),
          e.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on("click.slick", e.clickHandler),
          t(document).on(e.visibilityChange, t.proxy(e.visibility, e)),
          e.$list.on("mouseenter.slick", t.proxy(e.setPaused, e, !0)),
          e.$list.on("mouseleave.slick", t.proxy(e.setPaused, e, !1)),
          e.options.accessibility === !0 &&
            e.$list.on("keydown.slick", e.keyHandler),
          e.options.focusOnSelect === !0 &&
            t(e.$slideTrack).children().on("click.slick", e.selectHandler),
          t(window).on(
            "orientationchange.slick.slick-" + e.instanceUid,
            t.proxy(e.orientationChange, e)
          ),
          t(window).on(
            "resize.slick.slick-" + e.instanceUid,
            t.proxy(e.resize, e)
          ),
          t("[draggable!=true]", e.$slideTrack).on(
            "dragstart",
            e.preventDefault
          ),
          t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
          t(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
      }),
      (e.prototype.initUI = function () {
        var t = this;
        t.options.arrows === !0 &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.show(), t.$nextArrow.show()),
          t.options.dots === !0 &&
            t.slideCount > t.options.slidesToShow &&
            t.$dots.show(),
          t.options.autoplay === !0 && t.autoPlay();
      }),
      (e.prototype.keyHandler = function (t) {
        var e = this;
        t.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === t.keyCode && e.options.accessibility === !0
            ? e.changeSlide({ data: { message: "previous" } })
            : 39 === t.keyCode &&
              e.options.accessibility === !0 &&
              e.changeSlide({ data: { message: "next" } }));
      }),
      (e.prototype.lazyLoad = function () {
        function e(e) {
          t("img[data-lazy]", e).each(function () {
            var e = t(this),
              i = t(this).attr("data-lazy"),
              n = document.createElement("img");
            (n.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                e.attr("src", i).animate({ opacity: 1 }, 200, function () {
                  e.removeAttr("data-lazy").removeClass("slick-loading");
                });
              });
            }),
              (n.src = i);
          });
        }
        var i,
          n,
          o,
          s,
          r = this;
        r.options.centerMode === !0
          ? r.options.infinite === !0
            ? ((o = r.currentSlide + (r.options.slidesToShow / 2 + 1)),
              (s = o + r.options.slidesToShow + 2))
            : ((o = Math.max(
                0,
                r.currentSlide - (r.options.slidesToShow / 2 + 1)
              )),
              (s = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide))
          : ((o = r.options.infinite
              ? r.options.slidesToShow + r.currentSlide
              : r.currentSlide),
            (s = o + r.options.slidesToShow),
            r.options.fade === !0 && (o > 0 && o--, s <= r.slideCount && s++)),
          (i = r.$slider.find(".slick-slide").slice(o, s)),
          e(i),
          r.slideCount <= r.options.slidesToShow
            ? ((n = r.$slider.find(".slick-slide")), e(n))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? ((n = r.$slider
                .find(".slick-cloned")
                .slice(0, r.options.slidesToShow)),
              e(n))
            : 0 === r.currentSlide &&
              ((n = r.$slider
                .find(".slick-cloned")
                .slice(-1 * r.options.slidesToShow)),
              e(n));
      }),
      (e.prototype.loadSlider = function () {
        var t = this;
        t.setPosition(),
          t.$slideTrack.css({ opacity: 1 }),
          t.$slider.removeClass("slick-loading"),
          t.initUI(),
          "progressive" === t.options.lazyLoad && t.progressiveLazyLoad();
      }),
      (e.prototype.next = e.prototype.slickNext =
        function () {
          var t = this;
          t.changeSlide({ data: { message: "next" } });
        }),
      (e.prototype.orientationChange = function () {
        var t = this;
        t.checkResponsive(), t.setPosition();
      }),
      (e.prototype.pause = e.prototype.slickPause =
        function () {
          var t = this;
          t.autoPlayClear(), (t.paused = !0);
        }),
      (e.prototype.play = e.prototype.slickPlay =
        function () {
          var t = this;
          (t.paused = !1), t.autoPlay();
        }),
      (e.prototype.postSlide = function (t) {
        var e = this;
        e.$slider.trigger("afterChange", [e, t]),
          (e.animating = !1),
          e.setPosition(),
          (e.swipeLeft = null),
          e.options.autoplay === !0 && e.paused === !1 && e.autoPlay(),
          e.options.accessibility === !0 && e.initADA();
      }),
      (e.prototype.prev = e.prototype.slickPrev =
        function () {
          var t = this;
          t.changeSlide({ data: { message: "previous" } });
        }),
      (e.prototype.preventDefault = function (t) {
        t.preventDefault();
      }),
      (e.prototype.progressiveLazyLoad = function () {
        var e,
          i,
          n = this;
        (e = t("img[data-lazy]", n.$slider).length),
          e > 0 &&
            ((i = t("img[data-lazy]", n.$slider).first()),
            i.attr("src", null),
            i
              .attr("src", i.attr("data-lazy"))
              .removeClass("slick-loading")
              .load(function () {
                i.removeAttr("data-lazy"),
                  n.progressiveLazyLoad(),
                  n.options.adaptiveHeight === !0 && n.setPosition();
              })
              .error(function () {
                i.removeAttr("data-lazy"), n.progressiveLazyLoad();
              }));
      }),
      (e.prototype.refresh = function (e) {
        var i,
          n,
          o = this;
        (n = o.slideCount - o.options.slidesToShow),
          o.options.infinite ||
            (o.slideCount <= o.options.slidesToShow
              ? (o.currentSlide = 0)
              : o.currentSlide > n && (o.currentSlide = n)),
          (i = o.currentSlide),
          o.destroy(!0),
          t.extend(o, o.initials, { currentSlide: i }),
          o.init(),
          e || o.changeSlide({ data: { message: "index", index: i } }, !1);
      }),
      (e.prototype.registerBreakpoints = function () {
        var e,
          i,
          n,
          o = this,
          s = o.options.responsive || null;
        if ("array" === t.type(s) && s.length) {
          o.respondTo = o.options.respondTo || "window";
          for (e in s)
            if (
              ((n = o.breakpoints.length - 1),
              (i = s[e].breakpoint),
              s.hasOwnProperty(e))
            ) {
              for (; n >= 0; )
                o.breakpoints[n] &&
                  o.breakpoints[n] === i &&
                  o.breakpoints.splice(n, 1),
                  n--;
              o.breakpoints.push(i), (o.breakpointSettings[i] = s[e].settings);
            }
          o.breakpoints.sort(function (t, e) {
            return o.options.mobileFirst ? t - e : e - t;
          });
        }
      }),
      (e.prototype.reinit = function () {
        var e = this;
        (e.$slides = e.$slideTrack
          .children(e.options.slide)
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.currentSlide >= e.slideCount &&
            0 !== e.currentSlide &&
            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
          e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
          e.registerBreakpoints(),
          e.setProps(),
          e.setupInfinite(),
          e.buildArrows(),
          e.updateArrows(),
          e.initArrowEvents(),
          e.buildDots(),
          e.updateDots(),
          e.initDotEvents(),
          e.checkResponsive(!1, !0),
          e.options.focusOnSelect === !0 &&
            t(e.$slideTrack).children().on("click.slick", e.selectHandler),
          e.setSlideClasses(0),
          e.setPosition(),
          e.$slider.trigger("reInit", [e]),
          e.options.autoplay === !0 && e.focusHandler();
      }),
      (e.prototype.resize = function () {
        var e = this;
        t(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            (e.windowWidth = t(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition();
          }, 50)));
      }),
      (e.prototype.removeSlide = e.prototype.slickRemove =
        function (t, e, i) {
          var n = this;
          return (
            "boolean" == typeof t
              ? ((e = t), (t = e === !0 ? 0 : n.slideCount - 1))
              : (t = e === !0 ? --t : t),
            n.slideCount < 1 || 0 > t || t > n.slideCount - 1
              ? !1
              : (n.unload(),
                i === !0
                  ? n.$slideTrack.children().remove()
                  : n.$slideTrack.children(this.options.slide).eq(t).remove(),
                (n.$slides = n.$slideTrack.children(this.options.slide)),
                n.$slideTrack.children(this.options.slide).detach(),
                n.$slideTrack.append(n.$slides),
                (n.$slidesCache = n.$slides),
                void n.reinit())
          );
        }),
      (e.prototype.setCSS = function (t) {
        var e,
          i,
          n = this,
          o = {};
        n.options.rtl === !0 && (t = -t),
          (e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px"),
          (i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px"),
          (o[n.positionProp] = t),
          n.transformsEnabled === !1
            ? n.$slideTrack.css(o)
            : ((o = {}),
              n.cssTransitions === !1
                ? ((o[n.animType] = "translate(" + e + ", " + i + ")"),
                  n.$slideTrack.css(o))
                : ((o[n.animType] = "translate3d(" + e + ", " + i + ", 0px)"),
                  n.$slideTrack.css(o)));
      }),
      (e.prototype.setDimensions = function () {
        var t = this;
        t.options.vertical === !1
          ? t.options.centerMode === !0 &&
            t.$list.css({ padding: "0px " + t.options.centerPadding })
          : (t.$list.height(
              t.$slides.first().outerHeight(!0) * t.options.slidesToShow
            ),
            t.options.centerMode === !0 &&
              t.$list.css({ padding: t.options.centerPadding + " 0px" })),
          (t.listWidth = t.$list.width()),
          (t.listHeight = t.$list.height()),
          t.options.vertical === !1 && t.options.variableWidth === !1
            ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)),
              t.$slideTrack.width(
                Math.ceil(
                  t.slideWidth * t.$slideTrack.children(".slick-slide").length
                )
              ))
            : t.options.variableWidth === !0
            ? t.$slideTrack.width(5e3 * t.slideCount)
            : ((t.slideWidth = Math.ceil(t.listWidth)),
              t.$slideTrack.height(
                Math.ceil(
                  t.$slides.first().outerHeight(!0) *
                    t.$slideTrack.children(".slick-slide").length
                )
              ));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        t.options.variableWidth === !1 &&
          t.$slideTrack.children(".slick-slide").width(t.slideWidth - e);
      }),
      (e.prototype.setFade = function () {
        var e,
          i = this;
        i.$slides.each(function (n, o) {
          (e = i.slideWidth * n * -1),
            i.options.rtl === !0
              ? t(o).css({
                  position: "relative",
                  right: e,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                })
              : t(o).css({
                  position: "relative",
                  left: e,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          i.$slides
            .eq(i.currentSlide)
            .css({ zIndex: i.options.zIndex - 1, opacity: 1 });
      }),
      (e.prototype.setHeight = function () {
        var t = this;
        if (
          1 === t.options.slidesToShow &&
          t.options.adaptiveHeight === !0 &&
          t.options.vertical === !1
        ) {
          var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
          t.$list.css("height", e);
        }
      }),
      (e.prototype.setOption = e.prototype.slickSetOption =
        function (e, i, n) {
          var o,
            s,
            r = this;
          if ("responsive" === e && "array" === t.type(i))
            for (s in i)
              if ("array" !== t.type(r.options.responsive))
                r.options.responsive = [i[s]];
              else {
                for (o = r.options.responsive.length - 1; o >= 0; )
                  r.options.responsive[o].breakpoint === i[s].breakpoint &&
                    r.options.responsive.splice(o, 1),
                    o--;
                r.options.responsive.push(i[s]);
              }
          else r.options[e] = i;
          n === !0 && (r.unload(), r.reinit());
        }),
      (e.prototype.setPosition = function () {
        var t = this;
        t.setDimensions(),
          t.setHeight(),
          t.options.fade === !1
            ? t.setCSS(t.getLeft(t.currentSlide))
            : t.setFade(),
          t.$slider.trigger("setPosition", [t]);
      }),
      (e.prototype.setProps = function () {
        var t = this,
          e = document.body.style;
        (t.positionProp = t.options.vertical === !0 ? "top" : "left"),
          "top" === t.positionProp
            ? t.$slider.addClass("slick-vertical")
            : t.$slider.removeClass("slick-vertical"),
          (void 0 !== e.WebkitTransition ||
            void 0 !== e.MozTransition ||
            void 0 !== e.msTransition) &&
            t.options.useCSS === !0 &&
            (t.cssTransitions = !0),
          t.options.fade &&
            ("number" == typeof t.options.zIndex
              ? t.options.zIndex < 3 && (t.options.zIndex = 3)
              : (t.options.zIndex = t.defaults.zIndex)),
          void 0 !== e.OTransform &&
            ((t.animType = "OTransform"),
            (t.transformType = "-o-transform"),
            (t.transitionType = "OTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (t.animType = !1)),
          void 0 !== e.MozTransform &&
            ((t.animType = "MozTransform"),
            (t.transformType = "-moz-transform"),
            (t.transitionType = "MozTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.MozPerspective &&
              (t.animType = !1)),
          void 0 !== e.webkitTransform &&
            ((t.animType = "webkitTransform"),
            (t.transformType = "-webkit-transform"),
            (t.transitionType = "webkitTransition"),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (t.animType = !1)),
          void 0 !== e.msTransform &&
            ((t.animType = "msTransform"),
            (t.transformType = "-ms-transform"),
            (t.transitionType = "msTransition"),
            void 0 === e.msTransform && (t.animType = !1)),
          void 0 !== e.transform &&
            t.animType !== !1 &&
            ((t.animType = "transform"),
            (t.transformType = "transform"),
            (t.transitionType = "transition")),
          (t.transformsEnabled =
            t.options.useTransform && null !== t.animType && t.animType !== !1);
      }),
      (e.prototype.setSlideClasses = function (t) {
        var e,
          i,
          n,
          o,
          s = this;
        (i = s.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
          s.$slides.eq(t).addClass("slick-current"),
          s.options.centerMode === !0
            ? ((e = Math.floor(s.options.slidesToShow / 2)),
              s.options.infinite === !0 &&
                (t >= e && t <= s.slideCount - 1 - e
                  ? s.$slides
                      .slice(t - e, t + e + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((n = s.options.slidesToShow + t),
                    i
                      .slice(n - e + 1, n + e + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === t
                  ? i
                      .eq(i.length - 1 - s.options.slidesToShow)
                      .addClass("slick-center")
                  : t === s.slideCount - 1 &&
                    i.eq(s.options.slidesToShow).addClass("slick-center")),
              s.$slides.eq(t).addClass("slick-center"))
            : t >= 0 && t <= s.slideCount - s.options.slidesToShow
            ? s.$slides
                .slice(t, t + s.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : i.length <= s.options.slidesToShow
            ? i.addClass("slick-active").attr("aria-hidden", "false")
            : ((o = s.slideCount % s.options.slidesToShow),
              (n = s.options.infinite === !0 ? s.options.slidesToShow + t : t),
              s.options.slidesToShow == s.options.slidesToScroll &&
              s.slideCount - t < s.options.slidesToShow
                ? i
                    .slice(n - (s.options.slidesToShow - o), n + o)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : i
                    .slice(n, n + s.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
          "ondemand" === s.options.lazyLoad && s.lazyLoad();
      }),
      (e.prototype.setupInfinite = function () {
        var e,
          i,
          n,
          o = this;
        if (
          (o.options.fade === !0 && (o.options.centerMode = !1),
          o.options.infinite === !0 &&
            o.options.fade === !1 &&
            ((i = null), o.slideCount > o.options.slidesToShow))
        ) {
          for (
            n =
              o.options.centerMode === !0
                ? o.options.slidesToShow + 1
                : o.options.slidesToShow,
              e = o.slideCount;
            e > o.slideCount - n;
            e -= 1
          )
            (i = e - 1),
              t(o.$slides[i])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", i - o.slideCount)
                .prependTo(o.$slideTrack)
                .addClass("slick-cloned");
          for (e = 0; n > e; e += 1)
            (i = e),
              t(o.$slides[i])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", i + o.slideCount)
                .appendTo(o.$slideTrack)
                .addClass("slick-cloned");
          o.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              t(this).attr("id", "");
            });
        }
      }),
      (e.prototype.setPaused = function (t) {
        var e = this;
        e.options.autoplay === !0 &&
          e.options.pauseOnHover === !0 &&
          ((e.paused = t), t ? e.autoPlayClear() : e.autoPlay());
      }),
      (e.prototype.selectHandler = function (e) {
        var i = this,
          n = t(e.target).is(".slick-slide")
            ? t(e.target)
            : t(e.target).parents(".slick-slide"),
          o = parseInt(n.attr("data-slick-index"));
        return (
          o || (o = 0),
          i.slideCount <= i.options.slidesToShow
            ? (i.setSlideClasses(o), void i.asNavFor(o))
            : void i.slideHandler(o)
        );
      }),
      (e.prototype.slideHandler = function (t, e, i) {
        var n,
          o,
          s,
          r,
          a = null,
          l = this;
        return (
          (e = e || !1),
          (l.animating === !0 && l.options.waitForAnimate === !0) ||
          (l.options.fade === !0 && l.currentSlide === t) ||
          l.slideCount <= l.options.slidesToShow
            ? void 0
            : (e === !1 && l.asNavFor(t),
              (n = t),
              (a = l.getLeft(n)),
              (r = l.getLeft(l.currentSlide)),
              (l.currentLeft = null === l.swipeLeft ? r : l.swipeLeft),
              l.options.infinite === !1 &&
              l.options.centerMode === !1 &&
              (0 > t || t > l.getDotCount() * l.options.slidesToScroll)
                ? void (
                    l.options.fade === !1 &&
                    ((n = l.currentSlide),
                    i !== !0
                      ? l.animateSlide(r, function () {
                          l.postSlide(n);
                        })
                      : l.postSlide(n))
                  )
                : l.options.infinite === !1 &&
                  l.options.centerMode === !0 &&
                  (0 > t || t > l.slideCount - l.options.slidesToScroll)
                ? void (
                    l.options.fade === !1 &&
                    ((n = l.currentSlide),
                    i !== !0
                      ? l.animateSlide(r, function () {
                          l.postSlide(n);
                        })
                      : l.postSlide(n))
                  )
                : (l.options.autoplay === !0 && clearInterval(l.autoPlayTimer),
                  (o =
                    0 > n
                      ? l.slideCount % l.options.slidesToScroll !== 0
                        ? l.slideCount -
                          (l.slideCount % l.options.slidesToScroll)
                        : l.slideCount + n
                      : n >= l.slideCount
                      ? l.slideCount % l.options.slidesToScroll !== 0
                        ? 0
                        : n - l.slideCount
                      : n),
                  (l.animating = !0),
                  l.$slider.trigger("beforeChange", [l, l.currentSlide, o]),
                  (s = l.currentSlide),
                  (l.currentSlide = o),
                  l.setSlideClasses(l.currentSlide),
                  l.updateDots(),
                  l.updateArrows(),
                  l.options.fade === !0
                    ? (i !== !0
                        ? (l.fadeSlideOut(s),
                          l.fadeSlide(o, function () {
                            l.postSlide(o);
                          }))
                        : l.postSlide(o),
                      void l.animateHeight())
                    : void (i !== !0
                        ? l.animateSlide(a, function () {
                            l.postSlide(o);
                          })
                        : l.postSlide(o))))
        );
      }),
      (e.prototype.startLoad = function () {
        var t = this;
        t.options.arrows === !0 &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.hide(), t.$nextArrow.hide()),
          t.options.dots === !0 &&
            t.slideCount > t.options.slidesToShow &&
            t.$dots.hide(),
          t.$slider.addClass("slick-loading");
      }),
      (e.prototype.swipeDirection = function () {
        var t,
          e,
          i,
          n,
          o = this;
        return (
          (t = o.touchObject.startX - o.touchObject.curX),
          (e = o.touchObject.startY - o.touchObject.curY),
          (i = Math.atan2(e, t)),
          (n = Math.round((180 * i) / Math.PI)),
          0 > n && (n = 360 - Math.abs(n)),
          45 >= n && n >= 0
            ? o.options.rtl === !1
              ? "left"
              : "right"
            : 360 >= n && n >= 315
            ? o.options.rtl === !1
              ? "left"
              : "right"
            : n >= 135 && 225 >= n
            ? o.options.rtl === !1
              ? "right"
              : "left"
            : o.options.verticalSwiping === !0
            ? n >= 35 && 135 >= n
              ? "left"
              : "right"
            : "vertical"
        );
      }),
      (e.prototype.swipeEnd = function (t) {
        var e,
          i = this;
        if (
          ((i.dragging = !1),
          (i.shouldClick = !(i.touchObject.swipeLength > 10)),
          void 0 === i.touchObject.curX)
        )
          return !1;
        if (
          (i.touchObject.edgeHit === !0 &&
            i.$slider.trigger("edge", [i, i.swipeDirection()]),
          i.touchObject.swipeLength >= i.touchObject.minSwipe)
        )
          switch (i.swipeDirection()) {
            case "left":
              (e = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide + i.getSlideCount())
                : i.currentSlide + i.getSlideCount()),
                i.slideHandler(e),
                (i.currentDirection = 0),
                (i.touchObject = {}),
                i.$slider.trigger("swipe", [i, "left"]);
              break;
            case "right":
              (e = i.options.swipeToSlide
                ? i.checkNavigable(i.currentSlide - i.getSlideCount())
                : i.currentSlide - i.getSlideCount()),
                i.slideHandler(e),
                (i.currentDirection = 1),
                (i.touchObject = {}),
                i.$slider.trigger("swipe", [i, "right"]);
          }
        else
          i.touchObject.startX !== i.touchObject.curX &&
            (i.slideHandler(i.currentSlide), (i.touchObject = {}));
      }),
      (e.prototype.swipeHandler = function (t) {
        var e = this;
        if (
          !(
            e.options.swipe === !1 ||
            ("ontouchend" in document && e.options.swipe === !1) ||
            (e.options.draggable === !1 && -1 !== t.type.indexOf("mouse"))
          )
        )
          switch (
            ((e.touchObject.fingerCount =
              t.originalEvent && void 0 !== t.originalEvent.touches
                ? t.originalEvent.touches.length
                : 1),
            (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
            e.options.verticalSwiping === !0 &&
              (e.touchObject.minSwipe =
                e.listHeight / e.options.touchThreshold),
            t.data.action)
          ) {
            case "start":
              e.swipeStart(t);
              break;
            case "move":
              e.swipeMove(t);
              break;
            case "end":
              e.swipeEnd(t);
          }
      }),
      (e.prototype.swipeMove = function (t) {
        var e,
          i,
          n,
          o,
          s,
          r = this;
        return (
          (s = void 0 !== t.originalEvent ? t.originalEvent.touches : null),
          !r.dragging || (s && 1 !== s.length)
            ? !1
            : ((e = r.getLeft(r.currentSlide)),
              (r.touchObject.curX = void 0 !== s ? s[0].pageX : t.clientX),
              (r.touchObject.curY = void 0 !== s ? s[0].pageY : t.clientY),
              (r.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(r.touchObject.curX - r.touchObject.startX, 2)
                )
              )),
              r.options.verticalSwiping === !0 &&
                (r.touchObject.swipeLength = Math.round(
                  Math.sqrt(
                    Math.pow(r.touchObject.curY - r.touchObject.startY, 2)
                  )
                )),
              (i = r.swipeDirection()),
              "vertical" !== i
                ? (void 0 !== t.originalEvent &&
                    r.touchObject.swipeLength > 4 &&
                    t.preventDefault(),
                  (o =
                    (r.options.rtl === !1 ? 1 : -1) *
                    (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
                  r.options.verticalSwiping === !0 &&
                    (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
                  (n = r.touchObject.swipeLength),
                  (r.touchObject.edgeHit = !1),
                  r.options.infinite === !1 &&
                    ((0 === r.currentSlide && "right" === i) ||
                      (r.currentSlide >= r.getDotCount() && "left" === i)) &&
                    ((n = r.touchObject.swipeLength * r.options.edgeFriction),
                    (r.touchObject.edgeHit = !0)),
                  r.options.vertical === !1
                    ? (r.swipeLeft = e + n * o)
                    : (r.swipeLeft =
                        e + n * (r.$list.height() / r.listWidth) * o),
                  r.options.verticalSwiping === !0 && (r.swipeLeft = e + n * o),
                  r.options.fade === !0 || r.options.touchMove === !1
                    ? !1
                    : r.animating === !0
                    ? ((r.swipeLeft = null), !1)
                    : void r.setCSS(r.swipeLeft))
                : void 0)
        );
      }),
      (e.prototype.swipeStart = function (t) {
        var e,
          i = this;
        return 1 !== i.touchObject.fingerCount ||
          i.slideCount <= i.options.slidesToShow
          ? ((i.touchObject = {}), !1)
          : (void 0 !== t.originalEvent &&
              void 0 !== t.originalEvent.touches &&
              (e = t.originalEvent.touches[0]),
            (i.touchObject.startX = i.touchObject.curX =
              void 0 !== e ? e.pageX : t.clientX),
            (i.touchObject.startY = i.touchObject.curY =
              void 0 !== e ? e.pageY : t.clientY),
            void (i.dragging = !0));
      }),
      (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
        function () {
          var t = this;
          null !== t.$slidesCache &&
            (t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.appendTo(t.$slideTrack),
            t.reinit());
        }),
      (e.prototype.unload = function () {
        var e = this;
        t(".slick-cloned", e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow &&
            e.htmlExpr.test(e.options.prevArrow) &&
            e.$prevArrow.remove(),
          e.$nextArrow &&
            e.htmlExpr.test(e.options.nextArrow) &&
            e.$nextArrow.remove(),
          e.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (e.prototype.unslick = function (t) {
        var e = this;
        e.$slider.trigger("unslick", [e, t]), e.destroy();
      }),
      (e.prototype.updateArrows = function () {
        var t,
          e = this;
        (t = Math.floor(e.options.slidesToShow / 2)),
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            !e.options.infinite &&
            (e.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            e.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            0 === e.currentSlide
              ? (e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                e.options.centerMode === !1
              ? (e.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : e.currentSlide >= e.slideCount - 1 &&
                e.options.centerMode === !0 &&
                (e.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                e.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (e.prototype.updateDots = function () {
        var t = this;
        null !== t.$dots &&
          (t.$dots
            .find("li")
            .removeClass("slick-active")
            .attr("aria-hidden", "true"),
          t.$dots
            .find("li")
            .eq(Math.floor(t.currentSlide / t.options.slidesToScroll))
            .addClass("slick-active")
            .attr("aria-hidden", "false"));
      }),
      (e.prototype.visibility = function () {
        var t = this;
        document[t.hidden]
          ? ((t.paused = !0), t.autoPlayClear())
          : t.options.autoplay === !0 && ((t.paused = !1), t.autoPlay());
      }),
      (e.prototype.initADA = function () {
        var e = this;
        e.$slides
          .add(e.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          e.$slideTrack.attr("role", "listbox"),
          e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (i) {
            t(this).attr({
              role: "option",
              "aria-describedby": "slick-slide" + e.instanceUid + i,
            });
          }),
          null !== e.$dots &&
            e.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (i) {
                t(this).attr({
                  role: "presentation",
                  "aria-selected": "false",
                  "aria-controls": "navigation" + e.instanceUid + i,
                  id: "slick-slide" + e.instanceUid + i,
                });
              })
              .first()
              .attr("aria-selected", "true")
              .end()
              .find("button")
              .attr("role", "button")
              .end()
              .closest("div")
              .attr("role", "toolbar"),
          e.activateADA();
      }),
      (e.prototype.activateADA = function () {
        var t = this;
        t.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (e.prototype.focusHandler = function () {
        var e = this;
        e.$slider.on("focus.slick blur.slick", "*", function (i) {
          i.stopImmediatePropagation();
          var n = t(this);
          setTimeout(function () {
            e.isPlay &&
              (n.is(":focus")
                ? (e.autoPlayClear(), (e.paused = !0))
                : ((e.paused = !1), e.autoPlay()));
          }, 0);
        });
      }),
      (t.fn.slick = function () {
        var t,
          i,
          n = this,
          o = arguments[0],
          s = Array.prototype.slice.call(arguments, 1),
          r = n.length;
        for (t = 0; r > t; t++)
          if (
            ("object" == typeof o || "undefined" == typeof o
              ? (n[t].slick = new e(n[t], o))
              : (i = n[t].slick[o].apply(n[t].slick, s)),
            "undefined" != typeof i)
          )
            return i;
        return n;
      });
  }),
  +(function (t) {
    "use strict";
    function e(e, n) {
      return this.each(function () {
        var o = t(this),
          s = o.data("bs.modal"),
          r = t.extend({}, i.DEFAULTS, o.data(), "object" == typeof e && e);
        s || o.data("bs.modal", (s = new i(this, r))),
          "string" == typeof e ? s[e](n) : r.show && s.show(n);
      });
    }
    var i = function (e, i) {
      (this.options = i),
        (this.$body = t(document.body)),
        (this.$element = t(e)),
        (this.$dialog = this.$element.find(".modal-dialog")),
        (this.$backdrop = null),
        (this.isShown = null),
        (this.originalBodyPad = null),
        (this.scrollbarWidth = 0),
        (this.ignoreBackdropClick = !1),
        this.options.remote &&
          this.$element.find(".modal-content").load(
            this.options.remote,
            t.proxy(function () {
              this.$element.trigger("loaded.bs.modal");
            }, this)
          );
    };
    (i.VERSION = "3.3.6"),
      (i.TRANSITION_DURATION = 300),
      (i.BACKDROP_TRANSITION_DURATION = 150),
      (i.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
      (i.prototype.toggle = function (t) {
        return this.isShown ? this.hide() : this.show(t);
      }),
      (i.prototype.show = function (e) {
        var n = this,
          o = t.Event("show.bs.modal", { relatedTarget: e });
        this.$element.trigger(o),
          this.isShown ||
            o.isDefaultPrevented() ||
            ((this.isShown = !0),
            this.checkScrollbar(),
            this.setScrollbar(),
            this.$body.addClass("modal-open"),
            this.escape(),
            this.resize(),
            this.$element.on(
              "click.dismiss.bs.modal",
              '[data-dismiss="modal"]',
              t.proxy(this.hide, this)
            ),
            this.$dialog.on("mousedown.dismiss.bs.modal", function () {
              n.$element.one("mouseup.dismiss.bs.modal", function (e) {
                t(e.target).is(n.$element) && (n.ignoreBackdropClick = !0);
              });
            }),
            this.backdrop(function () {
              var o = t.support.transition && n.$element.hasClass("fade");
              n.$element.parent().length || n.$element.appendTo(n.$body),
                n.$element.show().scrollTop(0),
                n.adjustDialog(),
                o && n.$element[0].offsetWidth,
                n.$element.addClass("in"),
                n.enforceFocus();
              var s = t.Event("shown.bs.modal", { relatedTarget: e });
              o
                ? n.$dialog
                    .one("bsTransitionEnd", function () {
                      n.$element.trigger("focus").trigger(s);
                    })
                    .emulateTransitionEnd(i.TRANSITION_DURATION)
                : n.$element.trigger("focus").trigger(s);
            }));
      }),
      (i.prototype.hide = function (e) {
        e && e.preventDefault(),
          (e = t.Event("hide.bs.modal")),
          this.$element.trigger(e),
          this.isShown &&
            !e.isDefaultPrevented() &&
            ((this.isShown = !1),
            this.escape(),
            this.resize(),
            t(document).off("focusin.bs.modal"),
            this.$element
              .removeClass("in")
              .off("click.dismiss.bs.modal")
              .off("mouseup.dismiss.bs.modal"),
            this.$dialog.off("mousedown.dismiss.bs.modal"),
            t.support.transition && this.$element.hasClass("fade")
              ? this.$element
                  .one("bsTransitionEnd", t.proxy(this.hideModal, this))
                  .emulateTransitionEnd(i.TRANSITION_DURATION)
              : this.hideModal());
      }),
      (i.prototype.enforceFocus = function () {
        t(document)
          .off("focusin.bs.modal")
          .on(
            "focusin.bs.modal",
            t.proxy(function (t) {
              this.$element[0] === t.target ||
                this.$element.has(t.target).length ||
                this.$element.trigger("focus");
            }, this)
          );
      }),
      (i.prototype.escape = function () {
        this.isShown && this.options.keyboard
          ? this.$element.on(
              "keydown.dismiss.bs.modal",
              t.proxy(function (t) {
                27 == t.which && this.hide();
              }, this)
            )
          : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
      }),
      (i.prototype.resize = function () {
        this.isShown
          ? t(window).on("resize.bs.modal", t.proxy(this.handleUpdate, this))
          : t(window).off("resize.bs.modal");
      }),
      (i.prototype.hideModal = function () {
        var t = this;
        this.$element.hide(),
          this.backdrop(function () {
            t.$body.removeClass("modal-open"),
              t.resetAdjustments(),
              t.resetScrollbar(),
              t.$element.trigger("hidden.bs.modal");
          });
      }),
      (i.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
      }),
      (i.prototype.backdrop = function (e) {
        var n = this,
          o = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
          var s = t.support.transition && o;
          if (
            ((this.$backdrop = t(document.createElement("div"))
              .addClass("modal-backdrop " + o)
              .appendTo(this.$body)),
            this.$element.on(
              "click.dismiss.bs.modal",
              t.proxy(function (t) {
                return this.ignoreBackdropClick
                  ? void (this.ignoreBackdropClick = !1)
                  : void (
                      t.target === t.currentTarget &&
                      ("static" == this.options.backdrop
                        ? this.$element[0].focus()
                        : this.hide())
                    );
              }, this)
            ),
            s && this.$backdrop[0].offsetWidth,
            this.$backdrop.addClass("in"),
            !e)
          )
            return;
          s
            ? this.$backdrop
                .one("bsTransitionEnd", e)
                .emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION)
            : e();
        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          var r = function () {
            n.removeBackdrop(), e && e();
          };
          t.support.transition && this.$element.hasClass("fade")
            ? this.$backdrop
                .one("bsTransitionEnd", r)
                .emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION)
            : r();
        } else e && e();
      }),
      (i.prototype.handleUpdate = function () {
        this.adjustDialog();
      }),
      (i.prototype.adjustDialog = function () {
        var t =
          this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
          paddingLeft: !this.bodyIsOverflowing && t ? this.scrollbarWidth : "",
          paddingRight: this.bodyIsOverflowing && !t ? this.scrollbarWidth : "",
        });
      }),
      (i.prototype.resetAdjustments = function () {
        this.$element.css({ paddingLeft: "", paddingRight: "" });
      }),
      (i.prototype.checkScrollbar = function () {
        var t = window.innerWidth;
        if (!t) {
          var e = document.documentElement.getBoundingClientRect();
          t = e.right - Math.abs(e.left);
        }
        (this.bodyIsOverflowing = document.body.clientWidth < t),
          (this.scrollbarWidth = this.measureScrollbar());
      }),
      (i.prototype.setScrollbar = function () {
        var t = parseInt(this.$body.css("padding-right") || 0, 10);
        (this.originalBodyPad = document.body.style.paddingRight || ""),
          this.bodyIsOverflowing &&
            this.$body.css("padding-right", t + this.scrollbarWidth);
      }),
      (i.prototype.resetScrollbar = function () {
        this.$body.css("padding-right", this.originalBodyPad);
      }),
      (i.prototype.measureScrollbar = function () {
        var t = document.createElement("div");
        (t.className = "modal-scrollbar-measure"), this.$body.append(t);
        var e = t.offsetWidth - t.clientWidth;
        return this.$body[0].removeChild(t), e;
      });
    var n = t.fn.modal;
    (t.fn.modal = e),
      (t.fn.modal.Constructor = i),
      (t.fn.modal.noConflict = function () {
        return (t.fn.modal = n), this;
      }),
      t(document).on(
        "click.bs.modal.data-api",
        '[data-toggle="modal"]',
        function (i) {
          var n = t(this),
            o = n.attr("href"),
            s = t(
              n.attr("data-target") || (o && o.replace(/.*(?=#[^\s]+$)/, ""))
            ),
            r = s.data("bs.modal")
              ? "toggle"
              : t.extend({ remote: !/#/.test(o) && o }, s.data(), n.data());
          n.is("a") && i.preventDefault(),
            s.one("show.bs.modal", function (t) {
              t.isDefaultPrevented() ||
                s.one("hidden.bs.modal", function () {
                  n.is(":visible") && n.trigger("focus");
                });
            }),
            e.call(s, r, this);
        }
      );
  })(jQuery),
  +(function (t) {
    "use strict";
    function e() {
      var t = document.createElement("bootstrap"),
        e = {
          WebkitTransition: "webkitTransitionEnd",
          MozTransition: "transitionend",
          OTransition: "oTransitionEnd otransitionend",
          transition: "transitionend",
        };
      for (var i in e) if (void 0 !== t.style[i]) return { end: e[i] };
      return !1;
    }
    (t.fn.emulateTransitionEnd = function (e) {
      var i = !1,
        n = this;
      t(this).one("bsTransitionEnd", function () {
        i = !0;
      });
      var o = function () {
        i || t(n).trigger(t.support.transition.end);
      };
      return setTimeout(o, e), this;
    }),
      t(function () {
        (t.support.transition = e()),
          t.support.transition &&
            (t.event.special.bsTransitionEnd = {
              bindType: t.support.transition.end,
              delegateType: t.support.transition.end,
              handle: function (e) {
                return t(e.target).is(this)
                  ? e.handleObj.handler.apply(this, arguments)
                  : void 0;
              },
            });
      });
  })(jQuery),
  !(function (t) {
    if ("function" == typeof define && define.amd) define(t);
    else if ("object" == typeof exports) module.exports = t();
    else {
      var e = window.Cookies,
        i = (window.Cookies = t());
      i.noConflict = function () {
        return (window.Cookies = e), i;
      };
    }
  })(function () {
    function t() {
      for (var t = 0, e = {}; t < arguments.length; t++) {
        var i = arguments[t];
        for (var n in i) e[n] = i[n];
      }
      return e;
    }
    function e(i) {
      function n(e, o, s) {
        var r;
        if (arguments.length > 1) {
          if (
            ((s = t({ path: "/" }, n.defaults, s)),
            "number" == typeof s.expires)
          ) {
            var a = new Date();
            a.setMilliseconds(a.getMilliseconds() + 864e5 * s.expires),
              (s.expires = a);
          }
          try {
            (r = JSON.stringify(o)), /^[\{\[]/.test(r) && (o = r);
          } catch (l) {}
          return (
            (o = encodeURIComponent(String(o))),
            (o = o.replace(
              /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
              decodeURIComponent
            )),
            (e = encodeURIComponent(String(e))),
            (e = e.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
            (e = e.replace(/[\(\)]/g, escape)),
            (document.cookie = [
              e,
              "=",
              o,
              s.expires && "; expires=" + s.expires.toUTCString(),
              s.path && "; path=" + s.path,
              s.domain && "; domain=" + s.domain,
              s.secure ? "; secure" : "",
            ].join(""))
          );
        }
        e || (r = {});
        for (
          var c = document.cookie ? document.cookie.split("; ") : [],
            u = /(%[0-9A-Z]{2})+/g,
            h = 0;
          h < c.length;
          h++
        ) {
          var p = c[h].split("="),
            d = p[0].replace(u, decodeURIComponent),
            f = p.slice(1).join("=");
          '"' === f.charAt(0) && (f = f.slice(1, -1));
          try {
            if (
              ((f = (i && i(f, d)) || f.replace(u, decodeURIComponent)),
              this.json)
            )
              try {
                f = JSON.parse(f);
              } catch (l) {}
            if (e === d) {
              r = f;
              break;
            }
            e || (r[d] = f);
          } catch (l) {}
        }
        return r;
      }
      return (
        (n.get = n.set = n),
        (n.getJSON = function () {
          return n.apply({ json: !0 }, [].slice.call(arguments));
        }),
        (n.defaults = {}),
        (n.remove = function (e, i) {
          n(e, "", t(i, { expires: -1 }));
        }),
        (n.withConverter = e),
        n
      );
    }
    return e();
  }),
  !(function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("jquery")))
      : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    "use strict";
    function i(i, s, a) {
      function l(t, e, n) {
        var o,
          s = "$()." + i + '("' + e + '")';
        return (
          t.each(function (t, l) {
            var c = a.data(l, i);
            if (!c)
              return void r(
                i + " not initialized. Cannot call methods, i.e. " + s
              );
            var u = c[e];
            if (!u || "_" == e.charAt(0))
              return void r(s + " is not a valid method");
            var h = u.apply(c, n);
            o = void 0 === o ? h : o;
          }),
          void 0 !== o ? o : t
        );
      }
      function c(t, e) {
        t.each(function (t, n) {
          var o = a.data(n, i);
          o ? (o.option(e), o._init()) : ((o = new s(n, e)), a.data(n, i, o));
        });
      }
      (a = a || e || t.jQuery),
        a &&
          (s.prototype.option ||
            (s.prototype.option = function (t) {
              a.isPlainObject(t) &&
                (this.options = a.extend(!0, this.options, t));
            }),
          (a.fn[i] = function (t) {
            if ("string" == typeof t) {
              var e = o.call(arguments, 1);
              return l(this, t, e);
            }
            return c(this, t), this;
          }),
          n(a));
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i);
    }
    var o = Array.prototype.slice,
      s = t.console,
      r =
        "undefined" == typeof s
          ? function () {}
          : function (t) {
              s.error(t);
            };
    return n(e || t.jQuery), i;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {}),
            n = (i[t] = i[t] || {});
          return (n[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = 0,
            o = i[n];
          e = e || [];
          for (var s = this._onceEvents && this._onceEvents[t]; o; ) {
            var r = s && s[o];
            r && (this.off(t, o), delete s[o]),
              o.apply(this, e),
              (n += r ? 0 : 1),
              (o = i[n]);
          }
          return this;
        }
      }),
      t
    );
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("get-size/get-size", [], function () {
          return e();
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.getSize = e());
  })(window, function () {
    "use strict";
    function t(t) {
      var e = parseFloat(t),
        i = -1 == t.indexOf("%") && !isNaN(e);
      return i && e;
    }
    function e() {}
    function i() {
      for (
        var t = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0,
          },
          e = 0;
        c > e;
        e++
      ) {
        var i = l[e];
        t[i] = 0;
      }
      return t;
    }
    function n(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          a(
            "Style returned " +
              e +
              ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"
          ),
        e
      );
    }
    function o() {
      if (!u) {
        u = !0;
        var e = document.createElement("div");
        (e.style.width = "200px"),
          (e.style.padding = "1px 2px 3px 4px"),
          (e.style.borderStyle = "solid"),
          (e.style.borderWidth = "1px 2px 3px 4px"),
          (e.style.boxSizing = "border-box");
        var i = document.body || document.documentElement;
        i.appendChild(e);
        var o = n(e);
        (s.isBoxSizeOuter = r = 200 == t(o.width)), i.removeChild(e);
      }
    }
    function s(e) {
      if (
        (o(),
        "string" == typeof e && (e = document.querySelector(e)),
        e && "object" == typeof e && e.nodeType)
      ) {
        var s = n(e);
        if ("none" == s.display) return i();
        var a = {};
        (a.width = e.offsetWidth), (a.height = e.offsetHeight);
        for (
          var u = (a.isBorderBox = "border-box" == s.boxSizing), h = 0;
          c > h;
          h++
        ) {
          var p = l[h],
            d = s[p],
            f = parseFloat(d);
          a[p] = isNaN(f) ? 0 : f;
        }
        var m = a.paddingLeft + a.paddingRight,
          g = a.paddingTop + a.paddingBottom,
          v = a.marginLeft + a.marginRight,
          y = a.marginTop + a.marginBottom,
          k = a.borderLeftWidth + a.borderRightWidth,
          w = a.borderTopWidth + a.borderBottomWidth,
          b = u && r,
          S = t(s.width);
        S !== !1 && (a.width = S + (b ? 0 : m + k));
        var x = t(s.height);
        return (
          x !== !1 && (a.height = x + (b ? 0 : g + w)),
          (a.innerWidth = a.width - (m + k)),
          (a.innerHeight = a.height - (g + w)),
          (a.outerWidth = a.width + v),
          (a.outerHeight = a.height + y),
          a
        );
      }
    }
    var r,
      a =
        "undefined" == typeof console
          ? e
          : function (t) {
              console.error(t);
            },
      l = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      c = l.length,
      u = !1;
    return s;
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.matchesSelector = e());
  })(window, function () {
    "use strict";
    var t = (function () {
      var t = Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
        var n = e[i],
          o = n + "MatchesSelector";
        if (t[o]) return o;
      }
    })();
    return function (e, i) {
      return e[t](i);
    };
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (i) {
            return e(t, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("desandro-matches-selector")))
      : (t.fizzyUIUtils = e(t, t.matchesSelector));
  })(window, function (t, e) {
    var i = {};
    (i.extend = function (t, e) {
      for (var i in e) t[i] = e[i];
      return t;
    }),
      (i.modulo = function (t, e) {
        return ((t % e) + e) % e;
      }),
      (i.makeArray = function (t) {
        var e = [];
        if (Array.isArray(t)) e = t;
        else if (t && "number" == typeof t.length)
          for (var i = 0; i < t.length; i++) e.push(t[i]);
        else e.push(t);
        return e;
      }),
      (i.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
      }),
      (i.getParent = function (t, i) {
        for (; t != document.body; )
          if (((t = t.parentNode), e(t, i))) return t;
      }),
      (i.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.filterFindElements = function (t, n) {
        t = i.makeArray(t);
        var o = [];
        return (
          t.forEach(function (t) {
            if (t instanceof HTMLElement) {
              if (!n) return void o.push(t);
              e(t, n) && o.push(t);
              for (var i = t.querySelectorAll(n), s = 0; s < i.length; s++)
                o.push(i[s]);
            }
          }),
          o
        );
      }),
      (i.debounceMethod = function (t, e, i) {
        var n = t.prototype[e],
          o = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[o];
          t && clearTimeout(t);
          var e = arguments,
            s = this;
          this[o] = setTimeout(function () {
            n.apply(s, e), delete s[o];
          }, i || 100);
        };
      }),
      (i.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? t()
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (i.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i;
          })
          .toLowerCase();
      });
    var n = t.console;
    return (
      (i.htmlInit = function (e, o) {
        i.docReady(function () {
          var s = i.toDashed(o),
            r = "data-" + s,
            a = document.querySelectorAll("[" + r + "]"),
            l = document.querySelectorAll(".js-" + s),
            c = i.makeArray(a).concat(i.makeArray(l)),
            u = r + "-options",
            h = t.jQuery;
          c.forEach(function (t) {
            var i,
              s = t.getAttribute(r) || t.getAttribute(u);
            try {
              i = s && JSON.parse(s);
            } catch (a) {
              return void (
                n &&
                n.error("Error parsing " + r + " on " + t.className + ": " + a)
              );
            }
            var l = new e(t, i);
            h && h.data(t, o, l);
          });
        });
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "outlayer/item",
          ["ev-emitter/ev-emitter", "get-size/get-size"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("ev-emitter"), require("get-size")))
      : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
  })(window, function (t, e) {
    "use strict";
    function i(t) {
      for (var e in t) return !1;
      return (e = null), !0;
    }
    function n(t, e) {
      t &&
        ((this.element = t),
        (this.layout = e),
        (this.position = { x: 0, y: 0 }),
        this._create());
    }
    function o(t) {
      return t.replace(/([A-Z])/g, function (t) {
        return "-" + t.toLowerCase();
      });
    }
    var s = document.documentElement.style,
      r = "string" == typeof s.transition ? "transition" : "WebkitTransition",
      a = "string" == typeof s.transform ? "transform" : "WebkitTransform",
      l = {
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend",
      }[r],
      c = {
        transform: a,
        transition: r,
        transitionDuration: r + "Duration",
        transitionProperty: r + "Property",
        transitionDelay: r + "Delay",
      },
      u = (n.prototype = Object.create(t.prototype));
    (u.constructor = n),
      (u._create = function () {
        (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
          this.css({ position: "absolute" });
      }),
      (u.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (u.getSize = function () {
        this.size = e(this.element);
      }),
      (u.css = function (t) {
        var e = this.element.style;
        for (var i in t) {
          var n = c[i] || i;
          e[n] = t[i];
        }
      }),
      (u.getPosition = function () {
        var t = getComputedStyle(this.element),
          e = this.layout._getOption("originLeft"),
          i = this.layout._getOption("originTop"),
          n = t[e ? "left" : "right"],
          o = t[i ? "top" : "bottom"],
          s = this.layout.size,
          r =
            -1 != n.indexOf("%")
              ? (parseFloat(n) / 100) * s.width
              : parseInt(n, 10),
          a =
            -1 != o.indexOf("%")
              ? (parseFloat(o) / 100) * s.height
              : parseInt(o, 10);
        (r = isNaN(r) ? 0 : r),
          (a = isNaN(a) ? 0 : a),
          (r -= e ? s.paddingLeft : s.paddingRight),
          (a -= i ? s.paddingTop : s.paddingBottom),
          (this.position.x = r),
          (this.position.y = a);
      }),
      (u.layoutPosition = function () {
        var t = this.layout.size,
          e = {},
          i = this.layout._getOption("originLeft"),
          n = this.layout._getOption("originTop"),
          o = i ? "paddingLeft" : "paddingRight",
          s = i ? "left" : "right",
          r = i ? "right" : "left",
          a = this.position.x + t[o];
        (e[s] = this.getXValue(a)), (e[r] = "");
        var l = n ? "paddingTop" : "paddingBottom",
          c = n ? "top" : "bottom",
          u = n ? "bottom" : "top",
          h = this.position.y + t[l];
        (e[c] = this.getYValue(h)),
          (e[u] = ""),
          this.css(e),
          this.emitEvent("layout", [this]);
      }),
      (u.getXValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && !e
          ? (t / this.layout.size.width) * 100 + "%"
          : t + "px";
      }),
      (u.getYValue = function (t) {
        var e = this.layout._getOption("horizontal");
        return this.layout.options.percentPosition && e
          ? (t / this.layout.size.height) * 100 + "%"
          : t + "px";
      }),
      (u._transitionTo = function (t, e) {
        this.getPosition();
        var i = this.position.x,
          n = this.position.y,
          o = parseInt(t, 10),
          s = parseInt(e, 10),
          r = o === this.position.x && s === this.position.y;
        if ((this.setPosition(t, e), r && !this.isTransitioning))
          return void this.layoutPosition();
        var a = t - i,
          l = e - n,
          c = {};
        (c.transform = this.getTranslate(a, l)),
          this.transition({
            to: c,
            onTransitionEnd: { transform: this.layoutPosition },
            isCleaning: !0,
          });
      }),
      (u.getTranslate = function (t, e) {
        var i = this.layout._getOption("originLeft"),
          n = this.layout._getOption("originTop");
        return (
          (t = i ? t : -t),
          (e = n ? e : -e),
          "translate3d(" + t + "px, " + e + "px, 0)"
        );
      }),
      (u.goTo = function (t, e) {
        this.setPosition(t, e), this.layoutPosition();
      }),
      (u.moveTo = u._transitionTo),
      (u.setPosition = function (t, e) {
        (this.position.x = parseInt(t, 10)),
          (this.position.y = parseInt(e, 10));
      }),
      (u._nonTransition = function (t) {
        this.css(t.to), t.isCleaning && this._removeStyles(t.to);
        for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this);
      }),
      (u.transition = function (t) {
        if (!parseFloat(this.layout.options.transitionDuration))
          return void this._nonTransition(t);
        var e = this._transn;
        for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
        for (i in t.to)
          (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
        if (t.from) {
          this.css(t.from);
          var n = this.element.offsetHeight;
          n = null;
        }
        this.enableTransition(t.to),
          this.css(t.to),
          (this.isTransitioning = !0);
      });
    var h = "opacity," + o(a);
    (u.enableTransition = function () {
      if (!this.isTransitioning) {
        var t = this.layout.options.transitionDuration;
        (t = "number" == typeof t ? t + "ms" : t),
          this.css({
            transitionProperty: h,
            transitionDuration: t,
            transitionDelay: this.staggerDelay || 0,
          }),
          this.element.addEventListener(l, this, !1);
      }
    }),
      (u.onwebkitTransitionEnd = function (t) {
        this.ontransitionend(t);
      }),
      (u.onotransitionend = function (t) {
        this.ontransitionend(t);
      });
    var p = { "-webkit-transform": "transform" };
    (u.ontransitionend = function (t) {
      if (t.target === this.element) {
        var e = this._transn,
          n = p[t.propertyName] || t.propertyName;
        if (
          (delete e.ingProperties[n],
          i(e.ingProperties) && this.disableTransition(),
          n in e.clean &&
            ((this.element.style[t.propertyName] = ""), delete e.clean[n]),
          n in e.onEnd)
        ) {
          var o = e.onEnd[n];
          o.call(this), delete e.onEnd[n];
        }
        this.emitEvent("transitionEnd", [this]);
      }
    }),
      (u.disableTransition = function () {
        this.removeTransitionStyles(),
          this.element.removeEventListener(l, this, !1),
          (this.isTransitioning = !1);
      }),
      (u._removeStyles = function (t) {
        var e = {};
        for (var i in t) e[i] = "";
        this.css(e);
      });
    var d = {
      transitionProperty: "",
      transitionDuration: "",
      transitionDelay: "",
    };
    return (
      (u.removeTransitionStyles = function () {
        this.css(d);
      }),
      (u.stagger = function (t) {
        (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
      }),
      (u.removeElem = function () {
        this.element.parentNode.removeChild(this.element),
          this.css({ display: "" }),
          this.emitEvent("remove", [this]);
      }),
      (u.remove = function () {
        return r && parseFloat(this.layout.options.transitionDuration)
          ? (this.once("transitionEnd", function () {
              this.removeElem();
            }),
            void this.hide())
          : void this.removeElem();
      }),
      (u.reveal = function () {
        delete this.isHidden, this.css({ display: "" });
        var t = this.layout.options,
          e = {},
          i = this.getHideRevealTransitionEndProperty("visibleStyle");
        (e[i] = this.onRevealTransitionEnd),
          this.transition({
            from: t.hiddenStyle,
            to: t.visibleStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (u.onRevealTransitionEnd = function () {
        this.isHidden || this.emitEvent("reveal");
      }),
      (u.getHideRevealTransitionEndProperty = function (t) {
        var e = this.layout.options[t];
        if (e.opacity) return "opacity";
        for (var i in e) return i;
      }),
      (u.hide = function () {
        (this.isHidden = !0), this.css({ display: "" });
        var t = this.layout.options,
          e = {},
          i = this.getHideRevealTransitionEndProperty("hiddenStyle");
        (e[i] = this.onHideTransitionEnd),
          this.transition({
            from: t.visibleStyle,
            to: t.hiddenStyle,
            isCleaning: !0,
            onTransitionEnd: e,
          });
      }),
      (u.onHideTransitionEnd = function () {
        this.isHidden &&
          (this.css({ display: "none" }), this.emitEvent("hide"));
      }),
      (u.destroy = function () {
        this.css({
          position: "",
          left: "",
          right: "",
          top: "",
          bottom: "",
          transition: "",
          transform: "",
        });
      }),
      n
    );
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(
          "outlayer/outlayer",
          [
            "ev-emitter/ev-emitter",
            "get-size/get-size",
            "fizzy-ui-utils/utils",
            "./item",
          ],
          function (i, n, o, s) {
            return e(t, i, n, o, s);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(
          t,
          require("ev-emitter"),
          require("get-size"),
          require("fizzy-ui-utils"),
          require("./item")
        ))
      : (t.Outlayer = e(
          t,
          t.EvEmitter,
          t.getSize,
          t.fizzyUIUtils,
          t.Outlayer.Item
        ));
  })(window, function (t, e, i, n, o) {
    "use strict";
    function s(t, e) {
      var i = n.getQueryElement(t);
      if (!i)
        return void (
          l &&
          l.error(
            "Bad element for " + this.constructor.namespace + ": " + (i || t)
          )
        );
      (this.element = i),
        c && (this.$element = c(this.element)),
        (this.options = n.extend({}, this.constructor.defaults)),
        this.option(e);
      var o = ++h;
      (this.element.outlayerGUID = o), (p[o] = this), this._create();
      var s = this._getOption("initLayout");
      s && this.layout();
    }
    function r(t) {
      function e() {
        t.apply(this, arguments);
      }
      return (
        (e.prototype = Object.create(t.prototype)),
        (e.prototype.constructor = e),
        e
      );
    }
    function a(t) {
      if ("number" == typeof t) return t;
      var e = t.match(/(^\d*\.?\d*)(\w*)/),
        i = e && e[1],
        n = e && e[2];
      if (!i.length) return 0;
      i = parseFloat(i);
      var o = f[n] || 1;
      return i * o;
    }
    var l = t.console,
      c = t.jQuery,
      u = function () {},
      h = 0,
      p = {};
    (s.namespace = "outlayer"),
      (s.Item = o),
      (s.defaults = {
        containerStyle: { position: "relative" },
        initLayout: !0,
        originLeft: !0,
        originTop: !0,
        resize: !0,
        resizeContainer: !0,
        transitionDuration: "0.4s",
        hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
        visibleStyle: { opacity: 1, transform: "scale(1)" },
      });
    var d = s.prototype;
    n.extend(d, e.prototype),
      (d.option = function (t) {
        n.extend(this.options, t);
      }),
      (d._getOption = function (t) {
        var e = this.constructor.compatOptions[t];
        return e && void 0 !== this.options[e]
          ? this.options[e]
          : this.options[t];
      }),
      (s.compatOptions = {
        initLayout: "isInitLayout",
        horizontal: "isHorizontal",
        layoutInstant: "isLayoutInstant",
        originLeft: "isOriginLeft",
        originTop: "isOriginTop",
        resize: "isResizeBound",
        resizeContainer: "isResizingContainer",
      }),
      (d._create = function () {
        this.reloadItems(),
          (this.stamps = []),
          this.stamp(this.options.stamp),
          n.extend(this.element.style, this.options.containerStyle);
        var t = this._getOption("resize");
        t && this.bindResize();
      }),
      (d.reloadItems = function () {
        this.items = this._itemize(this.element.children);
      }),
      (d._itemize = function (t) {
        for (
          var e = this._filterFindItemElements(t),
            i = this.constructor.Item,
            n = [],
            o = 0;
          o < e.length;
          o++
        ) {
          var s = e[o],
            r = new i(s, this);
          n.push(r);
        }
        return n;
      }),
      (d._filterFindItemElements = function (t) {
        return n.filterFindElements(t, this.options.itemSelector);
      }),
      (d.getItemElements = function () {
        return this.items.map(function (t) {
          return t.element;
        });
      }),
      (d.layout = function () {
        this._resetLayout(), this._manageStamps();
        var t = this._getOption("layoutInstant"),
          e = void 0 !== t ? t : !this._isLayoutInited;
        this.layoutItems(this.items, e), (this._isLayoutInited = !0);
      }),
      (d._init = d.layout),
      (d._resetLayout = function () {
        this.getSize();
      }),
      (d.getSize = function () {
        this.size = i(this.element);
      }),
      (d._getMeasurement = function (t, e) {
        var n,
          o = this.options[t];
        o
          ? ("string" == typeof o
              ? (n = this.element.querySelector(o))
              : o instanceof HTMLElement && (n = o),
            (this[t] = n ? i(n)[e] : o))
          : (this[t] = 0);
      }),
      (d.layoutItems = function (t, e) {
        (t = this._getItemsForLayout(t)),
          this._layoutItems(t, e),
          this._postLayout();
      }),
      (d._getItemsForLayout = function (t) {
        return t.filter(function (t) {
          return !t.isIgnored;
        });
      }),
      (d._layoutItems = function (t, e) {
        if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
          var i = [];
          t.forEach(function (t) {
            var n = this._getItemLayoutPosition(t);
            (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
          }, this),
            this._processLayoutQueue(i);
        }
      }),
      (d._getItemLayoutPosition = function () {
        return { x: 0, y: 0 };
      }),
      (d._processLayoutQueue = function (t) {
        this.updateStagger(),
          t.forEach(function (t, e) {
            this._positionItem(t.item, t.x, t.y, t.isInstant, e);
          }, this);
      }),
      (d.updateStagger = function () {
        var t = this.options.stagger;
        return null === t || void 0 === t
          ? void (this.stagger = 0)
          : ((this.stagger = a(t)), this.stagger);
      }),
      (d._positionItem = function (t, e, i, n, o) {
        n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
      }),
      (d._postLayout = function () {
        this.resizeContainer();
      }),
      (d.resizeContainer = function () {
        var t = this._getOption("resizeContainer");
        if (t) {
          var e = this._getContainerSize();
          e &&
            (this._setContainerMeasure(e.width, !0),
            this._setContainerMeasure(e.height, !1));
        }
      }),
      (d._getContainerSize = u),
      (d._setContainerMeasure = function (t, e) {
        if (void 0 !== t) {
          var i = this.size;
          i.isBorderBox &&
            (t += e
              ? i.paddingLeft +
                i.paddingRight +
                i.borderLeftWidth +
                i.borderRightWidth
              : i.paddingBottom +
                i.paddingTop +
                i.borderTopWidth +
                i.borderBottomWidth),
            (t = Math.max(t, 0)),
            (this.element.style[e ? "width" : "height"] = t + "px");
        }
      }),
      (d._emitCompleteOnItems = function (t, e) {
        function i() {
          o.dispatchEvent(t + "Complete", null, [e]);
        }
        function n() {
          r++, r == s && i();
        }
        var o = this,
          s = e.length;
        if (!e || !s) return void i();
        var r = 0;
        e.forEach(function (e) {
          e.once(t, n);
        });
      }),
      (d.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if ((this.emitEvent(t, n), c))
          if (((this.$element = this.$element || c(this.element)), e)) {
            var o = c.Event(e);
            (o.type = t), this.$element.trigger(o, i);
          } else this.$element.trigger(t, i);
      }),
      (d.ignore = function (t) {
        var e = this.getItem(t);
        e && (e.isIgnored = !0);
      }),
      (d.unignore = function (t) {
        var e = this.getItem(t);
        e && delete e.isIgnored;
      }),
      (d.stamp = function (t) {
        (t = this._find(t)),
          t &&
            ((this.stamps = this.stamps.concat(t)),
            t.forEach(this.ignore, this));
      }),
      (d.unstamp = function (t) {
        (t = this._find(t)),
          t &&
            t.forEach(function (t) {
              n.removeFrom(this.stamps, t), this.unignore(t);
            }, this);
      }),
      (d._find = function (t) {
        return t
          ? ("string" == typeof t && (t = this.element.querySelectorAll(t)),
            (t = n.makeArray(t)))
          : void 0;
      }),
      (d._manageStamps = function () {
        this.stamps &&
          this.stamps.length &&
          (this._getBoundingRect(),
          this.stamps.forEach(this._manageStamp, this));
      }),
      (d._getBoundingRect = function () {
        var t = this.element.getBoundingClientRect(),
          e = this.size;
        this._boundingRect = {
          left: t.left + e.paddingLeft + e.borderLeftWidth,
          top: t.top + e.paddingTop + e.borderTopWidth,
          right: t.right - (e.paddingRight + e.borderRightWidth),
          bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
        };
      }),
      (d._manageStamp = u),
      (d._getElementOffset = function (t) {
        var e = t.getBoundingClientRect(),
          n = this._boundingRect,
          o = i(t),
          s = {
            left: e.left - n.left - o.marginLeft,
            top: e.top - n.top - o.marginTop,
            right: n.right - e.right - o.marginRight,
            bottom: n.bottom - e.bottom - o.marginBottom,
          };
        return s;
      }),
      (d.handleEvent = n.handleEvent),
      (d.bindResize = function () {
        t.addEventListener("resize", this), (this.isResizeBound = !0);
      }),
      (d.unbindResize = function () {
        t.removeEventListener("resize", this), (this.isResizeBound = !1);
      }),
      (d.onresize = function () {
        this.resize();
      }),
      n.debounceMethod(s, "onresize", 100),
      (d.resize = function () {
        this.isResizeBound && this.needsResizeLayout() && this.layout();
      }),
      (d.needsResizeLayout = function () {
        var t = i(this.element),
          e = this.size && t;
        return e && t.innerWidth !== this.size.innerWidth;
      }),
      (d.addItems = function (t) {
        var e = this._itemize(t);
        return e.length && (this.items = this.items.concat(e)), e;
      }),
      (d.appended = function (t) {
        var e = this.addItems(t);
        e.length && (this.layoutItems(e, !0), this.reveal(e));
      }),
      (d.prepended = function (t) {
        var e = this._itemize(t);
        if (e.length) {
          var i = this.items.slice(0);
          (this.items = e.concat(i)),
            this._resetLayout(),
            this._manageStamps(),
            this.layoutItems(e, !0),
            this.reveal(e),
            this.layoutItems(i);
        }
      }),
      (d.reveal = function (t) {
        if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.reveal();
          });
        }
      }),
      (d.hide = function (t) {
        if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
          var e = this.updateStagger();
          t.forEach(function (t, i) {
            t.stagger(i * e), t.hide();
          });
        }
      }),
      (d.revealItemElements = function (t) {
        var e = this.getItems(t);
        this.reveal(e);
      }),
      (d.hideItemElements = function (t) {
        var e = this.getItems(t);
        this.hide(e);
      }),
      (d.getItem = function (t) {
        for (var e = 0; e < this.items.length; e++) {
          var i = this.items[e];
          if (i.element == t) return i;
        }
      }),
      (d.getItems = function (t) {
        t = n.makeArray(t);
        var e = [];
        return (
          t.forEach(function (t) {
            var i = this.getItem(t);
            i && e.push(i);
          }, this),
          e
        );
      }),
      (d.remove = function (t) {
        var e = this.getItems(t);
        this._emitCompleteOnItems("remove", e),
          e &&
            e.length &&
            e.forEach(function (t) {
              t.remove(), n.removeFrom(this.items, t);
            }, this);
      }),
      (d.destroy = function () {
        var t = this.element.style;
        (t.height = ""),
          (t.position = ""),
          (t.width = ""),
          this.items.forEach(function (t) {
            t.destroy();
          }),
          this.unbindResize();
        var e = this.element.outlayerGUID;
        delete p[e],
          delete this.element.outlayerGUID,
          c && c.removeData(this.element, this.constructor.namespace);
      }),
      (s.data = function (t) {
        t = n.getQueryElement(t);
        var e = t && t.outlayerGUID;
        return e && p[e];
      }),
      (s.create = function (t, e) {
        var i = r(s);
        return (
          (i.defaults = n.extend({}, s.defaults)),
          n.extend(i.defaults, e),
          (i.compatOptions = n.extend({}, s.compatOptions)),
          (i.namespace = t),
          (i.data = s.data),
          (i.Item = r(o)),
          n.htmlInit(i, t),
          c && c.bridget && c.bridget(t, i),
          i
        );
      });
    var f = { ms: 1, s: 1e3 };
    return (s.Item = o), s;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(["outlayer/outlayer", "get-size/get-size"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("outlayer"), require("get-size")))
      : (t.Masonry = e(t.Outlayer, t.getSize));
  })(window, function (t, e) {
    var i = t.create("masonry");
    return (
      (i.compatOptions.fitWidth = "isFitWidth"),
      (i.prototype._resetLayout = function () {
        this.getSize(),
          this._getMeasurement("columnWidth", "outerWidth"),
          this._getMeasurement("gutter", "outerWidth"),
          this.measureColumns(),
          (this.colYs = []);
        for (var t = 0; t < this.cols; t++) this.colYs.push(0);
        this.maxY = 0;
      }),
      (i.prototype.measureColumns = function () {
        if ((this.getContainerWidth(), !this.columnWidth)) {
          var t = this.items[0],
            i = t && t.element;
          this.columnWidth = (i && e(i).outerWidth) || this.containerWidth;
        }
        var n = (this.columnWidth += this.gutter),
          o = this.containerWidth + this.gutter,
          s = o / n,
          r = n - (o % n),
          a = r && 1 > r ? "round" : "floor";
        (s = Math[a](s)), (this.cols = Math.max(s, 1));
      }),
      (i.prototype.getContainerWidth = function () {
        var t = this._getOption("fitWidth"),
          i = t ? this.element.parentNode : this.element,
          n = e(i);
        this.containerWidth = n && n.innerWidth;
      }),
      (i.prototype._getItemLayoutPosition = function (t) {
        t.getSize();
        var e = t.size.outerWidth % this.columnWidth,
          i = e && 1 > e ? "round" : "ceil",
          n = Math[i](t.size.outerWidth / this.columnWidth);
        n = Math.min(n, this.cols);
        for (
          var o = this._getColGroup(n),
            s = Math.min.apply(Math, o),
            r = o.indexOf(s),
            a = { x: this.columnWidth * r, y: s },
            l = s + t.size.outerHeight,
            c = this.cols + 1 - o.length,
            u = 0;
          c > u;
          u++
        )
          this.colYs[r + u] = l;
        return a;
      }),
      (i.prototype._getColGroup = function (t) {
        if (2 > t) return this.colYs;
        for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) {
          var o = this.colYs.slice(n, n + t);
          e[n] = Math.max.apply(Math, o);
        }
        return e;
      }),
      (i.prototype._manageStamp = function (t) {
        var i = e(t),
          n = this._getElementOffset(t),
          o = this._getOption("originLeft"),
          s = o ? n.left : n.right,
          r = s + i.outerWidth,
          a = Math.floor(s / this.columnWidth);
        a = Math.max(0, a);
        var l = Math.floor(r / this.columnWidth);
        (l -= r % this.columnWidth ? 0 : 1), (l = Math.min(this.cols - 1, l));
        for (
          var c = this._getOption("originTop"),
            u = (c ? n.top : n.bottom) + i.outerHeight,
            h = a;
          l >= h;
          h++
        )
          this.colYs[h] = Math.max(u, this.colYs[h]);
      }),
      (i.prototype._getContainerSize = function () {
        this.maxY = Math.max.apply(Math, this.colYs);
        var t = { height: this.maxY };
        return (
          this._getOption("fitWidth") &&
            (t.width = this._getContainerFitWidth()),
          t
        );
      }),
      (i.prototype._getContainerFitWidth = function () {
        for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
        return (this.cols - t) * this.columnWidth - this.gutter;
      }),
      (i.prototype.needsResizeLayout = function () {
        var t = this.containerWidth;
        return this.getContainerWidth(), t != this.containerWidth;
      }),
      i
    );
  }),
  !(function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {}),
            n = (i[t] = i[t] || {});
          return (n[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = 0,
            o = i[n];
          e = e || [];
          for (var s = this._onceEvents && this._onceEvents[t]; o; ) {
            var r = s && s[o];
            r && (this.off(t, o), delete s[o]),
              o.apply(this, e),
              (n += r ? 0 : 1),
              (o = i[n]);
          }
          return this;
        }
      }),
      t
    );
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["ev-emitter/ev-emitter"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("ev-emitter")))
      : (t.imagesLoaded = e(t, t.EvEmitter));
  })(window, function (t, e) {
    function i(t, e) {
      for (var i in e) t[i] = e[i];
      return t;
    }
    function n(t) {
      var e = [];
      if (Array.isArray(t)) e = t;
      else if ("number" == typeof t.length)
        for (var i = 0; i < t.length; i++) e.push(t[i]);
      else e.push(t);
      return e;
    }
    function o(t, e, s) {
      return this instanceof o
        ? ("string" == typeof t && (t = document.querySelectorAll(t)),
          (this.elements = n(t)),
          (this.options = i({}, this.options)),
          "function" == typeof e ? (s = e) : i(this.options, e),
          s && this.on("always", s),
          this.getImages(),
          a && (this.jqDeferred = new a.Deferred()),
          void setTimeout(
            function () {
              this.check();
            }.bind(this)
          ))
        : new o(t, e, s);
    }
    function s(t) {
      this.img = t;
    }
    function r(t, e) {
      (this.url = t), (this.element = e), (this.img = new Image());
    }
    var a = t.jQuery,
      l = t.console;
    (o.prototype = Object.create(e.prototype)),
      (o.prototype.options = {}),
      (o.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (o.prototype.addElementImages = function (t) {
        "IMG" == t.nodeName && this.addImage(t),
          this.options.background === !0 && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && c[e]) {
          for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
            var o = i[n];
            this.addImage(o);
          }
          if ("string" == typeof this.options.background) {
            var s = t.querySelectorAll(this.options.background);
            for (n = 0; n < s.length; n++) {
              var r = s[n];
              this.addElementBackgroundImages(r);
            }
          }
        }
      });
    var c = { 1: !0, 9: !0, 11: !0 };
    return (
      (o.prototype.addElementBackgroundImages = function (t) {
        var e = getComputedStyle(t);
        if (e)
          for (
            var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage);
            null !== n;

          ) {
            var o = n && n[2];
            o && this.addBackground(o, t), (n = i.exec(e.backgroundImage));
          }
      }),
      (o.prototype.addImage = function (t) {
        var e = new s(t);
        this.images.push(e);
      }),
      (o.prototype.addBackground = function (t, e) {
        var i = new r(t, e);
        this.images.push(i);
      }),
      (o.prototype.check = function () {
        function t(t, i, n) {
          setTimeout(function () {
            e.progress(t, i, n);
          });
        }
        var e = this;
        return (
          (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? void this.images.forEach(function (e) {
                e.once("progress", t), e.check();
              })
            : void this.complete()
        );
      }),
      (o.prototype.progress = function (t, e, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
          this.emitEvent("progress", [this, t, e]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, t),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && l && l.log("progress: " + i, t, e);
      }),
      (o.prototype.complete = function () {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(t, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var e = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[e](this);
        }
      }),
      (s.prototype = Object.create(e.prototype)),
      (s.prototype.check = function () {
        var t = this.getIsImageComplete();
        return t
          ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            void (this.proxyImage.src = this.img.src));
      }),
      (s.prototype.getIsImageComplete = function () {
        return this.img.complete && void 0 !== this.img.naturalWidth;
      }),
      (s.prototype.confirm = function (t, e) {
        (this.isLoaded = t), this.emitEvent("progress", [this, this.img, e]);
      }),
      (s.prototype.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (s.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (s.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (s.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (r.prototype = Object.create(s.prototype)),
      (r.prototype.check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url);
        var t = this.getIsImageComplete();
        t &&
          (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
          this.unbindEvents());
      }),
      (r.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (r.prototype.confirm = function (t, e) {
        (this.isLoaded = t),
          this.emitEvent("progress", [this, this.element, e]);
      }),
      (o.makeJQueryPlugin = function (e) {
        (e = e || t.jQuery),
          e &&
            ((a = e),
            (a.fn.imagesLoaded = function (t, e) {
              var i = new o(this, t, e);
              return i.jqDeferred.promise(a(this));
            }));
      }),
      o.makeJQueryPlugin(),
      o
    );
  }),
  !(function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t.Vimeo = t.Vimeo || {}), (t.Vimeo.Player = e()));
  })(this, function () {
    "use strict";
    function t(t, e) {
      return (e = { exports: {} }), t(e, e.exports), e.exports;
    }
    function e(t, e, i) {
      var n = x.get(t.element) || {};
      e in n || (n[e] = []), n[e].push(i), x.set(t.element, n);
    }
    function i(t, e) {
      var i = x.get(t.element) || {};
      return i[e] || [];
    }
    function n(t, e, i) {
      var n = x.get(t.element) || {};
      if (!n[e]) return !0;
      if (!i) return (n[e] = []), x.set(t.element, n), !0;
      var o = n[e].indexOf(i);
      return (
        -1 !== o && n[e].splice(o, 1),
        x.set(t.element, n),
        n[e] && 0 === n[e].length
      );
    }
    function o(t, e) {
      var o = i(t, e);
      if (o.length < 1) return !1;
      var s = o.shift();
      return n(t, e, s), s;
    }
    function s(t, e) {
      var i = x.get(t);
      x.set(e, i), x["delete"](t);
    }
    function r(t, e) {
      return 0 === t.indexOf(e.toLowerCase())
        ? t
        : "" + e.toLowerCase() + t.substr(0, 1).toUpperCase() + t.substr(1);
    }
    function a(t) {
      return t instanceof window.HTMLElement;
    }
    function l(t) {
      return !isNaN(parseFloat(t)) && isFinite(t) && Math.floor(t) == t;
    }
    function c(t) {
      return /^(https?:)?\/\/((player|www).)?vimeo.com(?=$|\/)/.test(t);
    }
    function u() {
      var t =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        e = t.id,
        i = t.url,
        n = e || i;
      if (!n)
        throw new Error(
          "An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute."
        );
      if (l(n)) return "https://vimeo.com/" + n;
      if (c(n)) return n.replace("http:", "https:");
      if (e) throw new TypeError("“" + e + "” is not a valid video id.");
      throw new TypeError("“" + n + "” is not a vimeo.com url.");
    }
    function h(t) {
      var e =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return T.reduce(function (e, i) {
        var n = t.getAttribute("data-vimeo-" + i);
        return (n || "" === n) && (e[i] = "" === n ? 1 : n), e;
      }, e);
    }
    function p(t) {
      var e =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return new Promise(function (i, n) {
        if (!c(t)) throw new TypeError("“" + t + "” is not a vimeo.com url.");
        var o =
          "https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(t);
        for (var s in e)
          e.hasOwnProperty(s) &&
            (o += "&" + s + "=" + encodeURIComponent(e[s]));
        var r =
          "XDomainRequest" in window
            ? new XDomainRequest()
            : new XMLHttpRequest();
        r.open("GET", o, !0),
          (r.onload = function () {
            if (404 === r.status)
              return void n(new Error("“" + e + "” was not found."));
            if (403 === r.status)
              return void n(new Error("“" + e + "” is not embeddable."));
            try {
              var t = JSON.parse(r.responseText);
              i(t);
            } catch (e) {
              n(e);
            }
          }),
          (r.onerror = function () {
            var t = r.status ? " (" + r.status + ")" : "";
            n(
              new Error(
                "There was an error fetching the embed code from Vimeo" +
                  t +
                  "."
              )
            );
          }),
          r.send();
      });
    }
    function d(t, e) {
      var i = t.html;
      if (!e) throw new TypeError("An element must be provided");
      if (null !== e.getAttribute("data-vimeo-initialized"))
        return e.querySelector("iframe");
      var n = document.createElement("div");
      return (
        (n.innerHTML = i),
        e.appendChild(n.firstChild),
        e.setAttribute("data-vimeo-initialized", "true"),
        e.querySelector("iframe")
      );
    }
    function f() {
      var t =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : document,
        e = [].slice.call(
          t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")
        ),
        i = function (t) {
          "console" in window &&
            console.error &&
            console.error("There was an error creating an embed: " + t);
        };
      e.forEach(function (t) {
        try {
          if (null !== t.getAttribute("data-vimeo-defer")) return;
          var e = h(t),
            n = u(e);
          p(n, e)
            .then(function (e) {
              return d(e, t);
            })
            ["catch"](i);
        } catch (t) {
          i(t);
        }
      });
    }
    function m(t) {
      return "string" == typeof t && (t = JSON.parse(t)), t;
    }
    function g(t, e, i) {
      if (t.element.contentWindow && t.element.contentWindow.postMessage) {
        var n = { method: e };
        void 0 !== i && (n.value = i);
        var o = parseFloat(
          navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1")
        );
        o >= 8 && 10 > o && (n = JSON.stringify(n)),
          t.element.contentWindow.postMessage(n, t.origin);
      }
    }
    function v(t, e) {
      e = m(e);
      var s = [],
        r = void 0;
      if (e.event) {
        if ("error" === e.event) {
          var a = i(t, e.data.method);
          a.forEach(function (i) {
            var o = new Error(e.data.message);
            (o.name = e.data.name), i.reject(o), n(t, e.data.method, i);
          });
        }
        (s = i(t, "event:" + e.event)), (r = e.data);
      } else if (e.method) {
        var l = o(t, e.method);
        l && (s.push(l), (r = e.value));
      }
      s.forEach(function (t) {
        try {
          if ("function" == typeof t) return void t.call(e, r);
          t.resolve(r);
        } catch (e) {}
      });
    }
    function y(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    var k = "undefined" != typeof Array.prototype.indexOf,
      w = "undefined" != typeof window.postMessage;
    if (!k || !w)
      throw new Error(
        "Sorry, the Vimeo Player API is not available in this browser."
      );
    var b =
        "undefined" != typeof window
          ? window
          : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
          ? self
          : {},
      S =
        (t(function (t, e) {
          !(function (t) {
            function e(t, e) {
              function n(t) {
                return this && this.constructor === n
                  ? ((this._keys = []),
                    (this._values = []),
                    (this._itp = []),
                    (this.objectOnly = e),
                    void (t && i.call(this, t)))
                  : new n(t);
              }
              return (
                e || k(t, "size", { get: g }),
                (t.constructor = n),
                (n.prototype = t),
                n
              );
            }
            function i(t) {
              this.add
                ? t.forEach(this.add, this)
                : t.forEach(function (t) {
                    this.set(t[0], t[1]);
                  }, this);
            }
            function n(t) {
              return (
                this.has(t) &&
                  (this._keys.splice(y, 1),
                  this._values.splice(y, 1),
                  this._itp.forEach(function (t) {
                    y < t[0] && t[0]--;
                  })),
                y > -1
              );
            }
            function o(t) {
              return this.has(t) ? this._values[y] : void 0;
            }
            function s(t, e) {
              if (this.objectOnly && e !== Object(e))
                throw new TypeError(
                  "Invalid value used as weak collection key"
                );
              if (e != e || 0 === e) for (y = t.length; y-- && !w(t[y], e); );
              else y = t.indexOf(e);
              return y > -1;
            }
            function r(t) {
              return s.call(this, this._values, t);
            }
            function a(t) {
              return s.call(this, this._keys, t);
            }
            function l(t, e) {
              return (
                this.has(t)
                  ? (this._values[y] = e)
                  : (this._values[this._keys.push(t) - 1] = e),
                this
              );
            }
            function c(t) {
              return this.has(t) || this._values.push(t), this;
            }
            function u() {
              (this._keys || 0).length = this._values.length = 0;
            }
            function h() {
              return m(this._itp, this._keys);
            }
            function p() {
              return m(this._itp, this._values);
            }
            function d() {
              return m(this._itp, this._keys, this._values);
            }
            function f() {
              return m(this._itp, this._values, this._values);
            }
            function m(t, e, i) {
              var n = [0],
                o = !1;
              return (
                t.push(n),
                {
                  next: function () {
                    var s,
                      r = n[0];
                    return (
                      !o && r < e.length
                        ? ((s = i ? [e[r], i[r]] : e[r]), n[0]++)
                        : ((o = !0), t.splice(t.indexOf(n), 1)),
                      { done: o, value: s }
                    );
                  },
                }
              );
            }
            function g() {
              return this._values.length;
            }
            function v(t, e) {
              for (var i = this.entries(); ; ) {
                var n = i.next();
                if (n.done) break;
                t.call(e, n.value[1], n.value[0], this);
              }
            }
            var y,
              k = Object.defineProperty,
              w = function (t, e) {
                return t === e || (t !== t && e !== e);
              };
            "undefined" == typeof WeakMap &&
              (t.WeakMap = e(
                { delete: n, clear: u, get: o, has: a, set: l },
                !0
              )),
              ("undefined" != typeof Map &&
                "function" == typeof new Map().values &&
                new Map().values().next) ||
                (t.Map = e({
                  delete: n,
                  has: a,
                  get: o,
                  set: l,
                  keys: h,
                  values: p,
                  entries: d,
                  forEach: v,
                  clear: u,
                })),
              ("undefined" != typeof Set &&
                "function" == typeof new Set().values &&
                new Set().values().next) ||
                (t.Set = e({
                  has: r,
                  add: c,
                  delete: n,
                  clear: u,
                  keys: p,
                  values: p,
                  entries: f,
                  forEach: v,
                })),
              "undefined" == typeof WeakSet &&
                (t.WeakSet = e({ delete: n, add: c, clear: u, has: r }, !0));
          })("undefined" != typeof b ? b : window);
        }),
        t(function (t) {
          var e =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                };
          !(function (e, i, n) {
            (i[e] = i[e] || n()), t.exports && (t.exports = i[e]);
          })("Promise", "undefined" != typeof b ? b : b, function () {
            function t(t, e) {
              d.add(t, e), p || (p = m(d.drain));
            }
            function i(t) {
              var i,
                n = "undefined" == typeof t ? "undefined" : e(t);
              return (
                null == t || ("object" != n && "function" != n) || (i = t.then),
                "function" == typeof i && i
              );
            }
            function n() {
              for (var t = 0; t < this.chain.length; t++)
                o(
                  this,
                  1 === this.state
                    ? this.chain[t].success
                    : this.chain[t].failure,
                  this.chain[t]
                );
              this.chain.length = 0;
            }
            function o(t, e, n) {
              var o, s;
              try {
                e === !1
                  ? n.reject(t.msg)
                  : ((o = e === !0 ? t.msg : e.call(void 0, t.msg)),
                    o === n.promise
                      ? n.reject(TypeError("Promise-chain cycle"))
                      : (s = i(o))
                      ? s.call(o, n.resolve, n.reject)
                      : n.resolve(o));
              } catch (t) {
                n.reject(t);
              }
            }
            function s(t) {
              var e,
                o = this;
              if (!o.triggered) {
                (o.triggered = !0), o.def && (o = o.def);
                try {
                  (e = i(t))
                    ? a(function () {
                        var t = new l(o);
                        try {
                          e.call(
                            i,
                            function () {
                              s.apply(t, arguments);
                            },
                            function () {
                              r.apply(t, arguments);
                            }
                          );
                        } catch (i) {
                          r.call(t, i);
                        }
                      })
                    : ((o.msg = t),
                      (o.state = 1),
                      o.chain.length > 0 && a(n, o));
                } catch (a) {
                  r.call(new l(o), a);
                }
              }
            }
            function r(e) {
              var i = this;
              i.triggered ||
                ((i.triggered = !0),
                i.def && (i = i.def),
                (i.msg = e),
                (i.state = 2),
                i.chain.length > 0 && t(n, i));
            }
            function a(t, e, i, n) {
              for (var o = 0; o < e.length; o++)
                !(function (o) {
                  t.resolve(e[o]).then(function (t) {
                    i(o, t);
                  }, n);
                })(o);
            }
            function l(t) {
              (this.def = t), (this.triggered = !1);
            }
            function c(t) {
              (this.promise = t),
                (this.state = 0),
                (this.triggered = !1),
                (this.chain = []),
                (this.msg = void 0);
            }
            function u(t) {
              if ("function" != typeof t) throw TypeError("Not a function");
              if (0 !== this.__NPO__) throw TypeError("Not a promise");
              this.__NPO__ = 1;
              var e = new c(this);
              (this.then = function (t, o) {
                var s = {
                  success: "function" != typeof t || t,
                  failure: "function" == typeof o && o,
                };
                return (
                  (s.promise = new this.constructor(function (t, e) {
                    if ("function" != typeof t || "function" != typeof e)
                      throw TypeError("Not a function");
                    (s.resolve = t), (s.reject = e);
                  })),
                  e.chain.push(s),
                  0 !== e.state && i(n, e),
                  s.promise
                );
              }),
                (this["catch"] = function (t) {
                  return this.then(void 0, t);
                });
              try {
                t.call(
                  void 0,
                  function (t) {
                    s.call(e, t);
                  },
                  function (t) {
                    r.call(e, t);
                  }
                );
              } catch (i) {
                r.call(e, i);
              }
            }
            var h,
              p,
              d,
              f = Object.prototype.toString,
              m =
                "undefined" != typeof setImmediate
                  ? function (t) {
                      return setImmediate(t);
                    }
                  : setTimeout;
            try {
              Object.defineProperty({}, "x", {}),
                (h = function (t, e, i, n) {
                  return Object.defineProperty(t, e, {
                    value: i,
                    writable: !0,
                    configurable: n !== !1,
                  });
                });
            } catch (t) {
              h = function (t, e, i) {
                return (t[e] = i), t;
              };
            }
            d = (function () {
              function t(t, e) {
                (this.fn = t), (this.self = e), (this.next = void 0);
              }
              var e, i, n;
              return {
                add: function (o, s) {
                  (n = new t(o, s)),
                    i ? (i.next = n) : (e = n),
                    (i = n),
                    (n = void 0);
                },
                drain: function () {
                  var t = e;
                  for (e = i = p = void 0; t; ) t.fn.call(t.self), (t = t.next);
                },
              };
            })();
            var g = h({}, "constructor", u, !1);
            return (
              (u.prototype = g),
              h(g, "__NPO__", 0, !1),
              h(u, "resolve", function (t) {
                var i = this;
                return t &&
                  "object" == ("undefined" == typeof t ? "undefined" : e(t)) &&
                  1 === t.__NPO__
                  ? t
                  : new i(function (e, i) {
                      if ("function" != typeof e || "function" != typeof i)
                        throw TypeError("Not a function");
                      e(t);
                    });
              }),
              h(u, "reject", function (t) {
                return new this(function (e, i) {
                  if ("function" != typeof e || "function" != typeof i)
                    throw TypeError("Not a function");
                  i(t);
                });
              }),
              h(u, "all", function (t) {
                var e = this;
                return "[object Array]" != f.call(t)
                  ? e.reject(TypeError("Not an array"))
                  : 0 === t.length
                  ? e.resolve([])
                  : new e(function (i, n) {
                      if ("function" != typeof i || "function" != typeof n)
                        throw TypeError("Not a function");
                      var o = t.length,
                        s = Array(o),
                        r = 0;
                      a(
                        e,
                        t,
                        function (t, e) {
                          (s[t] = e), ++r === o && i(s);
                        },
                        n
                      );
                    });
              }),
              h(u, "race", function (t) {
                var e = this;
                return "[object Array]" != f.call(t)
                  ? e.reject(TypeError("Not an array"))
                  : new e(function (i, n) {
                      if ("function" != typeof i || "function" != typeof n)
                        throw TypeError("Not a function");
                      a(
                        e,
                        t,
                        function (t, e) {
                          i(e);
                        },
                        n
                      );
                    });
              }),
              u
            );
          });
        })),
      x = new WeakMap(),
      T = [
        "id",
        "url",
        "width",
        "maxwidth",
        "height",
        "maxheight",
        "portrait",
        "title",
        "byline",
        "color",
        "autoplay",
        "autopause",
        "loop",
        "responsive",
      ],
      E = (function () {
        function t(t, e) {
          for (var i = 0; i < e.length; i++) {
            var n = e[i];
            (n.enumerable = n.enumerable || !1),
              (n.configurable = !0),
              "value" in n && (n.writable = !0),
              Object.defineProperty(t, n.key, n);
          }
        }
        return function (e, i, n) {
          return i && t(e.prototype, i), n && t(e, n), e;
        };
      })(),
      C = new WeakMap(),
      $ = new WeakMap(),
      _ = (function () {
        function t(e) {
          var i = this,
            n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
          if (
            (y(this, t),
            window.jQuery &&
              e instanceof jQuery &&
              (e.length > 1 &&
                window.console &&
                console.warn &&
                console.warn(
                  "A jQuery object with multiple elements was passed, using the first element."
                ),
              (e = e[0])),
            "string" == typeof e && (e = document.getElementById(e)),
            !a(e))
          )
            throw new TypeError(
              "You must pass either a valid element or a valid id."
            );
          if ("IFRAME" !== e.nodeName) {
            var o = e.querySelector("iframe");
            o && (e = o);
          }
          if ("IFRAME" === e.nodeName && !c(e.getAttribute("src") || ""))
            throw new Error("The player element passed isn’t a Vimeo embed.");
          if (C.has(e)) return C.get(e);
          (this.element = e), (this.origin = "*");
          var r = new S(function (t, o) {
            var r = function (e) {
              if (c(e.origin) && i.element.contentWindow === e.source) {
                "*" === i.origin && (i.origin = e.origin);
                var n = m(e.data),
                  o = "event" in n && "ready" === n.event,
                  s = "method" in n && "ping" === n.method;
                return o || s
                  ? (i.element.setAttribute("data-ready", "true"), void t())
                  : void v(i, n);
              }
            };
            if (
              (window.addEventListener
                ? window.addEventListener("message", r, !1)
                : window.attachEvent && window.attachEvent("onmessage", r),
              "IFRAME" !== i.element.nodeName)
            ) {
              var a = h(e, n),
                l = u(a);
              p(l, a)
                .then(function (t) {
                  var n = d(t, e);
                  return (i.element = n), s(e, n), C.set(i.element, i), t;
                })
                ["catch"](function (t) {
                  return o(t);
                });
            }
          });
          return (
            $.set(this, r),
            C.set(this.element, this),
            "IFRAME" === this.element.nodeName && g(this, "ping"),
            this
          );
        }
        return (
          E(t, [
            {
              key: "callMethod",
              value: function (t) {
                var i = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                return new S(function (o, s) {
                  return i.ready().then(function () {
                    e(i, t, { resolve: o, reject: s }), g(i, t, n);
                  });
                });
              },
            },
            {
              key: "get",
              value: function (t) {
                var i = this;
                return new S(function (n, o) {
                  return (
                    (t = r(t, "get")),
                    i.ready().then(function () {
                      e(i, t, { resolve: n, reject: o }), g(i, t);
                    })
                  );
                });
              },
            },
            {
              key: "set",
              value: function (t, i) {
                var n = this;
                return S.resolve(i).then(function (i) {
                  if (((t = r(t, "set")), void 0 === i || null === i))
                    throw new TypeError("There must be a value to set.");
                  return n.ready().then(function () {
                    return new S(function (o, s) {
                      e(n, t, { resolve: o, reject: s }), g(n, t, i);
                    });
                  });
                });
              },
            },
            {
              key: "on",
              value: function (t, n) {
                if (!t) throw new TypeError("You must pass an event name.");
                if (!n)
                  throw new TypeError("You must pass a callback function.");
                if ("function" != typeof n)
                  throw new TypeError("The callback must be a function.");
                var o = i(this, "event:" + t);
                0 === o.length &&
                  this.callMethod("addEventListener", t)["catch"](
                    function () {}
                  ),
                  e(this, "event:" + t, n);
              },
            },
            {
              key: "off",
              value: function (t, e) {
                if (!t) throw new TypeError("You must pass an event name.");
                if (e && "function" != typeof e)
                  throw new TypeError("The callback must be a function.");
                var i = n(this, "event:" + t, e);
                i &&
                  this.callMethod("removeEventListener", t)["catch"](function (
                    t
                  ) {});
              },
            },
            {
              key: "loadVideo",
              value: function (t) {
                return this.callMethod("loadVideo", t);
              },
            },
            {
              key: "ready",
              value: function () {
                var t = $.get(this);
                return S.resolve(t);
              },
            },
            {
              key: "addCuePoint",
              value: function (t) {
                var e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
                return this.callMethod("addCuePoint", { time: t, data: e });
              },
            },
            {
              key: "removeCuePoint",
              value: function (t) {
                return this.callMethod("removeCuePoint", t);
              },
            },
            {
              key: "enableTextTrack",
              value: function (t, e) {
                if (!t) throw new TypeError("You must pass a language.");
                return this.callMethod("enableTextTrack", {
                  language: t,
                  kind: e,
                });
              },
            },
            {
              key: "disableTextTrack",
              value: function () {
                return this.callMethod("disableTextTrack");
              },
            },
            {
              key: "pause",
              value: function () {
                return this.callMethod("pause");
              },
            },
            {
              key: "play",
              value: function () {
                return this.callMethod("play");
              },
            },
            {
              key: "unload",
              value: function () {
                return this.callMethod("unload");
              },
            },
            {
              key: "getAutopause",
              value: function () {
                return this.get("autopause");
              },
            },
            {
              key: "setAutopause",
              value: function (t) {
                return this.set("autopause", t);
              },
            },
            {
              key: "getColor",
              value: function () {
                return this.get("color");
              },
            },
            {
              key: "setColor",
              value: function (t) {
                return this.set("color", t);
              },
            },
            {
              key: "getCuePoints",
              value: function () {
                return this.get("cuePoints");
              },
            },
            {
              key: "getCurrentTime",
              value: function () {
                return this.get("currentTime");
              },
            },
            {
              key: "setCurrentTime",
              value: function (t) {
                return this.set("currentTime", t);
              },
            },
            {
              key: "getDuration",
              value: function () {
                return this.get("duration");
              },
            },
            {
              key: "getEnded",
              value: function () {
                return this.get("ended");
              },
            },
            {
              key: "getLoop",
              value: function () {
                return this.get("loop");
              },
            },
            {
              key: "setLoop",
              value: function (t) {
                return this.set("loop", t);
              },
            },
            {
              key: "getPaused",
              value: function () {
                return this.get("paused");
              },
            },
            {
              key: "getTextTracks",
              value: function () {
                return this.get("textTracks");
              },
            },
            {
              key: "getVideoEmbedCode",
              value: function () {
                return this.get("videoEmbedCode");
              },
            },
            {
              key: "getVideoId",
              value: function () {
                return this.get("videoId");
              },
            },
            {
              key: "getVideoTitle",
              value: function () {
                return this.get("videoTitle");
              },
            },
            {
              key: "getVideoWidth",
              value: function () {
                return this.get("videoWidth");
              },
            },
            {
              key: "getVideoHeight",
              value: function () {
                return this.get("videoHeight");
              },
            },
            {
              key: "getVideoUrl",
              value: function () {
                return this.get("videoUrl");
              },
            },
            {
              key: "getVolume",
              value: function () {
                return this.get("volume");
              },
            },
            {
              key: "setVolume",
              value: function (t) {
                return this.set("volume", t);
              },
            },
          ]),
          t
        );
      })();
    return f(), _;
  }),
  "undefined" == typeof Shopify && (ShopifyAPI = {}),
  (Shopify.money_format = "${{amount}}"),
  (Shopify.formatMoney = function (t, e) {
    function i(t, e) {
      return "undefined" == typeof t ? e : t;
    }
    function n(t, e, n, o) {
      if (
        ((e = i(e, 2)), (n = i(n, ",")), (o = i(o, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(e);
      var s = t.split("."),
        r = s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n),
        a = s[1] ? o + s[1] : "";
      return r + a;
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var o = "",
      s = /\{\{\s*(\w+)\s*\}\}/,
      r = e || this.money_format;
    switch (r.match(s)[1]) {
      case "amount":
        o = n(t, 2);
        break;
      case "amount_no_decimals":
        o = n(t, 0);
        break;
      case "amount_with_comma_separator":
        o = n(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = n(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = n(t, 0, " ");
    }
    return r.replace(s, o);
  }),
  "undefined" == typeof ShopifyAPI && (ShopifyAPI = {}),
  (ShopifyAPI.onCartUpdate = function (t) {}),
  (ShopifyAPI.onError = function (t, e) {}),
  (ShopifyAPI.addItemFromForm = function (t, e, i) {
    const formData = jQuery(t).serializeArray();

    const properties = formData.reduce((properties, property) => {
      const { name, value } = property;

      console.log('addItemFromForm Propeties:', property);

      if (!/\[(.*?)\]/gi.test(name)) return properties;

      const exec = /\[(.*?)\]/gi.exec(name);

      properties[exec[1]] = value;

      return properties;
    }, {});

    const quantity = formData.reduce((qty, item) => {
      const { name, value } = item;

      if (name !== "quantity") return qty;

      return Number(value);
    }, 1);

    const addData = formData.reduce((items, property) => {
      const { name, value } = property;

      console.log("forming add data", { name, value, properties });

      if (name !== "id" || value === "_none") return items;

      const item = {
        id: Number(value),
        quantity,
        properties,
      };

      items.push(item);

      return items;
    }, []);
    
    console.log(
      "Item Added from form here",
      { quantity },
      jQuery(t).serialize(),
      jQuery(t).serializeArray(),
      { addData },
      properties,
      { t, e, i }
    );

    var n = $(document.body),
      o = {
        type: "POST",
        url: "/cart/add.js",
        data: {
          items: addData,
        },
        dataType: "json",
        beforeSend: function (e, i) {
          n.trigger("beforeAddItem.ajaxCart", t);
        },
        success: function (i) {
          console.log("Success", { i });

          document.dispatchEvent(new CustomEvent("cart:open"));

          setTimeout(function () {
            $("#ajax-trigger").click();
          }, 500);

          "function" == typeof e ? e(i, t) : ShopifyAPI.onItemAdded(i, t),
            n.trigger("afterAddItem.ajaxCart", [i, t]);
        },
        error: function (t, e) {
          console.log("Error", { t, e });

          "function" == typeof i ? i(t, e) : ShopifyAPI.onError(t, e),
            n.trigger("errorAddItem.ajaxCart", [t, e]);
        },
        complete: function (t, e) {
          n.trigger("completeAddItem.ajaxCart", [this, t, e]);
        },
      };
    jQuery.ajax(o);
  }),
  (ShopifyAPI.getCart = function (t) {
    $(document.body).trigger("beforeGetCart.ajaxCart"),
      jQuery.getJSON("/cart.js", function (e, i) {
        "function" == typeof t ? t(e) : ShopifyAPI.onCartUpdate(e),
          $(document.body).trigger("afterGetCart.ajaxCart", e);
      });
  }),
  (ShopifyAPI.changeItem = function (t, e, i) {
    var n = $(document.body),
      o = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + e + "&line=" + t,
        dataType: "json",
        beforeSend: function () {
          n.trigger("beforeChangeItem.ajaxCart", [t, e]);
        },
        success: function (o) {
          "function" == typeof i ? i(o) : ShopifyAPI.onCartUpdate(o),
            n.trigger("afterChangeItem.ajaxCart", [t, e, o]);
        },
        error: function (t, e) {
          n.trigger("errorChangeItem.ajaxCart", [t, e]),
            ShopifyAPI.onError(t, e);
        },
        complete: function (t, e) {
          n.trigger("completeChangeItem.ajaxCart", [this, t, e]);
        },
      };
    jQuery.ajax(o);
  });
